import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { TextField, Button, Box, Paper } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from './index.styles';
import Boxlayout from './box-layout';
import LabelTemplate from './labelTemplate';
import randomized from 'randomatic';
import assignmentstatus from './assignment-status';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DialogContentText from '@mui/material/DialogContentText';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchableSelect from '../common/SearchableSelect';
import { toast } from 'react-toastify';
import FormHelperText from '@mui/material/FormHelperText';
import PlayArrow from '@mui/icons-material/PlayArrow';
import PrintTemplate from 'react-print';
import EVENT_TYPES from '../common/event-type';
import EVENT_CRUD_TYPES from '../common/event-crud-types';
import EventLogHandler from '../common/event-log-handler';
import DemoData from '../common/demo-data';
import { getFlagsForA33Item } from '../shared/dummyPrescriptionFlags';
import { fetchAccountSignatureFlagCodes } from './counter/services/SignatureFlagsService';
import CONNECTION_TYPE from '../common/connection-type';
import { navigate } from '@reach/router';
import spinner from './images/spinner.gif';
import checked from './images/checked.png';
import cl from './images/cl.gif';
import HomeIcon from '@mui/icons-material/Home';
import WorkIcon from '@mui/icons-material/Work';
import OtherIcon from '@mui/icons-material/DevicesOther';
import LOCATION_TYPE from '../enum/location_type';
import DEVICE_TYPE from '../enum/device_type';
import Manualconsultation from './Manual-consultation';
import InputAdornment from '@mui/material/InputAdornment';
import MagnifyIcon from '@mui/icons-material/Search';
import curbsideIcon from '../iLocal-Delivery-Icons/Curbside.svg';
import inpatientIcon from '../iLocal-Delivery-Icons/Bedside.svg';
import courierIcon from '../iLocal-Delivery-Icons/Courier.svg';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import NumberFormat from 'react-number-format';
import BOX_TYPE from '../enum/box_type';
import io from 'socket.io-client';
import TablePagination from '@mui/material/TablePagination';
import PatientManulOverride from '../common/patient_manual_override';
import CounterAssignUI from './counter';
import DeliveryTypeTabs from './DeliveryTypeTabs';
import './index.css';
import { withTranslation } from 'react-i18next';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import CloseIcon from '@mui/icons-material/Close';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PhoneInput from '../common/PhoneInput';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import userroles from '../common/userroles';
import { writeAuditLog } from '../common/apis';
import { AddCircleOutlineRounded, RemoveCircleOutlineRounded, Info as InfoIcon } from '@mui/icons-material';
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";

const rxData = require('./assets/rxData').default;

const localeTheme = createTheme(
  {},
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR
);

let searchedRxItems = [];
let searchedRxNumbers = [];
let nums = Array.from(Array(5).keys());
let nums1 = Array.from(Array(12).keys());
let elem = ['A', 'B', 'C', 'D', 'E'];
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
let rxMaxLength = null;
const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix='$'
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={'.'}
      fixedDecimalScale={true}
    />
  );
});

NumberFormatCustom.propTypes = {
  onChange: PropTypes.func.isRequired,
};

class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props &&
      this.props.onRequestSort &&
      this.props.onRequestSort(event, property);
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      isVisibleForPause,
      className,
      t,
    } = this.props;
    const rows = [
      {
        id: 'rxNo',
        numeric: false,
        disablePadding: true,
        label: t('Assign.PrescriptionID'),
      },
      {
        id: 'fillNumber',
        numeric: false,
        disablePadding: true,
        label: t('Assign.FillID'),
      },
      {
        id: 'PrescriptionNumber',
        numeric: false,
        disablePadding: true,
        label: t('Assign.PrescriptionNumber'),
      },
      {
        id: 'OrderId',
        numeric: false,
        disablePadding: true,
        label: t('Assign.OrderID'),
      },
      {
        id: 'TranactionId',
        numeric: false,
        disablePadding: true,
        label: sessionStorage.getItem('accountConnectionId') === CONNECTION_TYPE.QS1 ? t('Assign.SequnceNo') : t('Assign.TransactionID'),
      },
      {
        id: 'name',
        numeric: false,
        disablePadding: true,
        label: t('Assign.DrugName'),
      },
      {
        id: 'ndcCode',
        numeric: false,
        disablePadding: true,
        label: t('Assign.NDCCode'),
      },
      {
        id: 'qty',
        numeric: false,
        disablePadding: true,
        label: t('Assign.Qty'),
      },
      {
        id: 'AmountDue',
        numeric: false,
        disablePadding: true,
        label: t('Assign.AmountDue'),
      },
      {
        id: 'consultrequire',
        numeric: false,
        disablePadding: true,
        label: t('Assign.ConsultRequired'),
      },
      {
        id: 'isreturnable',
        numeric: false,
        disablePadding: true,
        label: t('Assign.IsReturnable'),
      },
    ];

    return (
      <TableHead>
        <TableRow style={{ height: '56px' }}>
          {!isVisibleForPause && (
            <TableCell padding={'none'}>
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
                style={{ color: '#4fc3f7' }}
              />
            </TableCell>
          )}
          {rows.map((row, index) => {
            const isFirst = index === 0;
            const isLast = index === rows.length - 1;
            const countLabel = rowCount != null ? ` (${rowCount})` : '';
            const labelWithCount = rowCount != null ? `${row.label}${countLabel}` : row.label;
            return (
              <TableCell
                key={row.id}
                align={row.numeric ? 'right' : 'left'}
                padding={row.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === row.id ? order : false}
                className={className}
                style={{
                  ...(row.label === 'Amount Due'
                    ? { width: '300px' }
                    : { width: '150px' }),
                }}
              >
                <Tooltip
                  title={t('Global.Label.Filter.Sort')}
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {(isFirst || isLast) ? labelWithCount : row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  className: PropTypes.string,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    backgroundColor: theme.palette.secondary.main,
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#4ff7c1',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
  deletePrimaryButton: {
    background: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    /* add,  deleteUsers, editUser, viewUser, */ confirmDelete,
    t,
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color='inherit' variant='subheading'>
            {numSelected} {t('Assign.SelectedRow')}
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected === 1 && (
          <div>
            <Tooltip key='single-delete' title={t('Assign.DeleteTooltip')}>
              <IconButton
                aria-label='Delete'
                onClick={confirmDelete}
                className={classes.deletePrimaryButton}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
        {numSelected > 1 && (
          <Tooltip key='multi-delete' title={t('Assign.DeleteTooltip')}>
            <IconButton
              aria-label='Delete'
              onClick={confirmDelete}
              className={classes.deletePrimaryButton}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const legend = [
  { color: "linear-gradient(155deg, rgb(212,209,0) 0%, rgb(255,255,189) 90%)", label: "Assigned" },
  { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(4, 144, 243) 90%)", label: "Hold" },
  { color: "linear-gradient(155deg, rgb(23,166,0) 0%, rgb(196,255,189) 90%)", label: "Stocked" },
  { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)", label: "Deactivate" },
  { color: "linear-gradient(155deg, rgb(106, 13, 173) 0%, rgb(186, 145, 214) 90%)", label: "Locked" },
];

// Helper function to get location type name from ID
const getLocationTypeName = (locationTypeId) => {
  const locationTypeMap = {
    [LOCATION_TYPE.Kiosk]: 'Kiosk',
    [LOCATION_TYPE.Home]: 'Home',
    [LOCATION_TYPE.Work]: 'Work',
    [LOCATION_TYPE.Courier]: 'Courier',
    [LOCATION_TYPE.Curbside]: 'Curbside',
    [LOCATION_TYPE.Bedside]: 'Bedside',
    [LOCATION_TYPE.Counter]: 'Counter',
    [LOCATION_TYPE.Other]: 'Other',
    [LOCATION_TYPE.Mail_Order]: 'Mail Order'
  };
  return locationTypeMap[locationTypeId] || 'Unknown';
};

const determineConsultRequire = (
  apiConsultValue,
  isControlledSubstance,
  locationTypeId,
  bypassConsult = false
) => {
  // Case 0: Account has bypass_consult enabled – always treat as NOT requiring consult
  if (bypassConsult === true || bypassConsult === "true") {
    return false;
  }

  // Case 1: API already has consult as true - use that value
  if (apiConsultValue === true || apiConsultValue === "true") {
    return true;
  }

  // Case 2: Counter location + controlled substance = true → set consult to true
  if (
    locationTypeId === LOCATION_TYPE.Counter &&
    (isControlledSubstance === true || isControlledSubstance === "true")
  ) {
    return true;
  }

  // Cases 3 & 4: Default to false
  return false;
};

export class AssignPrescriptions extends Component {
  constructor(props) {
    super(props);
    // Initialize module-level variables (ClearFields cannot be called here as state is not yet initialized)
    searchedRxItems = [];
    searchedRxNumbers = [];
    this.state = {
      rxDetails: rxData,
      selectedBinId: '',
      openMessage: false,
      disableFeild: false,
      stockCode: '',
      pickupCode: '',
      searchedRxNo: [],
      prescriptionMasterData: {},
      rxNumber: '',
      selected: [],
      box: [],
      hasError: false,
      box_id: localStorage.getItem('selectedLocation'),
      currentBoxData: null,
      pharmacyDetails: {},
      accountDetails: {},
      accountSignatureFlagCodes: [],
      BinStatus: [],
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      loader: false,
      expansionUnits: [],
      box_expansions_id: '',
      isLoadingTrans: false,
      isADACompatible: false,
      ConsultRequire: false,
      is_returnable: false,
      isAmountPaid: false,
      locationtype_id: localStorage.getItem('selectedLocationTypeId'),
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: '',
      EmailID: '',
      phone: '',
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      AccountConnections: [],
      location: '',
      isUnplugged: false,
      accountConnectionsLoginId: sessionStorage.getItem('accountConnectionId') || '',
      boxDetails: [],
      boxItems: [],
      allBoxes: [],
      globalAccountConnection: {},
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      storage_location: '',
      location_notes: '',
      searchedItems: [],
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      orderIds: [],
      prescriptionIds: [],
      isEdit: false,
      indexNo: null,
      binid: null,
      pmid: null,
      page: 0,
      rowsPerPage: 10,
      isManualOverrideOpen: false,
      printDialogOpen: false,
      printLoading: false,
      selectedObject: [],
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedAccountIdForPrescriptionCheck: null,
      doesPrescriptionScanned: false,
      selectedPMSType: "",
      confirmPMSDialogOpen: false,
      scannedRxScript: "",
      originalScannedScript: "",
      boxTypeId: '',
      allow_multi_bins_pickup: false,
      FutureRelease: false,
      showDatePopup: false,
      FutureReleaseDate: null,
      selectedBox: '',
      address: null,
      patientNotes: '',
      readOnly: true,
      isBinDeactivated: false,
      alternateAgents: [],
      makeFastlaneAPICall: false,
      is_controlled_substance: false,
      servePresFetchCount: 0,
      servePresRetryCount: 3, // Max 3 times retrieval
      isRetrying: false,
      doesBinClicked: false,
      confirmPhantomRemoval: false,
      isPhantomStockCodePrompt: false,
      isManualOverridePermissionEnabled: true,
      prescriptionUnAssign: true,
      prescriptionAssign: true,
      prescriptionView: true,
      prescriptionDirectPickup: true,
      prescriptionRemind: true,
      prescriptionConsult: true,
      prescriptionHoldResume: true,
      prescriptionAcDc: true,
      assign_order_notes: '',
      show_order_notes_dialog: false,
      selectionType: 0,
      consultWaiveDialogOpen: false,
      consultWaiveIndex: null,
      consultWaiveReason: '',
      consultCheckBoxFlagForRxByBin: false,
      rxEntries: [
        { rxNumber: '', isConsultRequired: false }
      ],
      isRxView: false,
      phoneError: false,
      dobError: false,
      printTicketPermissionAllowed: false,
      htmlBodyToPrint: '',
      openPrintDialog: false,
      fastlaneBinRetryCount: 0,
      fastlaneBinMaxRetries: 3,
      isFastlaneRetrying: false,
      fastlaneRetryMessage: '',
      fastlaneBinFetchError: false,
      fastlaneBinValidationError: false,
      pendingSaveMode: null,
      fastlaneBinId: '',
      isFastlaneCollisionResolving: false,
      fastlaneCollisionDialogOpen: false,
      fastlaneCollisionNextBinId: '',
      selectedAssignmentLocation: null,
      selectedAssignmentBoxId: null,
      selectedAssignmentBinId: null,
      selectedAssignmentBoxTypeId: null,
      isBinLocked: false,
      isOpenPath: false,
    };
    this.textInput = React.createRef();

    this.phoneInputRef = React.createRef();
  }

  shouldShowBasicUI = () => {
    const { selectedBox, currentBoxData, locationtype_id, accountDetails, accountConnectionsLoginId } = this.state;
    
    if (accountConnectionsLoginId === CONNECTION_TYPE.BASIC) {
      if (!locationtype_id) {
        return true;
      }
      return locationtype_id === LOCATION_TYPE.Kiosk;
    }
    
    const boxData = currentBoxData || selectedBox;
    
    if (!boxData) {
      return false;
    }
    
    if (locationtype_id !== LOCATION_TYPE.Kiosk) {
      return false;
    }
    
    if (boxData.parent_account_id && accountDetails && accountDetails.id === boxData.parent_account_id) {
      if (accountDetails.connection && accountDetails.connection.id === CONNECTION_TYPE.BASIC) {
        return true;
      }
    }
    
    return false;
  }

  validateEmail = (value = "") => {
    const trimmed = (value || "").trim();
    if (!trimmed) {
      return true;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(trimmed);
  };

  getEmailError = (value = "") => {
    const trimmed = (value || "").trim();
    if (!trimmed) {
      return "";
    }
    return this.validateEmail(trimmed) ? "" : "Enter a valid email address.";
  };

  formatUSPhoneNumber = (value = "") => {
    const digits = (value || "").replace(/\D/g, "").slice(0, 10);
    if (digits.length === 0) {
      return "";
    }
    if (digits.length < 4) {
      return digits;
    }
    if (digits.length < 7) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    }
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  getPhoneError = (value = "") => {
    const digits = (value || "").replace(/\D/g, "");
    if (!digits) {
      return "";
    }
    return digits.length === 10 ? "" : "Enter a valid 10-digit phone number.";
  };

  handlePatientEmailChange = (value = "") => {
    const sanitizedValue = (value || "").replace(/\s/g, "");
    this.setState({ EmailID: sanitizedValue });
  };

  handlePatientPhoneChange = (value = "") => {
    const formatted = this.formatUSPhoneNumber(value);
    this.setState({ phone: formatted });
  };

  getAssignSelectedLocationsByType = () => {
    try {
      const raw = localStorage.getItem('assignSelectedLocationsByType');
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  };

  getStoredLocationForType = (locationTypeId) => {
    if (!locationTypeId) {
      return null;
    }

    const locationsByType = this.getAssignSelectedLocationsByType();
    return locationsByType[locationTypeId] || null;
  };

  setStoredLocationForType = (locationTypeId, location) => {
    if (!locationTypeId || !location || !location.id) {
      return;
    }

    const locationsByType = this.getAssignSelectedLocationsByType();
    locationsByType[locationTypeId] = {
      id: location.id,
      name: location.name || location.value || '',
    };
    localStorage.setItem('assignSelectedLocationsByType', JSON.stringify(locationsByType));
  };

  initSocket = async (authToken) => {
    if (!this.socket && this.user) {
      /**
       ** Socket Initialization **
       */

      this.socket = io(
        `${process.env.REACT_APP_VIDEO_SOCKET_BASEURL}/console-socket`,
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          },
          secure: true,
        }
      );

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });
      this.socket &&
        this.socket.on('connect_error', (error) => {
          console.log('Connect Error: ', error);
          if (
            error.message === 'TokenExpiredError' ||
            error.message === 'JsonWebTokenError' ||
            error.message === 'NoTokenFound'
          ) {
            console.log('Token issue!');
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });
    }
  };

  componentWillUnmount() {
    this.socket && this.socket.disconnect();
    this.socket = false;
  }

  async componentDidMount() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    !this.socket && (await this.initSocket());
    this.handleFocus();
    this.setPermission();
    if (this.phoneInputRef.current) {
      this.phoneInputRef.current.focus();
    }
    // Log initial location type from localStorage
    const initialLocationType = localStorage.getItem('selectedLocationTypeId');
    const initialLocationName = localStorage.getItem('selected_location_name') || 'Not Set';
    const initialLocationTypeName = getLocationTypeName(initialLocationType);
    console.log('📍 [ASSIGN PRESCRIPTION] Initial Location Loaded:', {
      locationTypeId: initialLocationType,
      locationTypeName: initialLocationTypeName,
      locationName: initialLocationName,
      source: 'localStorage'
    });
    
    // Initialize SearchableMultiSelect state with saved location
    const savedBoxId = localStorage.getItem('selectedLocation');
    if (savedBoxId && savedBoxId !== 'null' && savedBoxId !== 'undefined') {
      // Set initial state - the name will be updated when boxes are loaded
      this.setState({
        selectedBoxItems: [{ id: savedBoxId, name: 'Loading...' }],
        selectedBoxChips: [{ id: savedBoxId, name: 'Loading...' }]
      });
    }

    if (initialLocationType && savedBoxId) {
      this.setStoredLocationForType(initialLocationType, {
        id: savedBoxId,
        name: initialLocationName === 'Not Set' ? '' : initialLocationName,
      });
    }
    
    this.getLocationTypes();
    this.fetchAllBoxesForTabs();
    this.GetAcccountConnectionId();
  }

  getAllBoxes = (id) => {
    fetch(process.env.REACT_APP_BASEURL + "getBoxesById/" + id, {
      method: "get",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data && data.length > 0) {
          let tmp = data.map((val) => {
            return {
              id: val.id,
              value: val.name,
              brandName: val.brandName,
              brandPhone: val.brandPhone,
              ...val,
            };
          });
          let AddressLine1 = "",
            AddressLine2 = "",
            City = "",
            State = "",
            Zip = "",
            Country = "";
          // Preferred for this location type if in list, else first from list
          const storedLocationForType = this.getStoredLocationForType(id);
          const preferredForThisType = storedLocationForType && storedLocationForType.id
            ? data.find((x) => x.id === storedLocationForType.id)
            : null;
          const currentSelectedLocation = preferredForThisType || data[0];
          if (currentSelectedLocation && currentSelectedLocation.id) {
            this.setStoredLocationForType(id, currentSelectedLocation);
            localStorage.setItem('selectedLocation', currentSelectedLocation.id);
            localStorage.setItem('selected_location_name', currentSelectedLocation.name || currentSelectedLocation.value || '');
          }
          if (currentSelectedLocation) {
            const addr = currentSelectedLocation.address || currentSelectedLocation;
            AddressLine1 = addr.address_line_1 || currentSelectedLocation.address_line_1 || "";
            AddressLine2 = addr.address_line_2 || currentSelectedLocation.address_line_2 || "";
            City = addr.city || currentSelectedLocation.city || "";
            State = addr.state || currentSelectedLocation.state || "";
            Zip = addr.zip || currentSelectedLocation.zip || "";
            Country = addr.country || currentSelectedLocation.country || "";
          }
          
          // Transform data for SearchableSelect
          const boxItems = tmp.map(box => ({
            id: box.id,
            name: box.value
          }));
          
          this.setState((prevState) => ({ 
            boxDetails: tmp,
            boxItems: boxItems,
            boxTypeId: ![undefined, undefined, null, null, ''].includes(currentSelectedLocation) ? currentSelectedLocation.type_id : data && data[0].type_id,
            assignedPrescription:
              (data && data[0].location_type_id) === LOCATION_TYPE.Kiosk
                ? data[0]
                : [],
            // box_id: preferred for this type if in list, else first from list
            box_id: currentSelectedLocation ? currentSelectedLocation.id : (this.state && this.state.box_id),
            selectedBox: currentSelectedLocation,
            searchedItems: {
              ...prevState.searchedItems,
              AddressLine1: AddressLine1,
              AddressLine2: AddressLine2,
              City: City,
              State: State,
              Zip: Zip,
              Country: Country,
            },
            // Set address state for Basic UI
            address: {
              address1: AddressLine1,
              address2: AddressLine2,
              city: City,
              state: State,
              zip: Zip,
              country: Country
            },
          }), () => {
            // After state is set, fetch full box details for currentBoxData
            const effectiveBoxId = this.state.box_id || (currentSelectedLocation && currentSelectedLocation.id);
            if (effectiveBoxId) {
              this.getBoxesByID(effectiveBoxId);
            }
          });
          this.getBoxes();
        }
      }).catch((error) => {
        this.getAllBoxes(id);
        this.setState({ loader: false });
      });
  };

  getBoxes(value) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          const boxesResponse = response.json();
          return boxesResponse;
        } catch (error) {
          return null;
        }
      })
      .then((boxtypes) => {
        if (boxtypes) {
          this.setState({ boxdata: boxtypes });
          const boxTypes = boxtypes.map((type) => {
            return {
              id: type.id,
              label: type.name,
              accountId: type.parent_account_id,
            };
          });
          if (boxtypes.length > 0) {
            if (value === 0) {
              const defaultSelectedBoxId = boxTypes[0].id;
              if (this.state.box_id === null) {
                this.setState({ box_id: boxTypes[0].id });
              }
              this.getAssignedBins(defaultSelectedBoxId);
              this.getPharmacyDetails(defaultSelectedBoxId);
              this.getExpansionBins(defaultSelectedBoxId);
            } else {
              this.getAssignedBins(this.state && this.state.box_id);
              this.getPharmacyDetails(this.state && this.state.box_id);
              this.getExpansionBins(this.state && this.state.box_id);
            }
          }
          this.setState({ boxTypes, printDialogOpen: false, loader: false });
        } else {
          this.setState({ loader: false });
        }
      }).catch((error) => {
        this.setState({ loader: false });
        this.getBoxes(value);
      });
  }

  fetchAllBoxesForTabs = async () => {
    const parentAccountId = sessionStorage.getItem('parentAccountId');
    if (![undefined, 'undefined', null, 'null', ''].includes(parentAccountId)) {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASEURL}getBoxesByStoreId/${parentAccountId}`, {
          method: 'GET',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          }
        });
        
        if (response.ok) {
          const allBoxes = await response.json();
          this.setState({ allBoxes: allBoxes || [] }, () => {
            // Auto-select preferred location for Counter if available
            this.selectPreferredCounterLocation(allBoxes);
          });
        }
      } catch (error) {
        console.error('Error fetching all boxes for Counter component:', error);
        this.setState({ allBoxes: [] });
      }
    }
  };

  getLocationTypesWithRetry = async (retryCount = 0) => {
    const maxRetries = 3;
    
    try {
      const response = await fetch(process.env.REACT_APP_BASEURL + 'locationtypes', {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      });
      
      const locationtypes = await response.json();
      
      if (locationtypes) {
        const locationtypesdata = [];
        let newLocationtypes = [
          ...new Set(locationtypes && locationtypes.map((obj) => obj.name)),
        ].map((name) => {
          return (
            locationtypes && locationtypes.find((obj) => obj.name === name)
          );
        });
        for (let i = 0; i < newLocationtypes.length; i++) {
          if (
            newLocationtypes[i].id !==
            '5e94cb81-ab9b-4e82-8b98-721a2d1794df' &&
            newLocationtypes[i].id !==
            'fd7c6330-8b9a-45e2-a1f6-f791db65f5d0' &&
            newLocationtypes[i].id !== 'ee98b36c-a0e9-4cc4-a411-6c925ad442b6'
          ) {
            let tmp = {};
            tmp = {
              id: newLocationtypes[i].id,
              label: this.props.t(newLocationtypes[i].name_es),
              ...newLocationtypes[i],
            };
            locationtypesdata.push(tmp);
          }
        }
        this.setState({ 
          locationtype: locationtypesdata,
          locationtype_id: this.state.locationtype_id || localStorage.getItem('selectedLocationTypeId')
        }, () => {
          this.getAllBoxes(this.state.locationtype_id)
        });
      }
    } catch (error) {
      console.error(`Location types fetch attempt ${retryCount + 1} failed:`, error);
      
      if (retryCount < maxRetries - 1) {
        console.log(`Retrying location types fetch... (Attempt ${retryCount + 2} of ${maxRetries})`);
        await new Promise(resolve => setTimeout(resolve, 1000));
        return await this.getLocationTypesWithRetry(retryCount + 1);
      } else {
        console.error('Failed to fetch location types after 3 attempts');
        this.setState({ loader: false });
      }
    }
  };

  getLocationTypes = () => {
    this.getLocationTypesWithRetry(0);
  };

  componentWillMount() {
    searchedRxItems = [];
  }

  GetAcccountConnectionId = () => {
    this.setState({ loader: true });
    fetch(`${process.env.REACT_APP_BASEURL}getConnection`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accountConnectionsId) => {
        this.setState({ loader: false });
        if (accountConnectionsId) {
          // Check if connection_details is missing for PioneerRx and fetch full account details
          if (!accountConnectionsId.connection_details && 
              accountConnectionsId.id && 
              accountConnectionsId.account_connections_id === CONNECTION_TYPE.PIONEERRX) {
            this.fetchFullAccountDetails(accountConnectionsId.id);
          }
          this.setState({ globalAccountConnection: accountConnectionsId });
          if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id ===
            CONNECTION_TYPE.UNPLUGGED
          ) {
            navigate('/home/prescription/unpluggedassign');
          }
          else if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id === CONNECTION_TYPE.QS1
          ) {
            rxMaxLength = 12;
          } else if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id ===
            CONNECTION_TYPE.ILOCALBOX_PHARMACY
          ) {
            rxMaxLength = 6 || 7;
          }
          if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id !==
            CONNECTION_TYPE.UNPLUGGED
          ) {
            setTimeout(() => {
              this.textInput &&
                this.textInput.current &&
                this.textInput.current.focus &&
                this.handleFocus();
            }, 3000);
          }
        } else {
          rxMaxLength = 6 || 7;
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  fetchFullAccountDetails = (accountId) => {
    fetch(`${process.env.REACT_APP_BASEURL}account/${accountId}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((fullAccountData) => {
        // Update globalAccountConnection with the full data including connection_details
        if (fullAccountData && fullAccountData[0]) {
          this.setState({ globalAccountConnection: fullAccountData[0] });
        }
      })
      .catch((error) => {
        console.error('Error fetching full account details:', error);
      });
  };

  generateCodes() {
    const _stockCode = [true, "true"].includes(this.state.isOpenPath) || JSON.parse(localStorage.getItem("isNumericCode"))
      ? randomized("0", 4)
      : randomized("A0", 6, { exclude: "0oOiIlL1&zZ" });
    const _pickupCode = [true, "true"].includes(this.state.isOpenPath) || JSON.parse(localStorage.getItem("isNumericCode"))
      ? randomized("0", 4)
      : randomized("A0", 6, { exclude: "0oOiIlL1&zZ" });
    setTimeout(() => {
      this.checkIfCodesExists({
        stockCode: _stockCode,
        pickupCode: _pickupCode,
      });
    }, 100);
  }

  isValidRx(rxno) {
    let customer = this.state.rxDetails.filter((element) =>
      element.orders.some((order) =>
        order.items.some((item) => {
          const trulyValue =
            item.rxNo.toString().toLowerCase() ===
            rxno.toString().toLowerCase();
          if (!trulyValue) {
            return false;
          }
          return trulyValue;
        })
      )
    );
    return customer.length;
  }

  fetchTransactions = (requestParams) => {
    this.setState({ isLoadingTrans: true });
    let tran = {};
    if (requestParams) {
      fetch(process.env.REACT_APP_BASEURL + 'qs/rxTransactions', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(requestParams),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          this.setState({ isLoadingTrans: false });
          tran = JSON.parse(res);
          let rxDetails = tran.rxdetails;
          searchedRxItems.map((i, index) => {
            /*-----Start Modification----- */
            /*
              Modified By: Belani Jaimin
              Modified Date: 01/22/2020
              Description: Check weather Zero is Exist or not as first character. If yes then do not add padded Zero as prefix else add Zero for QS1
            */
            // let _firstCharZero = this.state && this.state.rxNumber.charAt(0); //
            let RxNumber = rxDetails.RxNumber;
            
            // if (_firstCharZero === 0 || _firstCharZero === '0') {
            //   if (this.state && this.state.rxNumber.length === 12) {
            //     RxNumber =
            //       this.state &&
            //       this.state.rxNumber.slice(
            //         0,
            //         this.state && this.state.rxNumber.length - 4
            //       );
            //   } else {
            //     RxNumber = this.state.rxNumber;
            //   }
            // } else {
            //   RxNumber = '0' + this.state.rxNumber;
            // }

            /*-----End Modification----- */
            // Removed By : Belani Jaimin
            // Date: 01/22/2020
            // Description: Removed because It was appending 2 zeros before Rx Number.
            // let RxNumber = '0' + this.state.rxNumber
            if (RxNumber.length > 8) {
              RxNumber = RxNumber.substr(4, RxNumber.length - 8);
            }
            if (i.rxNo === RxNumber) {
              searchedRxItems[index].ndcCode =
                (rxDetails && rxDetails.NDC) || '';
              searchedRxItems[index].CoPayAmount = (rxDetails && rxDetails.isPlanAvailable) === true ? (rxDetails && rxDetails.PrimaryPriceAmount) : (rxDetails && rxDetails.CopayAmount);
              searchedRxItems[index].qty =
                (rxDetails && rxDetails.QuantityDispensed) || 0;
              searchedRxItems[index].isLoadingTrans = false;
              searchedRxItems[index].SeqNumber =
                (rxDetails && rxDetails.SeqNumber) || 0;
              searchedRxItems[index].fillNumber =
                (rxDetails && rxDetails.FillNumber) || 0;  
            }
            return true;
          });
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
          this.forceUpdate();
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };
  onChange = (event) => {
    const patientId =
      this.state &&
      this.state.searchedItems &&
      this.state.searchedItems.PatientID;
    const searchedString = event.target.value;
    this.setState({
      isEdit: false,
      doesPrescriptionScanned: true,
      rxNumber: searchedString && searchedString,
    });

    // Check connection type and route to appropriate handler for Counter Rx scanning
    const { globalAccountConnection } = this.state;
    const connectionTypeId = globalAccountConnection && globalAccountConnection.account_connections_id;

    // Handle Epic and Epic With MTLS Rx scanning
    if ((connectionTypeId === CONNECTION_TYPE.EPIC || connectionTypeId === CONNECTION_TYPE.EPIC_WITH_MTLS) &&
        searchedString && searchedString.trim().length > 0) {
      // Create synthetic event with Enter keyCode to trigger Epic Rx handler
      const syntheticEvent = {
        target: { value: searchedString },
        keyCode: 13,
        preventDefault: () => {},
      };
      const pmsType = connectionTypeId === CONNECTION_TYPE.EPIC ? 'EPIC' : 'Epic With MTLS';
      // Call handleRxCheck which will process Epic Rx scanning
      this.handleRxCheck(syntheticEvent, pmsType);
      return;
    }

    // Default flow for other connection types (BASIC, etc.)
    if (
      searchedString.toString().toUpperCase().length > 0 &&
      searchedString.toString().toUpperCase().length >= rxMaxLength
    ) {
      let isValid = this.isValidRx(searchedString);
      if (isValid > 0) {
        fetch(
          process.env.REACT_APP_BASEURL + 'checkrxexistornot/' + searchedString + '/false',
          {
            method: 'GET',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession
                  .idToken.jwtToken,
            },
          }
        )
          .then((response) => response.json())
          .then((boxes) => {
            if (boxes && !boxes.Rx_Is_Exist) {
              const data = this.state.rxDetails;
              if (this.state.searchedRxNo.length === 0) {
                this.state.rxDetails.filter((element) =>
                  element.orders.some((order) =>
                    order.items.some((items) => {
                      const trulyValue =
                        items.rxNo.toString().toUpperCase() ===
                        searchedString.toString().toUpperCase();
                      if (trulyValue) {
                        searchedRxItems.push(items);
                        this.setState({
                          searchedItems: element,
                          EmailID: element.EmailID,
                        });
                        this.checkADACompatible(
                          element.PatientID,
                          this.state && this.state.EmailID
                        );
                        if (searchedString.toString().length === rxMaxLength) {
                          this.setState({
                            searchedRxNo: [
                              ...this.state.searchedRxNo,
                              searchedString.toString().length ===
                              rxMaxLength && searchedString,
                            ],
                          });
                        }
                        this.setState({
                          rxNumber: '',
                        });
                        this.handleFocus();
                      }
                      return trulyValue;
                    })
                  )
                );
              } else {
                this.state.searchedRxNo.forEach((item) => {
                  // current rxNo
                  const rxno = this.state.rxNumber.toString().toUpperCase();
                  let currentRxObj = [];
                  data.filter((element) =>
                    element.orders.filter((order) =>
                      order.items.some((items) => {
                        if (items.rxNo.toString().toUpperCase() === rxno) {
                          currentRxObj = element;
                          this.setState({ EmailID: element.EmailID });
                          this.checkADACompatible(
                            element.PatientID,
                            this.state && this.state.EmailID
                          );
                        }
                        return true;
                      })
                    )
                  );

                  if (
                    this.state.searchedItems.PatientID !==
                    currentRxObj.PatientID &&
                    currentRxObj.PatientID !== undefined
                  ) {
                    toast.error(this.props.t('Toast.Error.WrongPatient'));
                    this.setState({
                      rxNumber: '',
                    });
                    this.handleFocus();
                  } else {
                    if (searchedString !== item) {
                      data.filter((element) =>
                        element.orders.some((order) =>
                          order.items.some((items) => {
                            const trulyValue =
                              items.rxNo.toString().toUpperCase() ===
                              searchedString.toString().toUpperCase() &&
                              patientId === element.PatientID;
                            if (trulyValue) {
                              var test = false;
                              for (var i = 0; i < searchedRxItems.length; i++) {
                                if (
                                  searchedRxItems[i].rxNo
                                    .toString()
                                    .toUpperCase() ===
                                  searchedString.toString().toUpperCase()
                                ) {
                                  test = true;
                                }
                              }
                              if (!test) {
                                searchedRxItems.push(items);
                                this.setState({ searchedItems: element });
                                this.setState({ EmailID: element.EmailID });
                                this.checkADACompatible(
                                  element.PatientID,
                                  this.state && this.state.EmailID
                                );
                                if (
                                  searchedString.toString().length ===
                                  rxMaxLength
                                ) {
                                  this.setState({
                                    searchedRxNo: [
                                      ...this.state.searchedRxNo,
                                      searchedString.toString().length ===
                                      rxMaxLength && searchedString,
                                    ],
                                  });
                                }
                              }
                              this.setState({
                                rxNumber: '',
                              });
                              this.handleFocus();
                            }
                            return trulyValue;
                          })
                        )
                      );
                    }
                  }
                });
              }
              this.setState({ readOnly: false });
            } else {
              this.setState({
                rxNumber: '',
              });
              this.handleFocus();
              toast.error(this.props.t('Toast.Error.RxAssigned'));
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      } else if (
        searchedString.substring(0, 3).toUpperCase() === 'A11' &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id ===
        CONNECTION_TYPE.ILOCALBOX_PHARMACY
      ) {
        //Assign single Rx for Patient
        if (this.state.searchedRxNo.length === 0) {
          var patient = DemoData.randomPatient();
          patient.EmailID =
            (this.state.accountDetails &&
              this.state.accountDetails.demo_email) ||
            this.state.EmailID;
          patient.MobileNo =
            (this.state.accountDetails &&
              this.state.accountDetails.demo_phone) ||
            this.state.phone;
          var items = DemoData.randomRx();
          items.rxNo = searchedString;
          items.patientId = patient.PatientID;
          searchedRxItems.push(items);
          this.checkADACompatible(patient.PatientID, patient.EmailID);
          this.getcustomerLocation(patient, items, 'A11');
          this.setState({
            EmailID: patient.EmailID,
            phone: patient.MobileNo,
            alternateAgents: patient.alternateAgents,
            searchedRxNo: [
              ...this.state.searchedRxNo,
              searchedString.toString().length === rxMaxLength &&
              searchedString,
            ],
            rxNumber: '',
            readOnly: false,
          });
          this.handleFocus();
        } else if (this.state.searchedRxNo[0] === searchedString) {
          //Do nothing.
          this.setState({ readOnly: false })
        } else {
          toast.error(this.props.t('Toast.Error.WrongPatient'));
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        }
      } else if (
        searchedString.substring(0, 3).toUpperCase() === 'A22' &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id ===
        CONNECTION_TYPE.ILOCALBOX_PHARMACY
      ) {
        //Assign multi Rx for Patient
        const res3 = searchedRxItems.some((elm) => {
          if (
            elm.rxNo &&
            elm.rxNo.toUpperCase() === searchedString.toUpperCase()
          ) {
            return true;
          } else {
            return false;
          }
        });

        if (res3) {
          if (this.state.accountDetails && this.state.accountDetails.demo_email) {
            this.setState({ EmailID: this.state.accountDetails.demo_email });
          } else if (this.state.searchedItems && this.state.searchedItems.EmailID) {
            this.setState({ EmailID: this.state.searchedItems.EmailID });
          }
          return;
        }
        if (this.state.searchedRxNo.length === 0) {
          var patient1 = DemoData.randomPatient();
          patient1.EmailID =
            this.state.accountDetails && this.state.accountDetails.demo_email;
          patient1.MobileNo =
            this.state.accountDetails && this.state.accountDetails.demo_phone;
          if (!patient1.orders || !patient1.orders[0]) {
            patient1.orders = [{
              items: []
            }];
          }
          var items1 = DemoData.randomRx();
          items1.rxNo = searchedString;
          items1.patientId = patient1.PatientID;
          items1.name =
            items1.name +
            ' ' +
            Math.floor(Math.random() * 100 + 1) +
            randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
          searchedRxItems.push(items1);
          if (patient1.orders[0] && patient1.orders[0].items) {
            patient1.orders[0].items.push(items1);
          }
          this.setState({
            searchedItems: patient1,
            EmailID: patient1.EmailID,
            phone: patient1.MobileNo,
            alternateAgents: patient1.alternateAgents,
          });
          this.checkADACompatible(patient1.PatientID, patient1.EmailID);
          this.getcustomerLocation(patient1, items1, 'A22');
          this.setState({
            searchedRxNo: [
              ...this.state.searchedRxNo,
              searchedString.toString().length === rxMaxLength &&
              searchedString,
            ],
            readOnly: false,
          });
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        } else {
          var patient2 = this.state.searchedItems;
          const res = this.state.rxDetails.some((element) => {
            if (element.PatientID === patient2.PatientID) {
              return true;
            } else {
              return false;
            }
          });

          const res2 = searchedRxItems.some((elm) => {
            const prefix = elm.rxNo && elm.rxNo.substring(0, 3).toUpperCase();
            return prefix === 'A11' || prefix === 'A33';
          });

          if (!res && !res2) {
            var orderItems = this.state.searchedItems.orders[0];
            var items2 = DemoData.randomRx();
            items2.patientId = patient2.PatientID;
            items2.rxNo = searchedString;
            items2.name =
              items2.name +
              ' ' +
              Math.floor(Math.random() * 100 + 1) +
              +randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
            items2.ndcCode =
              Math.floor(Math.random() * 100000 + 1) +
              '-' +
              Math.floor(Math.random() * 1000 + 1);
            searchedRxItems.push(items2);
            orderItems && orderItems.items && orderItems.items.push && orderItems.items.push(items2);
            patient2.orders[0] = orderItems;

            this.setState({ searchedItems: patient2 });
            const emailToSet = patient2.EmailID || 
                              this.state.EmailID || 
                              (this.state.accountDetails && this.state.accountDetails.demo_email) || 
                              '';
            this.setState({ 
              EmailID: emailToSet, 
              alternateAgents: (patient && patient.alternateAgents) || (patient2 && patient2.alternateAgents) 
            });
            this.checkADACompatible(
              patient2.PatientID,
              this.state && this.state.EmailID
            );
            if (searchedString.toString().length === rxMaxLength) {
              this.setState({
                searchedRxNo: [
                  ...this.state.searchedRxNo,
                  searchedString.toString().length === rxMaxLength &&
                  searchedString,
                ],
                readOnly: false,
              });
            }
          } else {
            toast.error(this.props.t('Toast.Error.WrongPatient'));
          }

          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        }
      } else if (
        searchedString.substring(0, 3).toUpperCase() === 'A33' &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id ===
        CONNECTION_TYPE.ILOCALBOX_PHARMACY
      ) {
        // Assign multi Rx for Patient (A33 flow, same as A22)
        const res3 = searchedRxItems.some((elm) => {
          if (
            elm.rxNo &&
            elm.rxNo.toUpperCase() === searchedString.toUpperCase()
          ) {
            return true;
          } else {
            return false;
          }
        });

        if (res3) {
          if (this.state.accountDetails && this.state.accountDetails.demo_email) {
            this.setState({ EmailID: this.state.accountDetails.demo_email });
          } else if (this.state.searchedItems && this.state.searchedItems.EmailID) {
            this.setState({ EmailID: this.state.searchedItems.EmailID });
          }
          return;
        }
        if (this.state.searchedRxNo.length === 0) {
          const patient1A33 = DemoData.randomPatient();
          patient1A33.EmailID =
            this.state.accountDetails && this.state.accountDetails.demo_email;
          patient1A33.MobileNo =
            this.state.accountDetails && this.state.accountDetails.demo_phone;
          if (!patient1A33.orders || !patient1A33.orders[0]) {
            patient1A33.orders = [{
              items: []
            }];
          }
          const items1A33 = DemoData.randomRx();
          items1A33.rxNo = searchedString;
          items1A33.patientId = patient1A33.PatientID;
          items1A33.AllFlags = getFlagsForA33Item({
            apiFlagCodes: this.state.accountSignatureFlagCodes,
            dummyMin: 2,
            dummyMax: 5,
          });
          items1A33.PrescriptionFlags = items1A33.AllFlags || [];
          items1A33.Flags = items1A33.AllFlags || [];
          items1A33.name =
            items1A33.name +
            ' ' +
            Math.floor(Math.random() * 100 + 1) +
            randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
          searchedRxItems.push(items1A33);
          if (patient1A33.orders[0] && patient1A33.orders[0].items) {
            patient1A33.orders[0].items.push(items1A33);
          }
          this.setState({
            searchedItems: patient1A33,
            EmailID: patient1A33.EmailID,
            phone: patient1A33.MobileNo,
            alternateAgents: patient1A33.alternateAgents,
          });
          this.checkADACompatible(patient1A33.PatientID, patient1A33.EmailID);
          this.getcustomerLocation(patient1A33, items1A33, 'A33');
          this.setState({
            searchedRxNo: [
              ...this.state.searchedRxNo,
              searchedString.toString().length === rxMaxLength &&
              searchedString,
            ],
            readOnly: false,
          });
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        } else {
          const patient2A33 = this.state.searchedItems;
          const res = this.state.rxDetails.some((element) => {
            if (element.PatientID === patient2A33.PatientID) {
              return true;
            } else {
              return false;
            }
          });

          const res2 = searchedRxItems.some((elm) => {
            const prefix = elm.rxNo && elm.rxNo.substring(0, 3).toUpperCase();
            return prefix === 'A11' || prefix === 'A22';
          });

          if (!res && !res2) {
            const orderItemsA33 = this.state.searchedItems.orders[0];
            const items2A33 = DemoData.randomRx();
            items2A33.patientId = patient2A33.PatientID;
            items2A33.rxNo = searchedString;
            items2A33.AllFlags = getFlagsForA33Item({
              apiFlagCodes: this.state.accountSignatureFlagCodes,
              dummyMin: 2,
              dummyMax: 5,
            });
            items2A33.PrescriptionFlags = items2A33.AllFlags || [];
            items2A33.Flags = items2A33.AllFlags || [];
            items2A33.name =
              items2A33.name +
              ' ' +
              Math.floor(Math.random() * 100 + 1) +
              +randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
            items2A33.ndcCode =
              Math.floor(Math.random() * 100000 + 1) +
              '-' +
              Math.floor(Math.random() * 1000 + 1);
            searchedRxItems.push(items2A33);
            orderItemsA33 && orderItemsA33.items && orderItemsA33.items.push && orderItemsA33.items.push(items2A33);
            patient2A33.orders[0] = orderItemsA33;

            this.setState({ searchedItems: patient2A33 });
            const emailToSet = patient2A33.EmailID ||
                              this.state.EmailID ||
                              (this.state.accountDetails && this.state.accountDetails.demo_email) ||
                              '';
            this.setState({
              EmailID: emailToSet,
              alternateAgents: (patient && patient.alternateAgents) || (patient2A33 && patient2A33.alternateAgents)
            });
            this.checkADACompatible(
              patient2A33.PatientID,
              this.state && this.state.EmailID
            );
            if (searchedString.toString().length === rxMaxLength) {
              this.setState({
                searchedRxNo: [
                  ...this.state.searchedRxNo,
                  searchedString.toString().length === rxMaxLength &&
                  searchedString,
                ],
                readOnly: false,
              });
            }
          } else {
            toast.error(this.props.t('Toast.Error.WrongPatient'));
          }

          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        }
      }
    }
    let unique = [...new Set(searchedRxItems)];
    searchedRxItems = [];
    searchedRxItems = unique;
  };

  checkADACompatible = (PatientID, EmailID) => {
    this.setState({ loader: true });
    let patientObj = {
      PatientID: PatientID,
      EmailID: EmailID,
    };
    fetch(process.env.REACT_APP_BASEURL + 'getADACompatiblePatients', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(patientObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((Pdata) => {
        if (Pdata && Pdata.ADAcustomers && Pdata.ADAcustomers.length > 0) {
          this.setState({
            ADAData: Pdata.ADAcustomers,
            isADACompatible: true,
            loader: false
          });
        } else {
          this.setState({ ADAData: [], isADACompatible: false, loader: false });
        }
      })
      .catch((error) => {
        toast.error(JSON.stringify(error));
        this.setState({ loader: false });
      });
  };
  getSelectedBin = (binId, position, flag) => {
    const { deactivatedBins } = this.state;
    if (deactivatedBins.includes(binId)) {
      this.setState({
        isBinDeactivated: true,
        selectedBinId: binId,
        box_position: position,
        isSelectedFlag: flag,
      });
    } else {
      this.setState({
        isBinDeactivated: false,
        selectedBinId: binId,
        box_position: position,
        isSelectedFlag: flag,
      });
    }
  };

  /*
      Added By : Belani Jaimin
      Added Date : 02/11/2019
      Description : Get Bin Status
    */
  getAssignedBins = (box_id) => {
    this.setState({ loader: true });
    let _binStatus = [];
    const { selectedBox } = this.state;
    if (box_id) {
      fetch(process.env.REACT_APP_BASEURL + 'api/v2/orders/occupied-bins/' + box_id, {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((bins) => {
          this.setState({ loader: false });
          let deactivatedBins;
          _binStatus = JSON.parse(bins);
          if (_binStatus && _binStatus[0] && _binStatus[0].disabled_bins) {
            deactivatedBins = _binStatus[0].disabled_bins.toString().split(',');
            this.setState({ deactivatedBins: deactivatedBins });
          } else {
            if (selectedBox && typeof selectedBox.disabled_bins === 'string') {
              let disabledBinsStr = selectedBox.disabled_bins.trim();
              if (disabledBinsStr.length > 0) {
                // Split by comma, trim each, filter out empty
                let binsArray = disabledBinsStr.split(',').map(b => b.trim()).filter(b => b.length > 0);
                this.setState({ deactivatedBins: binsArray });
              } else {
                this.setState({ deactivatedBins: [] });
              }
            } else {
              this.setState({ deactivatedBins: [] });
            }
          }
          this.setState({ BinStatus: _binStatus });
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  getBoxesByID = (id) => {
    fetch(`${process.env.REACT_APP_BASEURL}boxes/${id}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((boxes) => {
        // Handle both array and single object responses
        const boxData = Array.isArray(boxes) && boxes.length > 0 ? boxes[0] : boxes;
        
        // Debug: Log column_mappings from API
        console.log('[AssignPrescriptions] getBoxesByID - Received box data:', {
          boxId: boxData ? boxData.id : null,
          hasColumnMappings: boxData && !!boxData.column_mappings,
          columnMappings: boxData ? boxData.column_mappings : null,
          columnMappingsType: boxData && boxData.column_mappings ? Array.isArray(boxData.column_mappings) : false,
          columnMappingsLength: boxData && boxData.column_mappings ? boxData.column_mappings.length : 0
        });
        
        console.log(boxData, "boxData")
        if (boxData) {
          this.setState(
            {
              courier_type:
                boxData.courier_type && boxData.courier_type.length > 0
                  ? boxData.courier_type.map((val) => {
                    return val.courier_type;
                  })
                  : [],
              currentBoxData: boxData, // Store full box data in separate state
              selectedBox: boxData,
              isOpenPath: boxData.openpath
            },
            () => {
              if (this.state.courier_type.length > 0) {
                this.setState({
                  default_courier_selected:
                    boxData.courier_type[0].default_courier_type,
                });
              }
              // Always set address state when box data is available
              const addr = boxData.address || boxData;
              const address = {
                address1: addr.address_line_1 || boxData.address_line_1 || '',
                address2: addr.address_line_2 || boxData.address_line_2 || '',
                city: addr.city || boxData.city || '',
                state: addr.state || boxData.state || '',
                zip: addr.zip || boxData.zip || '',
                country: addr.country || boxData.country || ''
              };
              this.setState({ address });
            }
          );
          let search = this.state.searchedItems;
          if (search && boxData.location_notes) {
            search.location_notes = '';
            search.location_notes = boxData.location_notes;
            this.setState({ searchedItems: search });
          }
          this.getAssignedBins(id);
          this.getPharmacyDetails(id);
          this.getExpansionBins(id);
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleChange = async (event) => {
    const  { 
      boxDetails
    } = this.state;
    const newBoxId = event.target.value;
    const locationDetails = boxDetails.filter((x) => x.id === newBoxId)[0];
    this.setState({ box_id: newBoxId })
    this.getExpansionBins(event.target.value);
    this.getAssignedBins(event.target.value);
    // Fetch full box details for currentBoxData
    this.getBoxesByID(event.target.value);
    let AddressLine1 = '', 
    AddressLine2 = '', 
    City = '', 
    State = '', 
    Zip = '', 
    Country = '';
    if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
      const addr = locationDetails.address || locationDetails;
      AddressLine1 = addr.address_line_1 || locationDetails.address_line_1 || "";
      AddressLine2 = addr.address_line_2 || locationDetails.address_line_2 || "";
      City = addr.city || locationDetails.city || "";
      State = addr.state || locationDetails.state || "";
      Zip = addr.zip || locationDetails.zip || "";
      Country = addr.country || locationDetails.country || "";
    }
    this.setState(prevState => ({
      searchedItems: {
        ...prevState.searchedItems,
        AddressLine1: AddressLine1,
        AddressLine2: AddressLine2,
        City: City,
        State: State,
        Zip: Zip,
        Country: Country
      },
      boxTypeId: locationDetails.type_id,
      selectedBox: locationDetails
    }), () => {
      // Always set address state when box data is available
      const address = {
        address1: AddressLine1,
        address2: AddressLine2,
        city: City,
        state: State,
        zip: Zip,
        country: Country
      };
      this.setState({ address });
    });
  };

  handletypeChange = async (event) => {
    const newLocationType = event.target.value;
    this.handleLocationTypeChange(newLocationType);
  };

  handleLocationTypeChange = async (newLocationType) => {
    const locationTypeName = (this.state.locationtype && this.state.locationtype.find(l => l.id === newLocationType)) ? this.state.locationtype.find(l => l.id === newLocationType).label : 'Unknown';
    console.log('📍 [ASSIGN PRESCRIPTION] Location Type Changed:', {
      oldLocationType: this.state.locationtype_id,
      newLocationType: newLocationType,
      locationTypeName: locationTypeName
    });
    // Save to localStorage to persist user's selection
    localStorage.setItem('selectedLocationTypeId', newLocationType);
    this.setState({
      locationtype_id: newLocationType,
    }, () => {
      this.getAllBoxes(newLocationType);
      // If switching to Counter, try to select preferred location
      if (newLocationType === LOCATION_TYPE.Counter && this.state.allBoxes && this.state.allBoxes.length > 0) {
        this.selectPreferredCounterLocation(this.state.allBoxes);
      }
    });
  };

  selectPreferredCounterLocation = (allBoxes) => {
    const locationtype_id = this.state.locationtype_id;
    if (!locationtype_id || locationtype_id !== LOCATION_TYPE.Counter || !allBoxes || allBoxes.length === 0) {
      return;
    }

    const counterBoxes = allBoxes.filter(box => {
      const boxLocationTypeId = box.location_type_id || box.locationtype_id;
      return boxLocationTypeId === LOCATION_TYPE.Counter;
    });
    if (counterBoxes.length === 0) {
      return;
    }

    const storedLocationForCounter = this.getStoredLocationForType(LOCATION_TYPE.Counter);
    const hasPreferredForCounter = storedLocationForCounter && storedLocationForCounter.id &&
      ![undefined, 'undefined', null, 'null', ''].includes(storedLocationForCounter.id);

    // Prefer saved location if it exists for Counter and is in the list; else use first Counter box
    const preferredBox = hasPreferredForCounter
      ? counterBoxes.find(box => box.id === storedLocationForCounter.id)
      : null;
    const boxToSelect = preferredBox || counterBoxes[0];

    if (boxToSelect && boxToSelect.id && this.state.box_id !== boxToSelect.id) {
      this.setState({ box_id: boxToSelect.id }, () => {
        this.getBoxesByID(boxToSelect.id);
        this.setStoredLocationForType(LOCATION_TYPE.Counter, boxToSelect);
        localStorage.setItem('selectedLocation', boxToSelect.id);
        localStorage.setItem('selected_location_name', boxToSelect.name || '');
      });
    }
  };

  handleCounterLocationChange = (boxName) => {
    if (!boxName || !this.state.allBoxes || this.state.allBoxes.length === 0) {
      return;
    }
    
    const selectedBox = this.state.allBoxes.find(box => {
      const boxLocationTypeId = box.location_type_id || box.locationtype_id;
      const matchesLocationType = boxLocationTypeId === this.state.locationtype_id;
      const matchesName = box.name === boxName;
      return matchesLocationType && matchesName;
    });
    
    if (!selectedBox || !selectedBox.id) {
      return;
    }
    
    this.setState({ box_id: selectedBox.id }, () => {
      this.getBoxesByID(selectedBox.id);
      this.setStoredLocationForType(this.state.locationtype_id, selectedBox);
      localStorage.setItem('selectedLocation', selectedBox.id);
      localStorage.setItem('selected_location_name', selectedBox.name);
    });
  };
  handleFutureChange = async (event) => {
    if (event.preventDefault) event.preventDefault();
    this.setState({
      FutureRelease: event.target.value
    })
    if (event.target.value) {
      this.setState({
        showDatePopup: true
      })
    }
  }
  handleFutureDateChange = async (event) => {
    if (event.start > new Date()) {
      this.setState({ FutureReleaseDate: event.start, showDatePopup: false });
    }
  }

  getPharmacyDetails(boxId) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((phrmacydetail) => {
        this.setState({ loader: false });
        this.setState({ pharmacyDetails: phrmacydetail && phrmacydetail[0], allow_multi_bins_pickup: (phrmacydetail && phrmacydetail[0] && phrmacydetail[0].allow_multi_bins_pickup) });
        const accountId = phrmacydetail && phrmacydetail[0].parent_account_id;
        this.getAccountDetails(accountId);
      })
      .catch((error) => {
        this.getPharmacyDetails(boxId);
        this.setState({ loader: false });
      });
  }
  //Added by Naresh | DI-329 | Date:27-05-2019
  getExpansionBins(boxId) {
    fetch(process.env.REACT_APP_BASEURL + 'box-expansions/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((expansionDetails) => {
        console.log('🔵 getExpansionBins - expansionDetails from API:', expansionDetails);
        let order = 0;
        let UnitLayout = [];
        let UnitIndex = 0;
        if (expansionDetails && expansionDetails.length > 0) {
          //Add Left side Unit
          UnitLayout = [];
          if (expansionDetails.findIndex((x) => x.direction === 1) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 1) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = Math.abs(unit.box_position);
                  boxlist.pos = 'L';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                return true;
              });
          }
          if (UnitLayout.length > 0) {
            UnitLayout.reverse();
          }
          order = order + 1;
          UnitIndex = UnitIndex + 1;
          const boxesExpansions =
            expansionDetails &&
            expansionDetails.find((x) => x.box.id === boxId);
          if (boxesExpansions && boxesExpansions !== undefined) {
            if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M22
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M22',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M24
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M24',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.FASTLANE
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANE',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.FASTLANEGOLIATH
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANEGOLIATH',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            }
          }
          //Add Right side Unit
          if (expansionDetails.findIndex((x) => x.direction === 2) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 2) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = unit.box_position;
                  boxlist.pos = 'R';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                return true;
              });
          }
        } else {
          order = order + 1;
          const boxes =
            this.state &&
            this.state.boxdata &&
            this.state.boxdata.length &&
            this.state.boxdata.length > 0 &&
            this.state.boxdata.find((x) => x.id === boxId);
          if (boxes && boxes !== undefined) {
            if (
              boxes &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M22
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M22',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M24
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M24',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.FASTLANE
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANE',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.FASTLANEGOLIATH
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANEGOLIATH',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            }
          }
        }
        this.setState({ expansionUnits: UnitLayout });
        
        // Format expansion data for dialog use from UnitLayout (which has add-ons processed)
        const dialogExpansions = [];
        
        // Build dialog expansions from UnitLayout - filter out main units (M, M22, M24, FASTLANE)
        // Keep only add-ons (L or R position)
        if (UnitLayout && UnitLayout.length > 0) {
          UnitLayout.forEach((unit, index) => {
            // Add-ons have pos === 'L' or pos === 'R'
            // Main units have pos === 'M', 'M22', 'M24', 'FASTLANE', etc.
            const isAddOn = unit.pos === 'L' || unit.pos === 'R';
            
            if (isAddOn && unit.box && unit.box.id) {
              const directionLabel = unit.pos === 'L' ? 'Left' : 'Right';
              
              // For add-ons, use expansion_id or boxes_type.id as the box type (not box.type_id which is the main box)
              const addOnBoxTypeId = unit.expansion_id || (unit.boxes_type && unit.boxes_type.id) || unit.box.type_id;
              
              // Get box type name from expansion_id/boxes_type
              let boxName = 'Unit';
              if (unit.boxes_type && unit.boxes_type.name) {
                boxName = unit.boxes_type.name;
              } else if (addOnBoxTypeId) {
                // Map common box type IDs to names
                const boxTypeNames = {
                  [BOX_TYPE.Locker]: 'Locker',
                  [BOX_TYPE.L60]: 'L60',
                  [BOX_TYPE.Cool]: 'Cool',
                  [BOX_TYPE.HD36]: 'HD36',
                  [BOX_TYPE.M22]: 'M22',
                  [BOX_TYPE.M24]: 'M24',
                  [BOX_TYPE.C30]: 'C30',
                  [BOX_TYPE.A12]: 'A12',
                  [BOX_TYPE.V12]: 'V12',
                  [BOX_TYPE.COOL_12]: 'Cool12'
                };
                boxName = boxTypeNames[addOnBoxTypeId] || 'Unit';
              }
              
              // For add-ons, use the expansion ID as boxId, and expansion_id as boxTypeId
              // The expansion ID (unit.id) represents the add-on unit itself
              dialogExpansions.push({
                id: unit.id, // Expansion ID (the add-on unit ID)
                label: `Add-on ${directionLabel} - ${boxName}`,
                boxId: unit.id, // Use expansion ID as boxId for the add-on
                boxTypeId: addOnBoxTypeId, // Use expansion_id (add-on type) as boxTypeId
                expansionData: unit, // Full unit object with all properties
                isMainUnit: false
              });
            } else {
              console.log('⚠️ Skipped unit (main unit or invalid):', {
                pos: unit.pos,
                isAddOn: isAddOn,
                hasBox: !!unit.box,
                boxId: unit.box ? unit.box.id : 'NO BOX'
              });
            }
          });
        } else {
          console.log('⚠️ No units found in UnitLayout');
        }
        
        this.setState({ expansionUnitsForDialog: dialogExpansions });
      })
      .catch((error) => {
        console.error(error)
        this.getExpansionBins(boxId)
        this.setState({ loader: false });
      })
  }
  //End DI-329

  getAccountDetails(accountId) {
    this.setState({ loader: true });
    fetch(
      process.env.REACT_APP_BASEURL + 'account/' + accountId,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      },
      accountId
    )
      .then((response) => response.json())
      .then((accountdetail) => {
        this.setState({ loader: false });
        const details = accountdetail && accountdetail[0];
        this.setState({ accountDetails: details });
        const accountId = details && details.id;
        if (accountId) {
          fetchAccountSignatureFlagCodes(accountId).then((codes) => {
            this.setState({ accountSignatureFlagCodes: codes || [] });
          }).catch(() => { this.setState({ accountSignatureFlagCodes: [] }); });
        } else {
          this.setState({ accountSignatureFlagCodes: [] });
        }
        this.setState({ accountDetails: accountdetail && accountdetail[0] }, () => {
          // Set address if not already set and we have box data
          if (!this.state.address) {
            const { selectedBox, searchedItems } = this.state;
            if (selectedBox || searchedItems) {
              const boxAddr = selectedBox && selectedBox.address;
              const address = {
                address1: (boxAddr && boxAddr.address_line_1) || (selectedBox && selectedBox.address_line_1) || (searchedItems && searchedItems.AddressLine1) || '',
                address2: (boxAddr && boxAddr.address_line_2) || (selectedBox && selectedBox.address_line_2) || (searchedItems && searchedItems.AddressLine2) || '',
                city: (boxAddr && boxAddr.city) || (selectedBox && selectedBox.city) || (searchedItems && searchedItems.City) || '',
                state: (boxAddr && boxAddr.state) || (selectedBox && selectedBox.state) || (searchedItems && searchedItems.State) || '',
                zip: (boxAddr && boxAddr.zip) || (selectedBox && selectedBox.zip) || (searchedItems && searchedItems.Zip) || '',
                country: (boxAddr && boxAddr.country) || (selectedBox && selectedBox.country) || (searchedItems && searchedItems.Country) || ''
              };
              this.setState({ address });
            }
          }
        });
      }).catch(() => {
        this.getAccountDetails(accountId)
        this.setState({ loader: false });
      });
  }

  EventLogHanlder = (uData) => {
    let tofor_id = '';
    let descriptions = '';
    tofor_id =
      uData && uData.prescriptions_master && uData.prescriptions_master.id;
    descriptions =
      'Prescription is Assigned with stock code ' +
      this.state.stockCode +
      ' and pick up code ' +
      this.state.pickupCode +
      ' with Rx No ' +
      this.state.rxNumber;

    const event_params = {
      event_name: EVENT_CRUD_TYPES.INSERT,
      event_type_name: EVENT_TYPES.ASSIGNED,
      description: descriptions,
      object_id: assignmentstatus.ASSIGNED,
      tofor_id: tofor_id,
      box_id: this.state.box_id,
    };
    new EventLogHandler().handleEventLog(event_params);
  };

  courierTrackingHandler = (evt) => {
    this.setState({ courier_tracking: evt.target.value });
  };

  checkBoxHandler = (value) => {
    this.setState({ default_courier_selected: value });
  };

  getCartRxNumbers = () => {
    const { accountDetails } = this.state;
    searchedRxNumbers = [];
    searchedRxItems.map((item) => {
      if (item) {
        if (
          accountDetails &&
          accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS
        ) {
          searchedRxNumbers.push(item.prescriptionnumber);
        } else {
          searchedRxNumbers.push(item.rxNo || item.rx_no);
        }
      }
      return true;
    });
  };

  openAllBin() {
    let Ids = [];
    nums1.forEach((n1) => {
      nums.forEach((n) => {
        if ((elem[n] === 'B' || elem[n] === 'C') && n1 >= 0 && n1 <= 6) {
        } else {
          if (elem[n] === 'A') {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else if (elem[n] === 'B' && n1 >= 7 && n1 <= 11) {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else if (elem[n] === 'C' && n1 >= 7 && n1 <= 11) {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else {
            Ids.push(elem[n] + '' + (n1 + 1));
          }
        }
      });
    });

    const filteredArray = this.sortArray(Ids);
    for (let index = 0; index < filteredArray.length; index++) {
      const element = filteredArray[index];
      var items = document.getElementById(element);
      items.style.background =
        'linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)';
      items.style.color = '#000';
    }
  }

  sortArray(Ids) {
    var reA = /[^a-zA-Z]/g;
    var reN = /[^0-9]/g;

    function sortAlphaNum(a, b) {
      var aA = a.replace(reA, '');
      var bA = b.replace(reA, '');
      if (aA === bA) {
        var aN = parseInt(a.replace(reN, ''), 10);
        var bN = parseInt(b.replace(reN, ''), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    }
    return Ids.sort(sortAlphaNum);
  }

  handleClose = () => {
    this.setState({ openMessage: false });
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({
        selected: searchedRxItems.map((n) => n.rxNo),
      }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: searchedRxItems.filter(
          (x) => x.itemId === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: searchedRxItems.filter(
          (x) => this.state.selected.indexOf(x.rxNo) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    } else {
      this.deleteItems();
    }
    this.setState({ deleteDialogOpen: false });
  };

  deleteItems = (event) => {
    const rowIdToDelete = this.state.forDeletion;
    if (rowIdToDelete.length === searchedRxItems.length) {
      searchedRxItems = [];
      this.setState({
        searchedRxNo: [],
        searchedItems: [],
        rxNumber: '',
        selected: [],
      });
      searchedRxItems = [];
      this.openAllBin();
    } else {
      for (var i = 0; i < rowIdToDelete.length; i++) {
        searchedRxItems = searchedRxItems.filter(
          // eslint-disable-next-line no-loop-func
          (x) => x.rxNo !== rowIdToDelete[i].rxNo
        );
      }
      this.setState({
        rxNumber: '',
        selected: [],
      });
      this.handleFocus();
    }
  };

  getPrescriptionDetails = (BinId, pm_id, stockCodeOverride = null) => {
    const isFastlaneGoliath =
      this.state.boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const hasUsableBinId = ![undefined, 'undefined', null, 'null', ''].includes(BinId);
    // Goliath can resolve by stock_code / pm_id even when bin_id is null.
    if (hasUsableBinId || isFastlaneGoliath) {
      const { accountDetails, deactivatedBins } = this.state;
      if (deactivatedBins.includes(BinId)) {
        this.setState({ isEdit: true, binid: BinId, pmid: pm_id, indexNo: '', isBinDeactivated: true });
      } else {
        this.setState({ isEdit: true, binid: BinId, pmid: pm_id, indexNo: '', isBinDeactivated: false });
      }
      if (
        searchedRxItems &&
        searchedRxItems.length > 0 &&
        this.state &&
        this.state.doesPrescriptionScanned
      ) {
        let obj = {
          bin_id: BinId,
          box_id: this.state && this.state.box_id,
          account_id: accountDetails && accountDetails.id,
        };
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          },
          body: JSON.stringify(obj),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((res) => {
            if (res && res.statusCode === 409) {
              this.setState({
                isVerifyingBin: true,
                isVerifyingBinMessage:
                  'This bin is currently unavailable, please select another bin.',
                loader: false,
              });
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      } else {
        let isMScript = false;
        if (
          accountDetails &&
          accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS
        ) {
          isMScript = true;
        }
        if (BinId === null && !isFastlaneGoliath) {
          searchedRxItems = [];
          this.setState({
            searchedRxNo: [],
            searchedItems: [],
            rxNumber: '',
            selected: [],
          });
          this.handleFocus();
          searchedRxItems = [];
        } else {
          const boxId = this.state.box_id;
          this.getPharmacyDetails(boxId);
          const bin_info = {
            id: boxId,
            bin_id: BinId,
            pm_id: pm_id,
            stock_code: stockCodeOverride || this.state.stockCode || null,
          };
          this.setState({ loader: true, reminderData: [] });
          fetch(process.env.REACT_APP_BASEURL + 'rxbybin', {
            method: 'POST',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession
                  .idToken.jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(bin_info),
          })
            .then((response) => {
              try {
                return response.json();
              } catch (error) {
                return null;
              }
            })
            .then((data) => {
              this.setState({ loader: false, doesBinClicked: true });
              const isFastlaneGoliath =
                this.state.boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
              const hasCustomers =
                data &&
                data.response &&
                data.response.box &&
                Array.isArray(data.response.box.customers) &&
                data.response.box.customers.length > 0;

              if (isFastlaneGoliath && !hasCustomers) {
                this.setState({
                  confirmPhantomRemoval: true,
                  isPhantomStockCodePrompt: true,
                  stockCode: '',
                });
                return;
              }
              if (data) {
                searchedRxItems = [];
                this.setState({
                  reminderData: { bin_info: bin_info, data: data },
                });
                let permissions = JSON.parse(
                  sessionStorage.getItem("permissions")
                );
                let _checkUserRole = JSON.parse(
                  sessionStorage.getItem("permissionUser")
                );
                if (_checkUserRole === userroles.SUPERADMIN) {
                  this.setState({ isVisibleForPause: true });
                } else {
                  const assignPrescriptions = permissions.filter((item) => {
                    return (
                      item.permission_entity_type === "Assign Prescription"
                    );
                  });
                  if (assignPrescriptions.length > 0) {
                    this.setState({ isVisibleForPause: assignPrescriptions.some((x) => x.name.trim() === "Hold/Resume" && x.is_allowed === 1) })
                  } else {
                    this.setState({ isVisibleForPause: false });
                  }
                }
                const details = data.response.box;
                if (details && details.customers.length > 0) {
                  const basicDetails = details && details.customers[0];
                  const orders = details && details.customers[0].orders[0];
                  const typeId = orders.type_id;
                  const stockcode = orders.stock_code;
                  const pickupcode = orders.pucode;
                  const rxItems = orders.items;
                  const orderId = details && details.customers[0].orders[0].id;
                  const rxNo =
                    details && details.customers[0].orders[0].items[0].rx_no;
                  const bindId = details && details.customers[0].orders[0].bin_id;
                  const contactDetails =
                    details && details.customers[0].contacts[0];
                  const locationDetails = orders && orders.customerLocations;

                  if (this.shouldShowBasicUI()) {
                    const mappedrxEntries = details && details.customers[0].orders[0].items.map(item => ({
                      rxNumber: item.rx_no,
                      isConsultRequired: item.is_consultrequire
                    }));
                    const boxData = this.state.boxdata
                    boxData && boxData.forEach((item) => {
                      if (this.state.box_id === item.id) {
                        const address = {
                          address1: item.address.address_line_1,
                          address2: item.address.address_line_2,
                          city: item.address.city,
                          state: item.address.state,
                          zip: item.address.zip,
                          country: item.address.country
                        };
                        this.setState({ address });
                      }
                    });
                    this.setState({
                      dateOfBirth: details && details.customers[0].dob_str,
                      rxEntries: mappedrxEntries,
                      isRxView: true
                    })
                  }
                  // Codes now fetched fresh from database before printing - no localStorage
                  this.setState({
                    stockCode: orders.stock_code,
                    pickupCode: orders.pucode,
                    locationDetails: locationDetails,
                    basicDetails: basicDetails,
                    contactDetails: contactDetails,
                    PrintisCoolItem: orders['is_cool_item'],
                    FutureRelease: orders['is_future_release'],
                    FutureReleaseDate: new Date(orders['future_release_date']),
                    selectedBox: data && data.response && data.response.box,
                    alternateAgents: basicDetails.alternetAgents,
                    assign_order_notes: orders['assign_order_notes'],
                    isBinLocked: orders.is_locked
                  });
                  this.setState({
                    EmailID: isMScript ? 'N/A' : contactDetails.email,
                    phone: isMScript ? 'N/A' : contactDetails.phone,
                  });
                  let address1;
                  let address2;
                  let city;
                  let state;
                  let zip;
                  let country;
                  if (locationDetails.length > 0) {
                    if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                      const boxData = this.state.boxdata;
                      boxData.forEach((item) => {
                        if (this.state.box_id === item.id) {
                          address1 = item.address.address_line_1;
                          address2 = item.address.address_line_2;
                          city = item.address.city;
                          state = item.address.state;
                          zip = item.address.zip;
                          country = item.address.country;
                        }
                      });
                    } else {
                      locationDetails.forEach((type) => {
                        if (this.state.locationtype_id === type.locationtype_id) {
                          address1 = type.addressline1;
                          address2 = type.addressline2;
                          city = type.city;
                          state = type.state;
                          zip = type.zip;
                          country = type.country;
                        }
                      });
                    }
                  } else {
                    if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                      const boxData = this.state.boxdata;
                      boxData.forEach((item) => {
                        if (this.state.box_id === item.id) {
                          address1 = item.address.address_line_1;
                          address2 = item.address.address_line_2;
                          city = item.address.city;
                          state = item.address.state;
                          zip = item.address.zip;
                          country = item.address.country;
                        }
                      });
                    }
                  }
                  if (typeId === DEVICE_TYPE.Hold) {
                    this.setState({ isAlreadyOnHold: true });
                  } else {
                    this.setState({ isAlreadyOnHold: false });
                  }
                  if (typeId === DEVICE_TYPE.Assigned) {
                    this.setState({ isAlreadyAssigned: true });
                  } else {
                    this.setState({ isAlreadyAssigned: false });
                  }
                  if (typeId === DEVICE_TYPE.Stocked) {
                    this.setState({ is_stocked: true });
                  } else {
                    this.setState({ is_stocked: false });
                  }
                  this.setState({
                    searchedItems: {
                      FirstName: basicDetails.first_name,
                      LastName: basicDetails.last_name,
                      DateOfBirth: basicDetails.dob_str,
                      MobileNo: isMScript
                        ? 'N/A'
                        : this.state && this.state.phone,
                      EmailID: isMScript
                        ? 'N/A'
                        : this.state && this.state.EmailID,
                      AddressLine1: address1,
                      AddressLine2: address2,
                      City: city,
                      State: state,
                      Zip: zip,
                      Country: country,
                      isCoolItem: orders && orders.is_cool_item,
                      notes: basicDetails.notes,
                      customer_id: basicDetails.customer_id || basicDetails.customerId || basicDetails.id,
                    },
                    rxNumber: rxNo,
                    selectedBinId: bindId,
                    stockCode: stockcode,
                    pickupCode: pickupcode,
                    orderId: orderId,
                    patientNotes: basicDetails.notes,
                    readOnly: true,
                    consultCheckBoxFlagForRxByBin: true
                  });
                  searchedRxItems = rxItems;
                  this.getPaymentDetails(orderId, basicDetails.id);
                }
                this.getCartRxNumbers();
                this.setState({ assignedPrescription: data.response.box, disableFeild: true });
                this.forceUpdate();
              }
            }).catch(() => {
              this.setState({ loader: false });
            });
        }
      }
    }
  };

  GetFormattedDate(dob) {
    var tempDate = new Date(dob);
    var formattedDate = ('0' + tempDate.getUTCDate()).slice(-2);
    var formattedMonth = ('0' + (tempDate.getUTCMonth() + 1)).slice(-2);
    var formattedYears = tempDate.getUTCFullYear();
    var dateString =
      formattedMonth + '/' + formattedDate + '/' + formattedYears;
    return dateString;
  }
  sendOrederStatusEmail(reqDetails) {
    fetch(process.env.REACT_APP_BASEURL + 'emailHoldStatus', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    }).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    })
    .then((data) => { console.log(JSON.stringify(data, null, 2)) })
    .catch(() => {
      this.setState({ loader: false });
    });
  }
  changeOrderStatus(status) {
    this.setState({ loader: true });
    let bin_info;
    let reqDetails = {};
    if (status === 'pause') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Hold,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: true,
      };
      this.sendOrederStatusEmail(reqDetails);
    } else if (status === 'play') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Stocked,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: false,
      };
      this.sendOrederStatusEmail(reqDetails);
    } else if (status === 'remove') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.RemoveRx,
      };
    }

    fetch(process.env.REACT_APP_BASEURL + 'updateStatusOfRx', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bin_info),
    })
      .then((response) => {
        try {
          if (
            bin_info.type_id === assignmentstatus.REMOVE_RX &&
            response.status === 200
          ) {
            const event_params = {
              event_name: EVENT_CRUD_TYPES.UPDATE,
              event_type_name: EVENT_TYPES.REMOVE_RX,
              description:
                'Prescription is Remove with stock code ' +
                this.state.stockCode,
              object_id: assignmentstatus.REMOVE_RX,
              tofor_id: this.state.orderId,
              box_id: this.state.box_id,
            };
            new EventLogHandler().handleEventLog(event_params);
          }
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        this.setState({ loader: false });
        const { t } = this.props;
        if (status === 'pause') {
          toast.success(t('Prescriptions.Messages.OnHold'));
        } else if (status === 'play') {
          toast.success(t('Prescriptions.Messages.NotOnHold'));
        } else if (status === 'remove') {
          toast.success(t('Prescriptions.Messages.RemovedRx'));
        }
        if (status !== 'play') {
          searchedRxItems = [];
          this.setState({
            selectedBinId: '',
            searchedItems: [],
            rxNumber: '',
            // box_id: "",
            isVisibleForPause: false,
            EmailID: '',
            phone: '',
            makeFastlaneAPICall: true,
            stockCode: '',
            pickupCode: ''
          });
          searchedRxNumbers = [];
        }
        this.setState({ isAlreadyOnHold: false });
        this.handleFocus();
        this.getBoxes();
        this.setState({ makeFastlaneAPICall: false })
      }).catch(() => {
        this.setState({ loader: false });
      });
  }

  getSelectedUnitName = (index) => {
    if (index === 1) {
      this.setState({ selectedUnitName: 'L60 (Locker Addon with 60 bins)' });
    } else if (index === 2) {
      this.setState({ selectedUnitName: 'HD36 (Locker Addon with 36 bins)' });
    } else if (index === 3) {
      this.setState({ selectedUnitName: 'Cool (Temp Controlled with 8 bins)' });
    }  else if (index === 4) {
      this.setState({ selectedUnitName: 'C30 (C30 with 30 bins)' });
    } else {
      this.setState({ selectedUnitName: 'Locker (Main Unit with 46 bins)' });
    }
  };

  getFormattedExpiryDate(expirydate) {
    let parsedDate;
    if (
      expirydate !== '' &&
      expirydate !== 'null' &&
      expirydate !== null &&
      expirydate !== undefined &&
      expirydate !== 'undefined'
    ) {
      let ExpiryDateyear = expirydate.substr(0, 4);
      let ExpiryDatemonth = expirydate.substr(5, 2);
      let ExpiryDateday = expirydate.substr(8, 2);
      parsedDate = ExpiryDatemonth + '/' + ExpiryDateday + '/' + ExpiryDateyear;
    } else {
      parsedDate = '';
    }
    return parsedDate;
  }

  handleConsultrequire = (index) => {
    if (!searchedRxItems || !searchedRxItems.length || searchedRxItems[index] == null) return;
    const item = searchedRxItems[index];
    const isCurrentlyRequired = item.ConsultRequire || item.is_consultrequire;
    if (isCurrentlyRequired) {
      this.setState({
        consultWaiveDialogOpen: true,
        consultWaiveIndex: index,
        consultWaiveReason: '',
      });
      return;
    }
    item.ConsultRequire = true;
    item.is_consultrequire = true;
    this.forceUpdate();
  };

  handleConsultWaiveConfirm = async () => {
    const { consultWaiveIndex, consultWaiveReason } = this.state;
    const { t } = this.props;
    const reason = (consultWaiveReason || '').trim();
    if (reason === '') {
      toast.error(t('Assign.ConsultWaive.ReasonLabel') || 'Reason is required');
      return;
    }
    if (!searchedRxItems || consultWaiveIndex == null || !searchedRxItems[consultWaiveIndex]) {
      this.setState({ consultWaiveDialogOpen: false, consultWaiveIndex: null, consultWaiveReason: '' });
      return;
    }
    const item = searchedRxItems[consultWaiveIndex];
    const rxNo = item.rxNo || item.rx_no || '';
    const drugName = item.name || item.drug_name || '';
    const prescriptionNumber = item.prescriptionNumber || item.prescriptionnumber || '';
    try {
      const auditDescription = `${t('Assign.ConsultWaive.AuditMessage', { defaultValue: 'Consult requirement canceled' })}. Rx: ${rxNo || '—'}, Prescription: ${prescriptionNumber || '—'}, Reason: ${reason}`;
      await writeAuditLog(
        auditDescription,
        'Consult Cancel',
        {
          rx_no: rxNo,
          drug_name: drugName,
          prescription_number: prescriptionNumber,
          reason,
        }
      );
    } catch (err) {
      console.error('Consult cancel audit log failed:', err);
    }
    item.ConsultRequire = false;
    item.is_consultrequire = false;
    item.consult_waive_reason = reason;
    this.setState({ consultWaiveDialogOpen: false, consultWaiveIndex: null, consultWaiveReason: '' });
    this.forceUpdate();
  };

  handleConsultWaiveCancel = () => {
    this.setState({ consultWaiveDialogOpen: false, consultWaiveIndex: null, consultWaiveReason: '' }, () => this.forceUpdate());
  };

  handleIsReturnable = (index) => {
    if (searchedRxItems && searchedRxItems.length > 0) {
      searchedRxItems[index].IsReturnable = !searchedRxItems[index].IsReturnable;
      this.forceUpdate();
    }
  }

  handleEpicChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  getActualRx = (rxNumber) => {
    if(rxNumber.startsWith("\\")) {
        rxNumber = rxNumber.substr(4, rxNumber.length - 1);
    } else if(rxNumber.startsWith("RX")){
        rxNumber = rxNumber.substr(3, rxNumber.length - 1);
    }
    return rxNumber;
  };

  parseCoreflexScript = (scannedQR) => {
    let parsedCoreFlexObject = {};
    let _removeIlb = scannedQR.split('?');
    let _findRxs = _removeIlb[1].split('&');
    let _s = _findRxs[3].split('=')[1];
    parsedCoreFlexObject.key = _findRxs[0].split('=')[1];
    parsedCoreFlexObject.v = _findRxs[1].split('=')[1];
    parsedCoreFlexObject.d = _findRxs[2].split('=')[1];
    parsedCoreFlexObject.s = _s.split('#').filter((el) => el);
    return parsedCoreFlexObject;
  };

  verifyScriptIsCoreflexOrNotAndSaveEntryForHistory = async (scannedQR) => {
    // LEON Medical Coreflex Sample Script
    // ilb://?key=client&v=1.0&d=04/04/2020&s=10-1217253#10-1217254#
    let _parsedResponse = {};
    let _parsedRx = this.parseCoreflexScript(scannedQR);
    _parsedResponse.pharmacyNCPDPId = '';
    _parsedResponse.fillId = '';
    _parsedResponse.prescriptionNumber = _parsedRx.s;
    return _parsedResponse;
  };

  parseScannedQrCode = async (scannedQR, account_id) => {
    let _scannedQRCode = scannedQR;
    let _parsedResponse = {};
    if (scannedQR.length > 40) {
      if (scannedQR.startsWith('ilb') || scannedQR.includes('key')) {
        _parsedResponse = await this.verifyScriptIsCoreflexOrNotAndSaveEntryForHistory(
          scannedQR
        );
      } else {
        let arrayOfRxNumber = [];
        let splitByCarrotSign = _scannedQRCode.split('^');
        let actualRxNumber = this.getActualRx(splitByCarrotSign[0]);
        arrayOfRxNumber.push(actualRxNumber);
        _parsedResponse.prescriptionNumber = arrayOfRxNumber;
        _parsedResponse.pharmacyNCPDPId = splitByCarrotSign[splitByCarrotSign.length - 8];
        _parsedResponse.fillId = splitByCarrotSign[5];
        _parsedResponse.is_coreFlex = false;      
      }
    } else {
      _parsedResponse = await this.verifyScriptIsCoreflexOrNotAndSaveEntryForHistory(
        scannedQR
      );
    }
    console.log(
      `Parsed Response for EPIC script : ${JSON.stringify(
        _parsedResponse,
        null,
        2
      )}`
    );
    return _parsedResponse;
  };

  checkIfRxExistOrNot = async (rxTransactionNumber) => {
    let response = {};
    return fetch(
      process.env.REACT_APP_BASEURL +
      'epic/checkpoint/epic/rxno-fillid/' +
      rxTransactionNumber,
      {
        method: 'get',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((checkResponse) => {
        if (checkResponse) {
          let parsedJsonResponse = JSON.parse(checkResponse);
          if (
            parsedJsonResponse &&
            parsedJsonResponse.res &&
            parsedJsonResponse.res.status === 200
          ) {
            response.error = parsedJsonResponse.res.message;
            response.result = true;
            return response;
          } else {
            response.error = '';
            response.result = false;
            return response;
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  checkIfRxExistorNotForEpicWithmTLS = async (rxTransactionNumber) => {
    let response = {};
    return fetch(
      process.env.REACT_APP_BASEURL +
      'kp/epic/mtls/checkpoint/epic/rxno-fillid/' +
      rxTransactionNumber,
      {
        method: 'get',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((checkresponse) => {
        if (checkresponse) {
          let parsedJsonResponse = JSON.parse(checkresponse);
          if (
            parsedJsonResponse &&
            parsedJsonResponse.res &&
            parsedJsonResponse.res.status === 200
          ) {
            response.error = parsedJsonResponse.res.message;
            response.result = true;
            return response;
          } else {
            response.error = '';
            response.result = false;
            return response;
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  isRxExistInCart = async (searchedString, patientDetails, items) => {
    const { globalAccountConnection } = this.state;
    let connectionType;
    switch (globalAccountConnection.account_connections_id) {
      case CONNECTION_TYPE.EPIC:
        connectionType = 'Epic';
        break;
      case CONNECTION_TYPE.EPIC_WITH_MTLS:
        connectionType = 'Epic With MTLS';
        break;
      default:
        break;
    }
    let _existingPrescriptionNumbers = [];
    let existingRxNo =
      globalAccountConnection &&
      globalAccountConnection.vial_label_scan &&
      globalAccountConnection.vial_label_scan === true
        ? await this.parseScannedQrCodeForVialLabelScan(searchedString)
        : await this.parseScannedQrCode(searchedString);
    if (
      Array.isArray(
        existingRxNo &&
          existingRxNo.prescriptionNumber &&
          existingRxNo.prescriptionNumber
      )
    ) {
      if (
        existingRxNo &&
        existingRxNo.prescriptionNumber &&
        existingRxNo.prescriptionNumber.length > 0
      ) {
        const _existingRxItems = existingRxNo.prescriptionNumber;
        for (let exist = 0; exist < _existingRxItems.length; exist++) {
          for (let si = 0; si < searchedRxItems.length; si++) {
            if (
              _existingRxItems[exist].trim() ===
                searchedRxItems[si].prescriptionNumber &&
              existingRxNo.fillId === searchedRxItems[si].fillNumber
            ) {
              _existingPrescriptionNumbers.push(_existingRxItems[exist].trim());
            }
          }
        }
      }
    } else {
      const _existingRxItems = existingRxNo.prescriptionNumber;
      for (let si = 0; si < searchedRxItems.length; si++) {
        if (
          _existingRxItems.trim() ===
            searchedRxItems[si].prescriptionNumber &&
          existingRxNo.fillId === searchedRxItems[si].fillNumber
        ) {
          _existingPrescriptionNumbers.push(_existingRxItems.trim());
        }
      }
    }
    if (_existingPrescriptionNumbers.length > 0) {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers.join(
          ','
        )} are already exist in the cart!`,
      });
      return true;
    } else {
      let itemsdetail;
      let validRxScripts = this.validateRxFills(items);
      if (
        validRxScripts &&
        validRxScripts.validRxItems &&
        validRxScripts.validRxItems.length > 0
      ) {
        itemsdetail = validRxScripts.validRxItems;
      } else {
        itemsdetail = validRxScripts.inValidRxItems;
      }
      for (let i = 0; i < itemsdetail.length; i++) {
        searchedRxItems.push(itemsdetail[i]);
      }
      this.checkADACompatible(
        patientDetails.MedicalRecordNumber,
        patientDetails.EmailAddress
      );
      this.getcustomerLocation(patientDetails, itemsdetail, connectionType);
      this.forceUpdate();
      this.setState({
        rxNumber: '',
        loader: false,
      });
    }
  };

  isSamePatient = (patientDetails) => {
    const { searchedItems } = this.state;
    if (searchedItems.PatientID === patientDetails.MedicalRecordNumber) {
      this.setState({
        EmailID: patientDetails.EmailAddress,
        phone: patientDetails.MobilePhone,
      });
      return true;
    } else {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The scanned or entered prescription has different patient details. Please assign this prescription to any bin first then scan or enter another prescription!`,
      });
      return false;
    }
  };

  handleEpicKeyDown = (event) => {
    // if (event.keyCode === 13) {
      this.setState({
        loader: true,
        isEpicHasValidRx: true,
        isEpicHasValidRxMessage: '',
        isEdit: false,
      });
      const { originalScannedScript } = this.state;
      let searchedString = originalScannedScript;
      let validItems = [];
      let items = [];
      let obj = {
        PrescriptionId: searchedString,
        account_id: this.state.accountDetails.id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'epic/GetPrescriptionInfoById', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then(async (res) => {
          let parsedJsonResponse = JSON.parse(res);
          let parsedJson;
          if (parsedJsonResponse && parsedJsonResponse.message) {
            this.setState({
              loader: false,
              rxNumber: '',
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
            });
            return;
          }
          parsedJson = parsedJsonResponse.response;
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.prescriptions;
          if (prescriptionDetails.length <= 0) {
            toast.error(this.props.t('Toast.Error.Prescription'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              let _existingPrescriptionNumbers = [];
              if (
                prescriptionDetails &&
                prescriptionDetails.length &&
                prescriptionDetails.length > 0
              ) {
                for (let i = 0; i < prescriptionDetails.length; i++) {
                  let preacriptionNumber = prescriptionDetails[i].PrescriptionNumber.trim();
                  for (let si = 0; si < searchedRxItems.length; si++) {
                    let fillNumber = prescriptionDetails[i].Fill[i].Id;
                    if (
                      preacriptionNumber ===
                      searchedRxItems[si].prescriptionNumber && fillNumber === searchedRxItems[si].fillNumber
                    ) {
                      _existingPrescriptionNumbers.push(preacriptionNumber);
                    }
                  }
                }
              }
              if (
                _existingPrescriptionNumbers &&
                _existingPrescriptionNumbers.length &&
                _existingPrescriptionNumbers.length > 0
              ) {
                this.setState({
                  loader: false,
                  rxNumber: '',
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers} are already exist in the cart!`,
                });
                return true;
              }
            }
          }
          for (let j = 0; j < prescriptionDetails.length; j++) {
            let isconsultrequired = false;
            let isreturnable = false;
            if([true, "true"].includes(this.state.accountDetails.bypass_consult)){
              isconsultrequired = false;
            } else if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsConsultRequired === true
            ) {
              isconsultrequired = prescriptionDetails[j].IsConsultRequired;
            } else {
              isconsultrequired = false;
            }
            console.log(isconsultrequired, "isconsultrequired");
            //check for isreturnable feild in fetched prescriptions
            if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsReturnable === true
            ) {
              isreturnable = prescriptionDetails[j].IsReturnable;
            } else {
              isreturnable = false;
            }
            for (let i = 0; i < prescriptionDetails[j].Fill.length; i++) {
              let item = {
                ndcCode: prescriptionDetails[j].Fill[i].Ndc,
                itemId: '',
                binId: '',
                rxNo: prescriptionDetails[j].Fill[i].PrescriptionId,
                name: prescriptionDetails[j].Medication,
                description: prescriptionDetails[j].Sig,
                image: '',
                potency: '',
                qty: prescriptionDetails[j].Fill[i].Quantity,
                schedule: prescriptionDetails[j].Frequency,
                Amount: prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                taxPercentage: '',
                insuranceAmount: '',
                CoPayAmount:
                  prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                PaidAmount: '',
                DueAmount: '',
                paymentDueDate: '',
                stockedOn: '',
                stockedBy: '',
                deStockedOn: '',
                strength: '',
                route: '',
                doseage_form: '',
                non_proprietary_name: '',
                ExpirationDate: '',
                isLoadingTrans: false,
                fillNumber: prescriptionDetails[j].Fill[i].Id,
                prescriptionNumber:
                  prescriptionDetails[j].Fill[i].PrescriptionNumber,
                ConsultRequire: isconsultrequired,
                IsReturnable: isreturnable,
                status: prescriptionDetails[j].Fill[i].Status,
                is_controlled_substance: prescriptionDetails[j].isControlledSubstances,
                // Add flags and blocking reasons for informational display
                Flags: prescriptionDetails[j].Fill[i].Flags || [],
                CannotDispenseReasons: prescriptionDetails[j].Fill[i].CannotDispenseReasons || [],
                IsDispensable: prescriptionDetails[j].Fill[i].IsDispensable,
                // Prescription-level flags
                PrescriptionFlags: prescriptionDetails[j].AllFlags || prescriptionDetails[j].Flags || [],
                ReasonNotFillable: prescriptionDetails[j].ReasonNotFillable
              };
              let rxTransactionNumber = `${prescriptionDetails[j].Fill[i].PrescriptionId}-${prescriptionDetails[j].Fill[i].Id}`;
              if (
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'verified' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'readytodispense' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'intransit' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'received'
              ) {
                const isRxTrasactionNumberExist = await this.checkIfRxExistOrNot(
                  rxTransactionNumber
                );
                if (
                  isRxTrasactionNumberExist &&
                  isRxTrasactionNumberExist.result === true
                ) {
                  toast.error(isRxTrasactionNumberExist.error);
                  this.setState({
                    rxNumber: '',
                    loader: false,
                    EmailID: '',
                    phone: '',
                    isEpicHasValidRx: true,
                    isEpicHasValidRxMessage: '',
                  });
                  return;
                } else {
                  items.push(item);
                  if (
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'verified' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'readytodispense' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'intransit' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'received'
                  ) {
                    validItems.push(prescriptionDetails[j].Fill[i]);
                  }
                  if (validItems.length > 0) {
                    prescriptionDetails[j].Fill[i] = validItems;
                  }
                }
              } else {
                items.push(item);
              }
            }
          }
          if (items && items.length === 0) {
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              this.isRxExistInCart(searchedString, patientDetails, items);
            }
          } else {
            this.setState({
              EmailID: patientDetails.EmailAddress,
              phone: patientDetails.MobilePhone,
            });
            let RxItems = this.validateRxFills(items);
            if (
              RxItems &&
              RxItems.validRxItems &&
              RxItems.validRxItems.length > 0
            ) {
              searchedRxItems = RxItems.validRxItems;
            } else {
              searchedRxItems = RxItems.inValidRxItems;
              let errorArray = [];
              if (searchedRxItems && searchedRxItems.length > 0) {
                for (
                  let invalid = 0;
                  invalid < searchedRxItems.length;
                  invalid++
                ) {
                  errorArray.push({ Status: searchedRxItems[invalid].status });
                }
                this.setState({
                  loader: false,
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The status of the prescription
                  should be Verified, ReadyToDispense, Received or InTransit but the ${errorArray && errorArray.length > 1
                      ? 'statuses are'
                      : 'status is'
                    } ${errorArray &&
                    errorArray.map((x) => x.Status).join(', ')}`,
                });
              }
            }
            this.checkADACompatible(
              patientDetails.MedicalRecordNumber,
              patientDetails.EmailAddress
            );
            this.getcustomerLocation(patientDetails, searchedRxItems, 'Epic');
            this.forceUpdate();
            this.setState({
              rxNumber: '',
              loader: false,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            loader: false,
            rxNumber: '',
            isEpicHasValidRx: false,
            isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
          });
          return;
        });
    // }
  };

  validateRxFills = (items) => {
    let _validRxItemArray = [];
    let _inValidRxItemArray = [];
    let validatedRxFills = {};
    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        if (
          items[i].status.toLowerCase() === 'verified' ||
          items[i].status.toLowerCase() === 'readytodispense' ||
          items[i].status.toLowerCase() === 'received' ||
          items[i].status.toLowerCase() === 'intransit'
        ) {
          _validRxItemArray.push(items[i]);
        } else {
          _inValidRxItemArray.push(items[i]);
        }
      }
    }
    validatedRxFills.validRxItems = _validRxItemArray;
    validatedRxFills.inValidRxItems = _inValidRxItemArray;
    return validatedRxFills;
  };

  getDueAmount = () => {
    let orderAmount = 0;
    for (let i = 0; i < searchedRxItems.length; i++) {
      if (
        !isNaN(
          parseFloat(searchedRxItems[i].CoPayAmount) ||
          parseFloat(searchedRxItems[i].price)
        )
      ) {
        let amount =
          parseFloat(searchedRxItems[i].CoPayAmount) ||
          parseFloat(searchedRxItems[i].price);
        orderAmount = orderAmount + amount;
      }
    }
    return `$${orderAmount.toFixed(2)}`;
  };
  getBinAssignments = () => {
    // Get bin assignments from BinStatus or searchedItems
    const { BinStatus, searchedItems, pickupCode } = this.state;
    const assignments = [];

    if (BinStatus && BinStatus.length > 0) {
      BinStatus.forEach((bin) => {
        if (bin.customer_name) {
          assignments.push({
            name: bin.customer_name,
            bin: bin.bin_id || bin.id,
            status: bin.status === 'assigned' || bin.status === 'stocked',
            puCode: bin.pucode || pickupCode,
          });
        }
      });
    } else if (searchedItems && searchedItems.first_name) {
      // If we have patient info but no bin status, show patient with selected bin
      assignments.push({
        name: `${searchedItems.first_name || ''} ${searchedItems.last_name || ''}`.trim(),
        bin: this.state.selectedBinId || this.state.binid || '',
        status: !!this.state.selectedBinId || !!this.state.binid,
        puCode: pickupCode,
      });
    }

    return assignments;
  };

  getPaymentDetails = (orderId, customerId) => {
    this.setState({ loader: true });
    fetch(
      `${process.env.REACT_APP_BASEURL}payments/validate-payment?order_id=${orderId}&customer_id=${customerId}`,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ isAmountPaid: data.res, loader: false });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };
  getcustomerLocation = (patient, items, type) => {
    const { 
      phone, 
      EmailID, 
      boxDetails 
    } = this.state;
    let parsedDob = '', 
    AddressLine1 = '', 
    AddressLine2 = '', 
    City = '', 
    State = '', 
    Zip = '', 
    Country = '', 
    phoneNumber = '', 
    emailAddress = '',
    boxId = this.state.box_id;
    this.generateCodes();
    let locationDetails = boxDetails.filter((x) => x.id === boxId)[0];
    if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
      AddressLine1 = locationDetails.address_line_1 || "";
      AddressLine2 = locationDetails.address_line_2 || "";
      City = locationDetails.city || "";
      State = locationDetails.state || "";
      Zip = locationDetails.zip || "";
      Country = locationDetails.country || "";
    }
    if (type === 'Epic' || type === 'Epic With MTLS') {
      parsedDob = patient.DateOfBirth.substr(5, 2) + '/' + patient.DateOfBirth.substr(8, 2) + '/' + patient.DateOfBirth.substr(0, 4);
      phoneNumber = phone;
      emailAddress = EmailID;
      if (patient.EmailAddress === '' || EmailID === '') {
        toast.error(this.props.t('Toast.Error.EnterEmail'));
        this.setState({ loader: false });
      }
      if (patient.MobilePhone === '' || phone === '') {
        toast.error(this.props.t('Toast.Error.EnterMobile'));
        this.setState({ loader: false });
      }
    } else if (type === 'Pioneer') {
      parsedDob = patient.dateOfBirth.substr(5, 2) + '/' + patient.dateOfBirth.substr(8, 2) + '/' + patient.dateOfBirth.substr(0, 4);
      phoneNumber = phone;
      emailAddress = EmailID;
    } else if (type === 'Medbank') {
      parsedDob = patient.dob_str || patient.dateOfBirth;
      phoneNumber = phone;
      emailAddress = EmailID;
    } else if (type === 'MScripts') {
      parsedDob = patient.dob_str || patient.dateOfBirth || patient.dob;
      phoneNumber = 'N/A';
      emailAddress = 'N/A'
    } else if (type === 'McKesson') {
      parsedDob = patient.DateOfBirth
      phoneNumber = patient.MobilePhoneWithoutAreaCode;
      emailAddress = patient.EmailAddress;
    } else if (type === 'LIBERTYSOFTWARE') {
      parsedDob = patient.dob_str;
      phoneNumber = patient.phone;
      emailAddress = patient.email;
    }  else if (type === 'HL7') {
      parsedDob = patient.dob_str || patient.dateOfBirth || patient.dob;
    } else if(type === 'DRX') {
      parsedDob = patient.dob.substr(5, 2) + '/' + patient.dob.substr(8, 2) + '/' + patient.dob.substr(0, 4);
      phoneNumber = patient.phone;
      emailAddress = patient.email;
    } else if (type === 'PrimeRx') {
      console.log(patient, 'patient');
      parsedDob = patient.dob_str || patient.dateOfBirth || patient.dob;
      phoneNumber = patient.phone;
      emailAddress = patient.email;
    } else {
      parsedDob = patient.DateOfBirth;
      phoneNumber = phone;
      emailAddress = EmailID;
    }
    const basicDetails = {
      first_name: patient.FirstName,
      last_name: patient.LastName,
      dob_str: patient.DateOfBirth,
    };
    const contactDetails = {
      phone: phoneNumber,
      email: emailAddress,
    };
    this.setState({
      locationtype_id: localStorage.getItem('selectedLocationTypeId'),
      box_id: boxId,
      searchedItems: {
        PatientID: patient.PatientID || patient.MedicalRecordNumber || patient.patient_id || patient.patientID || patient.ExternalPatientID,
        customer_id: patient.customer_id || patient.customerId,
        FirstName: patient.FirstName || patient.first_name || patient.firstName,
        LastName: patient.LastName || patient.last_name || patient.lastName,
        MiddleName: patient.MiddleName || null,
        DateOfBirth: parsedDob,
        MobileNo: phoneNumber,
        EmailID: emailAddress,
        AddressLine1: AddressLine1,
        AddressLine2: AddressLine2,
        City: City,
        State: State,
        Zip: Zip,
        Country: Country,
        notes: (patient && patient.notes) || '',
        orders: [{ items: Array.isArray(items) ? items : [items] }],
      },
      patientNotes: (patient && patient.notes),
      basicDetails: basicDetails,
      contactDetails: contactDetails
    });
  };

  reminderHandler = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'reminder/notification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.state.reminderData),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ searchedRxNo: [] });
          toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
        }
        try {
          return response.text();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((uData) => {
        this.setState({ loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  textInputHandler = (type, value) => {
    this.setState({ [type]: value });
  };

  ManualPickupNotification = (type) => {
    let reqDetails = {
      box_id: this.state.box_id,
      pucode: this.state.pickupCode,
      emailID:
        this.state.searchedItems.EmailID || (this.state && this.state.EmailID),
      firstName: this.state.searchedItems.FirstName,
      lastName: this.state.searchedItems.LastName,
      AccountName: this.state.accountDetails && this.state.accountDetails.name,
      AccountAddress:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.address_line_1 +
        ' ' +
        this.state.accountDetails.contact.address.address_line_2 +
        ' ',
      AccountAddress2:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.city +
        ', ' +
        this.state.accountDetails.contact.address.state +
        ' ' +
        this.state.accountDetails.contact.address.zip,
    };
    if (type === 1) {
      this.changeOrderStatus('remove');
    }
    if (type === 2) {
      this.changeOrderStatus('pause');
    }
    if (type === 3) {
      this.changeOrderStatus('play');
    }
    fetch(process.env.REACT_APP_BASEURL + 'emailPickupNotification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ searchedRxNo: [] });
          toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
        }
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.getBoxes();
        searchedRxItems = [];
        searchedRxNumbers = [];
        this.setState({
          selectedBinId: '',
          searchedItems: [],
          rxNumber: '',
        });
        this.handleFocus();
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  ClearFields = () => {
    searchedRxItems = [];
    searchedRxNumbers = [];
    this.setState({
      selectedBinId: '',
      openMessage: false,
      locationData: null,
      disableFeild: false,
      stockCode: '',
      pickupCode: '',
      searchedRxNo: [],
      prescriptionMasterData: {},
      rxNumber: '',
      selected: [],
      box: [],
      hasError: false,
      // box_id: '',
      pharmacyDetails: {},
      accountDetails: {},
      BinStatus: [],
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      loader: false,
      expansionUnits: [],
      box_expansions_id: '',
      isLoadingTrans: false,
      servePresRetryCount: 3,
      servePresFetchCount: 0,
      isRetrying: false,
      isADACompatible: false,
      ConsultRequire: false,
      is_returnable: false,
      isAmountPaid: false,
      locationtype_id: '',
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: '',
      EmailID: '',
      phone: '',
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      AccountConnections: [],
      location: '',
      isUnplugged: false,
      boxDetails: [],
      globalAccountConnection: {},
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      storage_location: '',
      location_notes: '',
      searchedItems: [],
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      basicDetails: undefined,
      isEdit: false,
      selectedObject: [],
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedAccountIdForPrescriptionCheck: null,
      doesPrescriptionScanned: false,
      selectedPMSType: "",
      confirmPMSDialogOpen: false,
      scannedRxScript: "",
      originalScannedScript: "",
      boxTypeId: '',
      allow_multi_bins_pickup: false,
      FutureRelease: false,
      FutureReleaseDate: null,
      patientNotes: '',
      readOnly: true,
      isBinDeactivated: false,
      alternateAgents: [],
      doesBinClicked: false,
      confirmPhantomRemoval: false,
      isPhantomStockCodePrompt: false,
      isManualOverridePermissionEnabled: true,
      prescriptionUnAssign: true,
      prescriptionAssign: true,
      prescriptionView: true,
      prescriptionDirectPickup: true,
      prescriptionRemind: true,
      prescriptionConsult: true,
      prescriptionHoldResume: true,
      prescriptionAcDc: true,
      assign_order_notes: '',
      rxEntries: [
        { rxNumber: '', isConsultRequired: false }
      ],
      dateOfBirth: '',
      address: null,
      isRxView: false,
      dobError: false,
      phoneError: false,
      rxError: false,
      printTicketPermissionAllowed: false,
      htmlBodyToPrint: '',
      openPrintDialog: false,
      fastlaneBinRetryCount: 0,
      isFastlaneRetrying: false,
      fastlaneRetryMessage: '',
      fastlaneBinFetchError: false,
      fastlaneBinValidationError: false,
      pendingSaveMode: null
    });
    this.GetAcccountConnectionId();
    this.getLocationTypes();
    this.setPermission();
    if (this.phoneInputRef && this.phoneInputRef.current) {
      this.phoneInputRef.current.focus();
    }
  };

  onInputChange = (event) => {
    const { searchedItems } = this.state;
    searchedItems[event.target.name] = event.target.value;
    this.setState({ [event.target.name]: event.target.value, searchedItems });
  };
  handleConsultClick = () => {
    this.setState({ detailDialogOpen: true });
  };

  handleConsultClose = () => {
    this.setState({ detailDialogOpen: false });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  onSearchChange = (event) => {
    const searchString = event.target.value;
    this.setState({
      searchObj: { ...this.state.searchObj, searchTxt: searchString },
    });
    if (searchString.length > 2) {
      this.FetchSearchResult();
    } else {
      searchedRxItems = [];
      searchedRxNumbers = [];
      this.setState({
        selectedBinId: '',
        searchedItems: [],
        rxNumber: '',
        isVisibleForPause: false,
        EmailID: '',
        phone: '',
        isEpicHasValidRx: true,
        isEpicHasValidRxMessage: '',
      });
    }
  };

  FetchSearchResult = () => {
    let FilterObj = {
      searchtext: this.state.searchObj.searchTxt,
      pageNo: this.state.searchObj.pageNo,
      pageSize: this.state.searchObj.pageSize,
      sortOrder: this.state.searchObj.sortOrder,
    };
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getPrescriptionSearchResult', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(FilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({
          totalSearchRecords: uData && uData['total'],
          loader: false,
          innerSearchLoader: false,
        });
        if (
          uData &&
          Array.isArray(uData['results']) &&
          uData['results']['length'] > 0
        ) {
          if (uData['results']['length'] === 1) {
            let BinId = uData['results'][0].bin_id;
            let pm_id = uData['results'][0].pm_id;
            let stockCode = uData['results'][0].stock_code;
            this.getPrescriptionDetails(BinId, pm_id, stockCode);
          } else
            this.setState({
              selectedObject: uData['results'],
              SearchResultDialogOpen: true,
            });
        } else {
          searchedRxItems = [];
          searchedRxNumbers = [];
          this.setState({
            selectedBinId: '',
            searchedItems: [],
            rxNumber: '',
            isVisibleForPause: false,
            EmailID: '',
            phone: '',
            isEpicHasValidRx: true,
            isEpicHasValidRxMessage: '',
            SearchResultDialogOpen: false,
            innerSearchLoader: false,
            searchObj: { pageNo: 0, pageSize: 10, sortOrder: 'desc' },
          });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleSearchClose = (event) => {
    event.preventDefault();
    this.setState({
      SearchResultDialogOpen: false,
      selectedObject: [],
      innerSearchLoader: false,
      searchObj: { searchTxt: '', pageNo: 0, pageSize: 10, sortOrder: 'desc' },
    });
  };

  handlePUcodeClick = (event, BinId, pm_id, boxid, stockCode = null) => {
    event.preventDefault();
    this.getPharmacyDetails(boxid);
    this.getExpansionBins(boxid);
    this.getAssignedBins(boxid);
    this.setState({ box_id: boxid });
    setTimeout(() => {
      this.handleSearchClose(event);
      this.getPrescriptionDetails(BinId, pm_id, stockCode);
    }, 100);
  };

  handleMedBankChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleMedBankKeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      let isRxExist = false;
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        rxNumber: searchedString,
      };
      fetch(`${process.env.REACT_APP_BASEURL}medbank/is-exist`, {
        method: 'post',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedResponse = JSON.parse(res);
          isRxExist = parsedResponse.Rx_Is_Exist;
          if (isRxExist === false || isRxExist === 'false') {
            let obj = {
              lookupValue: searchedString,
              account_id: globalAccountConnection.id,
            };
            fetch(
              process.env.REACT_APP_BASEURL +
              'medbank/GetPrescriptionByPrescriptionNumber',
              {
                crossDomain: true,
                method: 'post',
                headers: {
                  Authorization:
                    'Bearer ' +
                    JSON.parse(sessionStorage.getItem('user')).signInUserSession
                      .idToken.jwtToken,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(obj),
              }
            )
              .then((response) => {
                try {
                  return response.text();
                } catch (error) {
                  return null;
                }
              })
              .then((res) => {
                let parsedJson = JSON.parse(res);
                let patientDetails = parsedJson.patient;
                let prescriptionDetails = parsedJson.Rxs;
                if (prescriptionDetails && prescriptionDetails.length === 0) {
                  toast.error(this.props.t('Toast.Error.RxFound'));
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                  return;
                }
                let isreturnable = false
                for (let i = 0; i < prescriptionDetails.length; i++) {
                  if (
                    prescriptionDetails[i] &&
                    prescriptionDetails[i].IsReturnable === true
                  ) {
                    isreturnable = prescriptionDetails[i].IsReturnable;
                  } else {
                    isreturnable = false;
                  }
                  let item = {
                    ndcCode: prescriptionDetails[i].dispensedNDC,
                    itemId: '',
                    binId: '',
                    rxNo: prescriptionDetails[i].PrescriptionNumber,
                    name: prescriptionDetails[i].dispensedDrugName,
                    description: prescriptionDetails[i].dispensedDrugName,
                    image: '',
                    potency: '',
                    qty: prescriptionDetails[i].prescribedQuantity,
                    schedule: '',
                    Amount: prescriptionDetails[i].dispensedAmount,
                    taxPercentage: '',
                    insuranceAmount: '',
                    CoPayAmount: prescriptionDetails[i].dispensedAmount,
                    PaidAmount: '',
                    DueAmount: '',
                    paymentDueDate: '',
                    stockedOn: '',
                    stockedBy: '',
                    deStockedOn: '',
                    strength: '',
                    route: '',
                    doseage_form: '',
                    non_proprietary_name: '',
                    ExpirationDate: '',
                    isLoadingTrans: false,
                    fillNumber: prescriptionDetails[i].fillNumber,
                    prescriptionNumber:
                      prescriptionDetails[i].PrescriptionNumber,
                    ConsultRequire: prescriptionDetails[i].promptForCounseling,
                    IsReturnable: isreturnable,
                    status: '',
                  };
                  const existingItem = this.state.searchedItems;
                  const EmailAddress =
                    (patientDetails && patientDetails.email) ||
                    (patientDetails &&
                      patientDetails.contacts &&
                      patientDetails.contacts[0] &&
                      patientDetails.contacts[0].email);
                  const CellPhone =
                    (patientDetails && patientDetails.sms_phone) ||
                    (patientDetails &&
                      patientDetails.contacts &&
                      patientDetails.contacts[0] &&
                      patientDetails.contacts[0].phone);
                  this.setState({ EmailID: EmailAddress, phone: CellPhone });
                  if (
                    existingItem &&
                    searchedRxItems &&
                    searchedRxItems.length > 0
                  ) {
                    let isexist = searchedRxItems.findIndex(
                      (x) => x.rxNo === searchedString
                    );
                    if (existingItem.PatientID === patientDetails.patientID) {
                      if (isexist < 0) {
                        searchedRxItems.push(item);
                        if (
                          patientDetails &&
                          patientDetails.patientID &&
                          EmailAddress
                        ) {
                          this.checkADACompatible(
                            patientDetails.patientID,
                            EmailAddress
                          );
                        }
                        this.getcustomerLocation(
                          patientDetails,
                          searchedRxItems,
                          'Medbank'
                        );
                        this.setState({
                          rxNumber: '',
                        });
                        this.forceUpdate();
                      } else {
                        toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                        this.setState({
                          rxNumber: '',
                          loader: false,
                        });
                      }
                    } else {
                      toast.error(this.props.t('Toast.Error.WrongPatient'));
                      this.setState({
                        rxNumber: '',
                        loader: false,
                      });
                    }
                  } else {
                    searchedRxItems.push(item);
                    if (
                      patientDetails &&
                      patientDetails.patientID &&
                      EmailAddress
                    ) {
                      this.checkADACompatible(
                        patientDetails.patientID,
                        EmailAddress
                      );
                    }
                    this.getcustomerLocation(
                      patientDetails,
                      searchedRxItems,
                      'Medbank'
                    );
                    this.forceUpdate();
                    this.setState({
                      rxNumber: '',
                      loader: false,
                    });
                  }
                }
              }).catch(() => {
                this.setState({ loader: false });
              });
          } else {
            toast.error(this.props.t('Toast.Error.RxExist'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
          }
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  handleMScriptsOnChange = (e) => {
    const scannedValue = e.target.value;
    const cleanedValue = String(scannedValue).replace(/^0+/, ""); 
    
    this.setState(
      {
        rxNumber: cleanedValue,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };
  handleMScriptsKeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      let isRxExist = false;
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        lookupValue: searchedString,
        account_id: globalAccountConnection.id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'orders/lookup', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedJson = JSON.parse(res);
          if (
            parsedJson &&
            parsedJson.status &&
            parsedJson.status.toLowerCase() === 'failed'
          ) {
            toast.error(parsedJson.error_message);
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.order_details;
          if([false, 'false'].includes(patientDetails && patientDetails._isOrderFound)) {
            toast.error("This order may not be deliverable.", {
              autoClose: 5000,
              progress: undefined,
              hideProgressBar: false,
            });
          }
          let isreturnable = false
          if (
            prescriptionDetails &&
            prescriptionDetails.IsReturnable === true
          ) {
            isreturnable = prescriptionDetails.IsReturnable;
          } else {
            isreturnable = false;
          }
          if (!prescriptionDetails) {
            toast.error(this.props.t('Toast.Error.RxFound'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          } else {
            let item = {
              ndcCode: prescriptionDetails.ndc,
              itemId: '',
              binId: '',
              // rxNo: prescriptionDetails.rx_num,
              rxNo: '',
              name: prescriptionDetails.name,
              description: '',
              image: '',
              potency: '',
              qty: prescriptionDetails.dispensed_qty,
              schedule: '',
              Amount: prescriptionDetails.amount_due,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: prescriptionDetails.amount_due,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: prescriptionDetails.expiry_date,
              isLoadingTrans: false,
              fillNumber: prescriptionDetails.fill_number,
              prescriptionNumber: prescriptionDetails.rx_num,
              ConsultRequire:
                [true, "true"].includes(this.state.accountDetails.bypass_consult)
                  ? false
                  : ((prescriptionDetails && prescriptionDetails.fill_number === 0) ||
                     (prescriptionDetails && prescriptionDetails.fill_number === '0')),
              IsReturnable: isreturnable,
              status: '',
              order_id: parsedJson.order_id,
              prescription_txn_id: prescriptionDetails.prescription_txn_id,
            };
            let objIsExist = {
              rxNumber: item.prescription_txn_id,
              account_id: globalAccountConnection.id,
            };
            fetch(`${process.env.REACT_APP_BASEURL}is-rx-exists`, {
              method: 'post',
              withCredentials: true,
              headers: {
                'Content-Type': 'application/json',
                Authorization:
                  'Bearer ' +
                  JSON.parse(sessionStorage.getItem('user')).signInUserSession
                    .idToken.jwtToken,
              },
              body: JSON.stringify(objIsExist),
            })
              .then((response) => {
                try {
                  return response.text();
                } catch (error) {
                  return null;
                }
              })
              .then((res) => {
                let parsedResponse = JSON.parse(res);
                isRxExist = parsedResponse.Rx_Is_Exist;
                if (isRxExist === false || isRxExist === 'false') {
                  const existingItem = this.state.searchedItems;
                  // this.setState({ EmailID: patientDetails.EmailAddress, phone: patientDetails.phone });
                  this.setState({ EmailID: 'N/A', phone: 'N/A' });
                  if (
                    existingItem &&
                    searchedRxItems &&
                    searchedRxItems.length > 0
                  ) {
                    let isexist = searchedRxItems.findIndex(
                      (x) => x.prescription_txn_id === searchedString
                    );
                    if (existingItem.PatientID === patientDetails.patient_id) {
                      if (isexist < 0) {
                        searchedRxItems.push(item);
                        if (
                          patientDetails &&
                          patientDetails.patient_id &&
                          patientDetails.EmailAddress
                        ) {
                          this.checkADACompatible(
                            patientDetails.patient_id,
                            patientDetails.EmailAddress
                          );
                        }
                        this.getcustomerLocation(
                          patientDetails,
                          searchedRxItems,
                          'MScripts'
                        );
                        this.setState({
                          rxNumber: '',
                          loader: false,
                        });
                        this.forceUpdate();
                      } else {
                        toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                        this.setState({
                          rxNumber: '',
                          loader: false,
                        });
                      }
                    } else {
                      toast.error(this.props.t('Toast.Error.WrongPatient'));
                      this.setState({
                        rxNumber: '',
                        loader: false,
                      });
                    }
                  } else {
                    searchedRxItems.push(item);
                    // if(patientDetails && patientDetails.patientID && EmailAddress) {
                    //   this.checkADACompatible(patientDetails.patientID, EmailAddress)
                    // }
                    this.getcustomerLocation(
                      patientDetails,
                      searchedRxItems,
                      'MScripts'
                    );
                    this.forceUpdate();
                    this.setState({
                      rxNumber: '',
                      loader: false,
                    });
                  }
                } else {
                  toast.error(this.props.t('Toast.Error.RxExist'));
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                }
              });
          }
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  handlePioneerKeyDown = () => {
    const { originalScannedScript } = this.state;
    let searchedString = originalScannedScript;
    this.setState({ loader: true, isEdit: false });
    let obj = {
      lookupValue: searchedString,
      vendor_key: this.state.accountDetails.connection_details
        .vendor_key,
      data_exchange_id: this.state.accountDetails.connection_details
        .data_exchange_id,
      contentType: 'application/json',
      returnType: 0,
      endPoint: this.state.accountDetails.connection_details.endpoint,
      account_id: this.state.accountDetails.id,
    };
    fetch(`${process.env.REACT_APP_BASEURL}pioneerRx/rxQuery`, {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        this.setState({ loader: false });
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (
          JSON.parse(res).status === 500 ||
          JSON.parse(res).status === '500'
        ) {
          toast.error(this.props.t("Assign.Pioneer.NoRxFound"));
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else if (
          (JSON.parse(res).status > 200 &&
            JSON.parse(res).status < 500) ||
          (JSON.parse(res).status > '200' &&
            JSON.parse(res).status < '500')
        ) {
          toast.error(this.props.t('Toast.Error.AdministratorContact')
          );
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else {
          if (res && res !== '') {
            let parsedResponse = JSON.parse(res);
            let patientDetails = parsedResponse.patient;
            let rxDetails = parsedResponse.rx;
            this.setState({ loader: false, confirmPMSDialogOpen: false });
            if (
              rxDetails !== undefined &&
              rxDetails !== 'undefined' &&
              rxDetails !== null &&
              rxDetails !== 'null' &&
              rxDetails !== ''
            ) {
              // if (rxDetails.readyToBeSold !== 1 && (rxDetails.statusTypeID !== 5 || rxDetails.statusTypeID !== 6)) {
              /*
              1 = Waiting for Data Entry
              2 = Waiting for Pre-check
              3 = Waiting for Fill
              4 = Waiting for Check
              10 = Completed
              16 = Cancelled
              17 = Waiting for Print
            */
              if (
                rxDetails.statusTypeID === 1 ||
                rxDetails.statusTypeID === 2 ||
                rxDetails.statusTypeID === 3 ||
                rxDetails.statusTypeID === 4 ||
                rxDetails.statusTypeID === 10 ||
                rxDetails.statusTypeID === 16 ||
                rxDetails.statusTypeID === 17
              ) {
                // toast.error(`The status of this Rx number is ${rxDetails.statusTypeText}`);
                this.setState({
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: this.props.t('Toast.Error.PioneerRx.Completed'),
                  rxNumber: '',
                });
                // return;
              }
            }
            if (rxDetails === undefined || rxDetails === 'undefined') {
              toast.error(this.props.t('Toast.Error.RxNotValid'));
              this.setState({
                rxNumber: '',
              });
              return;
            }
            let isConsultRequired = false;
            if (
              rxDetails.isControlled === 1 ||
              rxDetails.isControlled === '1' ||
              rxDetails.promptForCounseling === 1 ||
              rxDetails.promptForCounseling === '1'
            ) {
              isConsultRequired = true;
            }
            // Check if account has bypass_consult enabled
            if ([true, "true"].includes(this.state.accountDetails.bypass_consult)) {
              isConsultRequired = false;
            }
            let isreturnable = false
            if (
              rxDetails &&
              rxDetails.IsReturnable === true
            ) {
              isreturnable = rxDetails.IsReturnable;
            } else {
              isreturnable = false;
            }
            let _localIsControlledSubstance = false;
            if(![undefined, 'undefined', null, 'null', ''].includes(rxDetails.drugSchedule)) {
              if(["2", "3", "4", "5", 2, 3, 4, 5].includes(rxDetails.drugSchedule)) {
                this.setState({ is_controlled_substance: true });
                _localIsControlledSubstance = true;
              } else {
                this.setState({ is_controlled_substance: false });
                _localIsControlledSubstance = false;
              }
            } else {
              this.setState({ is_controlled_substance: false });
              _localIsControlledSubstance = false;
            }
            // User-friendly logs for calculation and values
            console.log("=== Account & Prescription Billing Calculation Start ===");
            if (this.state.globalAccountConnection) {
              console.log("Account Connection Details found.");
              if (this.state.globalAccountConnection.connection_details) {
                console.log("Connection Type:", (
                  this.state.globalAccountConnection && 
                  this.state.globalAccountConnection.connection && 
                  this.state.globalAccountConnection.connection.name) || 
                  "N/A"
                );
                console.log("Account has 'calculate_tax' enabled:",
                  !!this.state.globalAccountConnection.connection_details.calculate_tax
                );
              } else {
                console.log("No connection_details property found on account connection.");
              }
            } else {
              console.log("No account connection configuration available.");
            }

            const shouldCalculateTax =
              this.state.globalAccountConnection &&
              this.state.globalAccountConnection.connection_details &&
              this.state.globalAccountConnection.connection_details.calculate_tax;

            if (shouldCalculateTax) {
              console.log("Tax calculation by Connect is ENABLED for this account.");
            } else {
              console.log("Tax calculation by Connect is DISABLED or not configured for this account.");
            }

            // Parse patient amount
            const patientAmount = [undefined, 'undefined', null, 'null', '', '0', 0].includes(rxDetails.patientAmountOwed)
              ? 0
              : (typeof rxDetails.patientAmountOwed === 'string' ? parseFloat(rxDetails.patientAmountOwed) : rxDetails.patientAmountOwed);

            if (patientAmount > 0) {
              console.log(`Patient responsibility amount from Pioneer: $${patientAmount.toFixed(2)}`);
            } else {
              console.log("No patient responsibility amount provided in the rx details. Defaulting to zero.");
            }

            // Parse tax amount
            let taxAmount = [undefined, 'undefined', null, 'null', '', '0', 0].includes(rxDetails.taxAmountOwedByPatient)
              ? 0
              : (typeof rxDetails.taxAmountOwedByPatient === 'string' ? parseFloat(rxDetails.taxAmountOwedByPatient) : rxDetails.taxAmountOwedByPatient);

            if (taxAmount > 0) {
              console.log(`Tax amount from Pioneer: $${taxAmount.toFixed(2)}`);
            } else {
              console.log("No tax amount provided in the rx details. Will attempt to calculate if enabled...");
            }

            // If calculate_tax is enabled and Pioneer didn't provide tax, calculate it using account tax_rate
            if (shouldCalculateTax && (taxAmount === 0 || taxAmount === null || taxAmount === undefined)) {
              const taxData = this.state.globalAccountConnection && this.state.globalAccountConnection.tax_data;
              const taxRate = taxData && taxData.tax_rate;
              if (taxRate && taxRate > 0) {
                taxAmount = (patientAmount * parseFloat(taxRate)) / 100;
                console.log(`Calculated tax using tax_rate (${taxRate}%): $${taxAmount.toFixed(2)} (for patient amount $${patientAmount.toFixed(2)})`);
              } else {
                console.log("No valid tax_rate found in account settings; tax remains zero.");
              }
            }

            // Calculate total amount based on account setting
            const totalAmount = shouldCalculateTax ? (patientAmount + taxAmount) : patientAmount;
            console.log(`Total amount to be charged: $${totalAmount.toFixed(2)} (Patient: $${patientAmount.toFixed(2)} + Tax: $${taxAmount.toFixed(2)})`);
            console.log("=== Account & Prescription Billing Calculation Complete ===");
            
            let item = {
              ndcCode: rxDetails.prescribedNDC,
              itemId: '',
              binId: '',
              rxNo: rxDetails.rxNumber,
              name: rxDetails.prescribedDrugName,
              description: '',
              image: '',
              potency: '',
              qty: rxDetails.dispensedQuantity,
              schedule: rxDetails.drugSchedule,
              Amount: totalAmount,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: totalAmount,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: '',
              isLoadingTrans: false,
              fillNumber: rxDetails.fillNumber,
              ConsultRequire: isConsultRequired,
              IsReturnable: isreturnable,
              is_controlled_substance: [true, 'true'].includes(_localIsControlledSubstance) ? true : false,
              tax_amount: taxAmount,
            };
            this.setState({
              EmailID: patientDetails.emailAddress,
              phone: patientDetails.primaryPhone,
              is_controlled_substance: [true, 'true'].includes(_localIsControlledSubstance) ? true : false
            });
            const existingItem = this.state.searchedItems;
            if (
              existingItem &&
              searchedRxItems &&
              searchedRxItems.length > 0
            ) {
              let rxNumbers = searchedString;
              if (rxNumbers[0].toLowerCase() === 'x') {
                rxNumbers = rxNumbers.split('X')[1];
              } else {
                rxNumbers = searchedString.split('-')[0];
              }
              let isexist = searchedRxItems.findIndex(
                (x) => x.rxNo === rxNumbers
              );
              if (existingItem.PatientID === patientDetails.patientID) {
                if (isexist < 0) {
                  searchedRxItems.push(item);
                  if (
                    patientDetails.emailAddress !== '' &&
                    patientDetails.emailAddress !== undefined &&
                    patientDetails.emailAddress !== 'undefined' &&
                    patientDetails.emailAddress !== 'null' &&
                    patientDetails.emailAddress !== 'null'
                  ) {
                    this.checkADACompatible(
                      patientDetails.patientID,
                      patientDetails.emailAddress
                    );
                  }
                  this.getcustomerLocation(
                    patientDetails,
                    searchedRxItems,
                    'Pioneer'
                  );
                  this.forceUpdate();
                  this.setState({
                    rxNumber: '',
                  });
                } else {
                  toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                  this.setState({
                    rxNumber: '',
                  });
                }
              } else {
                toast.error(this.props.t('Toast.Error.WrongPatient'));
                this.setState({
                  rxNumber: '',
                });
              }
            } else {
              searchedRxItems.push(item);
              if (
                patientDetails.emailAddress !== null &&
                patientDetails.emailAddress !== 'null' &&
                patientDetails.emailAddress !== undefined &&
                patientDetails.emailAddress !== 'undefined' &&
                patientDetails.emailAddress !== ''
              ) {
                this.checkADACompatible(
                  patientDetails.patientID,
                  patientDetails.emailAddress
                );
              }
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'Pioneer'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
              });
            }
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });

  };

  handlePioneerChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleOpenDueAmountEditInput = (index) => {
    this.setState({ indexNo: index });
  };

  handleCloseDueAmountEditInput = (index, id) => {
    this.setState({ indexNo: Math.random() || index });
    const orderdueamount =
      searchedRxItems && searchedRxItems.find((item, i) => item.id === id);
    this.updateDueAmount(id, orderdueamount['price']);
  };

  updateDueAmount = (orderid, dueAmount) => {
    this.setState({ loader: true });
    const updateParams = {
      orderid: orderid,
      dueamount: dueAmount,
    };
    try {
      fetch(process.env.REACT_APP_BASEURL + 'updateorderdueamout', {
        method: 'PUT',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateParams),
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          if (res) {
            this.setState({ loader: false });
            toast.success(
              res && res.UpdateDueAmount && res.UpdateDueAmount.message
            );
            //this.getPrescriptionDetails(this.state.binid, this.state.pmid);
          } else {
            this.setState({ loader: false });
            toast.error(res.error);
          }
        });
    } catch (error) {
      this.setState({ loader: false });
      console.log(error);
    }
  };

  onHandleChangeInputValue = (id, type, value, rxNumber) => {
    if (type === 'price') {
      const items =
        searchedRxItems &&
        searchedRxItems.map((item, i) => {
          if (((item.id || item.itemId) === id) && ((item.rxNo || item.rx_no) === rxNumber)) {
            return { ...item, price: parseFloat(value), CoPayAmount: parseFloat(value), Amount: parseFloat(value) };
          }
          return item;
        });
      searchedRxItems = items;
    } else if (type === 'seqNumber') {
      const items =
        searchedRxItems &&
        searchedRxItems.map((item, i) => {
          if (((item.id || item.itemId) === id) && ((item.rxNo || item.rx_no) === rxNumber)) {
            return { ...item, SeqNumber: value };
          }
          return item;
        });
      searchedRxItems = items;
    }
    this.forceUpdate();
  };

  handleMcKessonRxChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  parseRegexFromString = (regexString) => {
    const match = regexString.match(/^\/(.*)\/([gimsuy]*)$/); // Extract pattern & flags
    if (!match) throw new Error("Invalid regex format in DB");
  
    const [, pattern, flags] = match; // Destructure extracted values
    return new RegExp(pattern, flags);
  };

  parseMcKessonRxNumber = (prescriptionId, accountObject) => {
    // await McKessionParseRxService('40036000109000', /\d(?<storeNumber>\d{3})(?<rxNumber>\d{7})(?<fillNumber>\d{2})(?<partialFillNumber>\d{1})/)
    // await McKessionParseRxService('^4-11-6119625-01-2^', /\^\d{1}-(?<storeNumber>\d{2})-(?<rxNumber>\d{7})-(?<fillNumber>\d{2})-(?<partialFillNumber>\d{1})/)
    // await McKessionParseRxService('RX6385102000-0000930', /(?<rxNumber>\d{7})(?<fillNumber>\d{2})(?<partialFillNumber>\d{1})/)
    const regExp = this.parseRegexFromString(accountObject && accountObject.regexp);
    const parsedScript = regExp.exec(prescriptionId);
    let parsedRxNumber = null;
    if (parsedScript && parsedScript.length > 0) {
      const _groups = parsedScript && parsedScript.groups;
      if (![undefined, "undefined", null, "null", ""].includes(_groups)) {
        parsedRxNumber = {
          storeNumber: (_groups && _groups.storeNumber) || "",
          rxNumber:
            `${_groups && _groups.rxNumber}${_groups && _groups.fillNumber}` ||
            "",
          rxNumberWithoutFill: (_groups && _groups.rxNumber) || "",
          fillNumber: (_groups && _groups.fillNumber) || "",
          partialFillNumber: (_groups && _groups.partialFillNumber) || "",
        };
      }
    }
    return parsedRxNumber;
  };  
  handleMcKessonRxKeyDown = () => {
    const { globalAccountConnection, originalScannedScript } = this.state;
    this.setState({ loader: true, isEdit: false, confirmPMSDialogOpen: false });
    let searchedString = originalScannedScript;
    const rxToValidate = this.parseMcKessonRxNumber(searchedString, globalAccountConnection);
    let obj = {
      PrescriptionId: searchedString,
      account_id: this.state.accountDetails.id,
      isSafetyCheck: false,
    };
    fetch(
      process.env.REACT_APP_BASEURL +
      'api/mc-kession/GetPrescriptionDetailsById',
      {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession
              .idToken.jwtToken,
        },
        body: JSON.stringify(obj),
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (
          JSON.parse(res).status === 500 ||
          JSON.parse(res).status === '500'
        ) {
          toast.error(
            this.props.t('Toast.Error.AdministratorContact')
          );
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else if (
          (JSON.parse(res).status > 200 &&
            JSON.parse(res).status < 500) ||
          (JSON.parse(res).status > '200' &&
            JSON.parse(res).status < '500')
        ) {
          toast.error(
            this.props.t('Toast.Error.AdministratorContact')
          );
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else {
          let parsedResponse = JSON.parse(res) && JSON.parse(res).res;
          if (parsedResponse.patientInfo !== null) {
            let patientDetails = parsedResponse.patientInfo;
            let rxDetails = parsedResponse.prescriptionInfo;
            this.setState({ loader: false });
            if (rxDetails.WorkflowStatus !== 'Ready') {
              this.setState({
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: `The status of Rx: ${searchedString} is not ready. Please check your system and try again.`,
                rxNumber: '',
              });
            }
            if (
              (patientDetails && patientDetails.ExternalPatientID) ===
              undefined ||
              (patientDetails && patientDetails.ExternalPatientID) ===
              'undefined'
            ) {
              toast.error(this.props.t('Toast.Error.RxNotValid'));
              this.setState({
                rxNumber: '',
              });
              return;
            }
            let isConsultRequired = false;
            if (
              rxDetails.isControlledSubstance === true ||
              rxDetails.isControlledSubstance === 'true'
            ) {
              isConsultRequired = true;
            }
            let isreturnable = false
            if (
              rxDetails &&
              rxDetails.IsReturnable === true
            ) {
              isreturnable = rxDetails.IsReturnable;
            } else {
              isreturnable = false;
            }
            let item = {
              ndcCode: rxDetails.DispensedNDC,
              itemId: '',
              binId: '',
              rxNo: rxDetails.RxNumber,
              name: rxDetails.DrugName || rxDetails.ProductName,
              description: rxDetails.SigText,
              image: '',
              potency: '',
              qty: rxDetails.Quantity,
              schedule: rxDetails.SigText,
              Amount: rxDetails.Price,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: rxDetails.Price,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: rxDetails.ExpirationDate,
              isLoadingTrans: false,
              fillNumber: rxDetails.FillNumber,
              ConsultRequire: isConsultRequired,
              IsReturnable: isreturnable,
              partialfillseqnum: rxDetails.partialfillseqnum,
              is_controlled_substance: rxDetails.isControlledSubstance,
              StoreNumber: rxDetails.StoreNumber,
            };
            this.setState({
              EmailID: patientDetails && patientDetails.EmailAddress,
              phone: patientDetails && patientDetails.MobilePhone,
            });
            const existingItem = this.state.searchedItems;
            if (
              existingItem &&
              searchedRxItems &&
              searchedRxItems.length > 0
            ) {
              let isexist = searchedRxItems.findIndex(
                (x) => x.rxNo === rxToValidate.rxNumber
              );
              if (
                existingItem.ExternalPatientID ===
                patientDetails.ExternalPatientID ||
                existingItem.PatientID === patientDetails.ExternalPatientID
              ) {
                if (isexist < 0) {
                  searchedRxItems.push(item);
                  if (
                    patientDetails.EmailAddress !== '' &&
                    patientDetails.EmailAddress !== undefined &&
                    patientDetails.EmailAddress !== 'undefined' &&
                    patientDetails.EmailAddress !== 'null' &&
                    patientDetails.EmailAddress !== 'null'
                  ) {
                    this.checkADACompatible(
                      patientDetails.ExternalPatientID,
                      patientDetails.EmailAddress
                    );
                  }
                  this.getcustomerLocation(
                    patientDetails,
                    searchedRxItems,
                    'McKesson'
                  );
                  this.forceUpdate();
                  this.setState({
                    rxNumber: '',
                  });
                } else {
                  toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                  this.setState({
                    rxNumber: '',
                  });
                }
              } else {
                toast.error(this.props.t('Toast.Error.WrongPatient'));
                this.setState({
                  rxNumber: '',
                });
              }
            } else {
              searchedRxItems.push(item);
              if (
                patientDetails &&
                patientDetails.EmailAddress !== null &&
                patientDetails &&
                patientDetails.EmailAddress !== 'null' &&
                patientDetails &&
                patientDetails.EmailAddress !== undefined &&
                patientDetails &&
                patientDetails.EmailAddress !== 'undefined' &&
                patientDetails &&
                patientDetails.EmailAddress !== ''
              ) {
                this.checkADACompatible(
                  patientDetails.ExternalPatientID,
                  patientDetails.EmailAddress
                );
              }
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'McKesson'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
              });
            }
          } else {
            this.setState({
              loader: false,
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `Prescription found but no patient information is available for Rx: ${searchedString}. Please verify the prescription in your system.`,
              rxNumber: ''
            });
          }
        }
        this.setState({ loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleEpicWithmTLSChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleEpicWithmTLSKeyDown = () => {
    // if (event.keyCode === 13) {
      this.setState({
        loader: true,
        isEpicHasValidRx: true,
        isEpicHasValidRxMessage: '',
        isEdit: false,
      });
      const { originalScannedScript } = this.state;
      let searchString = originalScannedScript;
      let validItems = [];
      let items = [];
      let obj = {
        PrescriptionId: searchString,
        account_id: this.state.accountDetails.id,
      };
      fetch(
        process.env.REACT_APP_BASEURL + 'kp/epic/mtls/GetPrescriptionInfoById',
        {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
          body: JSON.stringify(obj),
        }
      )
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then(async (res) => {
          let parsedJsonResponse = JSON.parse(res);
          let parsedJson;
          if (parsedJsonResponse && parsedJsonResponse.message) {
            this.setState({
              loader: false,
              rxNumber: '',
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
            });
            return;
          }
          parsedJson = parsedJsonResponse.response;
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.prescriptions;
          if (prescriptionDetails && prescriptionDetails.length <= 0) {
            toast.error(this.props.t('Toast.Error.Prescription'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              let _existingPrescriptionNumbers = [];
              if (
                prescriptionDetails &&
                prescriptionDetails.length &&
                prescriptionDetails.length > 0
              ) {
                for (
                  let exist = 0;
                  exist < prescriptionDetails.length;
                  exist++
                ) {
                  let preacriptionNumber = prescriptionDetails[
                    exist
                  ].PrescriptionNumber.trim();
                  for (let si = 0; si < searchedRxItems.length; si++) {
                    if (
                      preacriptionNumber ===
                      searchedRxItems[si].prescriptionNumber
                    ) {
                      _existingPrescriptionNumbers.push(preacriptionNumber);
                    }
                  }
                }
              }
              if (
                _existingPrescriptionNumbers &&
                _existingPrescriptionNumbers.length &&
                _existingPrescriptionNumbers.length > 0
              ) {
                this.setState({
                  loader: false,
                  rxNumber: '',
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers} are already exist in the cart!`,
                });
                return true;
              }
            }
          }
          for (let j = 0; j < prescriptionDetails.length; j++) {
            let isconsultrequired = false;
            if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsConsultRequired === true
            ) {
              isconsultrequired = prescriptionDetails[j].IsConsultRequired;
            } else {
              isconsultrequired = false;
            }
            let isreturnable = false
            if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsReturnable === true
            ) {
              isreturnable = prescriptionDetails[j].IsReturnable;
            } else {
              isreturnable = false;
            }
            for (let i = 0; i < prescriptionDetails[j].Fill.length; i++) {
              let item = {
                ndcCode: prescriptionDetails[j].Fill[i].Ndc,
                itemId: '',
                binId: '',
                rxNo: prescriptionDetails[j].Fill[i].PrescriptionId,
                name: prescriptionDetails[j].Medication,
                description: prescriptionDetails[j].Sig,
                image: '',
                potency: '',
                qty: prescriptionDetails[j].Fill[i].Quantity,
                schedule: prescriptionDetails[j].Frequency,
                Amount: prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                taxPercentage: '',
                insuranceAmount: '',
                CoPayAmount:
                  prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                PaidAmount: '',
                DueAmount: '',
                paymentDueDate: '',
                stockedOn: '',
                stockedBy: '',
                deStockedOn: '',
                strength: '',
                route: '',
                doseage_form: '',
                non_proprietary_name: '',
                ExpirationDate: '',
                isLoadingTrans: false,
                fillNumber: prescriptionDetails[j].Fill[i].Id,
                prescriptionNumber:
                  prescriptionDetails[j].Fill[i].PrescriptionNumber,
                ConsultRequire: isconsultrequired,
                IsReturnable: isreturnable,
                status: prescriptionDetails[j].Fill[i].Status,
                is_controlled_substance: prescriptionDetails[j].isControlledSubstances,
                // Add flags and blocking reasons for informational display
                Flags: prescriptionDetails[j].Fill[i].Flags || [],
                CannotDispenseReasons: prescriptionDetails[j].Fill[i].CannotDispenseReasons || [],
                IsDispensable: prescriptionDetails[j].Fill[i].IsDispensable,
                // Prescription-level flags
                PrescriptionFlags: prescriptionDetails[j].AllFlags || prescriptionDetails[j].Flags || [],
                ReasonNotFillable: prescriptionDetails[j].ReasonNotFillable
              };
              let rxTransactionNumber = `${prescriptionDetails[j].Fill[i].PrescriptionId}-${prescriptionDetails[j].Fill[i].Id}`;
              if (
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'verified' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'readytodispense' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'intransit' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'received'
              ) {
                const isRxTrasactionNumberExist = await this.checkIfRxExistorNotForEpicWithmTLS(
                  rxTransactionNumber
                );
                if (
                  isRxTrasactionNumberExist &&
                  isRxTrasactionNumberExist.result === true
                ) {
                  toast.error(isRxTrasactionNumberExist.error);
                  this.setState({
                    rxNumber: '',
                    loader: false,
                    EmailID: '',
                    phone: '',
                    isEpicHasValidRx: true,
                    isEpicHasValidRxMessage: '',
                  });
                  return;
                } else {
                  items.push(item);
                  if (
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'verified' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'readytodispense' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'intransit' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'received'
                  ) {
                    validItems.push(prescriptionDetails[j].Fill[i]);
                  }
                  if (validItems.length > 0) {
                    prescriptionDetails[j].Fill[i] = validItems;
                  }
                }
              } else {
                items.push(item);
              }
            }
          }
          if (items && items.length === 0) {
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              this.isRxExistInCart(searchString, patientDetails, items);
            }
          } else {
            this.setState({
              EmailID: patientDetails.EmailAddress,
              phone: patientDetails.MobilePhone,
            });
            let RxItems = this.validateRxFills(items);
            if (
              RxItems &&
              RxItems.validRxItems &&
              RxItems.validRxItems.length > 0
            ) {
              searchedRxItems = RxItems.validRxItems;
            } else {
              searchedRxItems = RxItems.inValidRxItems;
              let errorArray = [];
              if (searchedRxItems && searchedRxItems.length > 0) {
                for (
                  let invalid = 0;
                  invalid < searchedRxItems.length;
                  invalid++
                ) {
                  errorArray.push({ Status: searchedRxItems[invalid].status });
                }
                this.setState({
                  loader: false,
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The status of the prescription
                  should be Verified, ReadyToDispense, Received or InTransit but the ${errorArray && errorArray.length > 1
                      ? 'statuses are'
                      : 'status is'
                    } ${errorArray &&
                    errorArray.map((x) => x.Status).join(', ')}`,
                });
              }
            }
            this.checkADACompatible(
              patientDetails.MedicalRecordNumber,
              patientDetails.EmailAddress
            );
            this.getcustomerLocation(
              patientDetails,
              searchedRxItems,
              'Epic With MTLS'
            );
            this.forceUpdate();
            this.setState({
              rxNumber: '',
              loader: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            loader: false,
            rxNumber: '',
            isEpicHasValidRx: false,
            isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
          });
          return;
        });
    // }
  };
  renderScanRxBasedOnConnectionType = (classes) => {
    const { globalAccountConnection, prescriptionAssign } = this.state;
    const { t } = this.props;
    switch (globalAccountConnection.account_connections_id) {
      case CONNECTION_TYPE.EPIC:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'EPIC')}
            onChange={this.handleEpicChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.MEDBANK:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={this.handleMedBankKeyDown}
            onChange={this.handleMedBankChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.MSCRIPTS:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={this.handleMScriptsKeyDown}
            onChange={this.handleMScriptsOnChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.PIONEERRX:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'PIONEERRX')}
            onChange={this.handlePioneerChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.QS1:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'QS1')}
            onChange={this.handleQS1Change}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.MCKESSONERX:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'MCKESSONERX')}
            onChange={this.handleMcKessonRxChange}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.EPIC_WITH_MTLS:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'Epic With MTLS')}
            onChange={this.handleEpicWithmTLSChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.LIBERTY_SOFTWARE:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'LIBERTYSOFTWARE')}
            onChange={this.handleLibertySoftwareChange}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.THIRD_PARTY:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleThirdPartyRxCheck(e, 'THIRDPARTY')}
            onChange={this.handleThirdPartyChange}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.HL7:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={this.handleHL7KeyDown}
            onChange={this.handleHL7OnChange}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.DRX_INTEGRATION:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'DRX')}
            onChange={this.handleDRXChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        )
        case CONNECTION_TYPE.PRIMERX:
          return (
            <TextField
              id='outlined-bare'
              type='text'
              className={classes.scantextField}
              value={this.state.rxNumber}
              margin='normal'
              variant='standard'
              label={t('Assign.ScanRxNow')}
              autoFocus={true}
              onKeyDown={this.handlePrimerxKeyDown}
              onChange={this.handlePrimerxOnChange}
              inputRef={this.textInput}
              style={{ width: '100%' }}
              inputProps={{
                autoComplete: 'off',
                form: {
                  autoComplete: 'off',
                },
              }}
              disabled={!prescriptionAssign}
            />
          );
      default:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onChange={this.onChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
    }
  };

  BindPatientId = () => {
    const { searchedItems, basicDetails } = this.state;
    if (
      searchedItems &&
      searchedItems.PatientID &&
      searchedItems.PatientID !== null &&
      searchedItems.PatientID !== 'null'
    ) {
      return searchedItems.PatientID;
    } else if (
      basicDetails &&
      basicDetails.patient_id &&
      basicDetails.patient_id !== null &&
      basicDetails.patient_id !== 'null'
    ) {
      return basicDetails.patient_id;
    } else {
      return '';
    }
  };

  handleQS1Change = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleQS1KeyDown = () => {
    const { accountDetails, boxDetails, originalScannedScript, scannedRxScript } = this.state;
    let searchedString = originalScannedScript || scannedRxScript;
    if (boxDetails && boxDetails.length === 0) {
      this.setState({
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage:
          'Please select at least one location or check the location is active or not.',
        loader: false,
        rxNumber: '',
      });
      this.handleFocus();
      return;
    }
    this.setState({ loader: true, confirmPMSDialogOpen: false });
    let obj = {
      pharmacyId:
        accountDetails &&
        accountDetails.connection_details &&
        accountDetails.connection_details.pharmacyid,
      rxNumber: searchedString,
      account_id: this.state.accountDetails.id,
    };
    fetch(process.env.REACT_APP_BASEURL + 'qs/rx', {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        this.setState({ loader: false, confirmPMSDialogOpen: false });
        let parsedResponse = JSON.parse(res);
        let patientDetails = parsedResponse.patient;
        let rxDetails = parsedResponse.rx;
        let parsedExpirationDate = '';
        if (
          patientDetails === 404 &&
          (rxDetails[0].Status === 'N' || rxDetails[0].Status === 'n')
        ) {
          toast.error(this.props.t('Toast.Error.RxNotAvailableNumber'));
          this.handleFocus();
          this.setState({
            rxNumber: '',
          });
        } else {
          if (
            rxDetails &&
            rxDetails[0] &&
            rxDetails[0].ExpirationDate
          ) {
            let ExpirationDateyear = rxDetails[0].ExpirationDate.substring(
              0,
              4
            );
            let ExpirationDatemonth = rxDetails[0].ExpirationDate.substring(
              4,
              6
            );
            let ExpirationDateday = rxDetails[0].ExpirationDate.substring(
              6,
              8
            );
            parsedExpirationDate =
              ExpirationDatemonth +
              '/' +
              ExpirationDateday +
              '/' +
              ExpirationDateyear;
          }
          if(![undefined, 'undefined', null, 'null', ''].includes(rxDetails[0].DrugSchedule)) {
            if(["2", "3", "4", "5"].includes(rxDetails[0].DrugSchedule)) {
              this.setState({ is_controlled_substance: true });
            } else {
              this.setState({ is_controlled_substance: false });
            }
          } else {
            this.setState({ is_controlled_substance: false });
          }
          let item = {
            ndcCode: '',
            itemId: '',
            binId: '',
            rxNo: rxDetails && rxDetails[0] && rxDetails[0].RxNumber,
            name: rxDetails && rxDetails[0] && rxDetails[0].DrugName,
            description: '',
            image: '',
            potency: '',
            qty: '',
            schedule:
              rxDetails && rxDetails[0] && rxDetails[0].DrugSchedule,
            Amount: '',
            taxPercentage: '',
            insuranceAmount: '',
            CoPayAmount: '',
            PaidAmount: '',
            DueAmount: '',
            paymentDueDate: '',
            stockedOn: '',
            stockedBy: '',
            deStockedOn: '',
            strength: '',
            route: '',
            doseage_form: '',
            non_proprietary_name: '',
            ExpirationDate: parsedExpirationDate,
            isLoadingTrans: true,
            ConsultRequire: false,
            datefilled:
              rxDetails && rxDetails[0] && rxDetails[0].LastFillDate,
          };
          obj.datefilled = item.datefilled;
          this.generateCodes();
          this.setState({
            EmailID: patientDetails.EmailAddress,
            phone: patientDetails.CellPhone,
          });
          let parsedDob = '';
          var year = patientDetails.DateOfBirth.substring(0, 4);
          var month = patientDetails.DateOfBirth.substring(4, 6);
          var day = patientDetails.DateOfBirth.substring(6, 8);
          parsedDob = month + '/' + day + '/' + year;
          const existingItem = this.state.searchedItems;
          if (
            existingItem &&
            searchedRxItems &&
            searchedRxItems.length > 0
          ) {
            let _searchedRxNumber = '';
            let _firstCharZero = searchedString.charAt(0);
            if (_firstCharZero === 0 || _firstCharZero === '0') {
              if (searchedString.length === 12) {
                _searchedRxNumber = searchedString.slice(
                  0,
                  searchedString.length - 4
                );
              } else {
                _searchedRxNumber = searchedString;
              }
            } else {
              _searchedRxNumber = '0' + searchedString;
            }
            let isexist = searchedRxItems.findIndex(
              (x) => x.rxNo === _searchedRxNumber
            );
            if (existingItem.PatientID === patientDetails.PatientID) {
              if (isexist < 0) {
                searchedRxItems.push(item);
                this.checkADACompatible(
                  patientDetails.PatientID,
                  this.state.EmailID
                );
                let AddressLine1 = '', 
                AddressLine2 = '', 
                City = '', 
                State = '', 
                Zip = '', 
                Country = '',
                boxId = this.state.box_id;
                let locationDetails = boxDetails.filter((x) => x.id === boxId)[0];
                if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
                  AddressLine1 = locationDetails.address_line_1 || "";
                  AddressLine2 = locationDetails.address_line_2 || "";
                  City = locationDetails.city || "";
                  State = locationDetails.state || "";
                  Zip = locationDetails.zip || "";
                  Country = locationDetails.country || "";
                }
                this.setState({
                  searchedItems: {
                    PatientID: patientDetails.PatientID,
                    customer_id: patientDetails.customer_id || patientDetails.customerId,
                    FirstName: patientDetails.FirstName,
                    LastName: patientDetails.LastName,
                    DateOfBirth: parsedDob,
                    MobileNo: this.state && this.state.phone,
                    EmailID: this.state && this.state.EmailID,
                    orders: [{ items: searchedRxItems }],
                    AddressLine1: AddressLine1,
                    AddressLine2: AddressLine2,
                    City: City,
                    State: State,
                    Zip: Zip,
                    Country: Country,
                  },
                });
              } else {
                toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                this.setState({
                  rxNumber: '',
                });
                this.handleFocus();
              }
            } else {
              toast.error(this.props.t('Toast.Error.WrongPatient'));
              this.setState({
                rxNumber: '',
              });
              this.handleFocus();
            }
          } else {
            searchedRxItems.push(item);
            this.checkADACompatible(
              patientDetails.PatientID,
              this.state && this.state.EmailID
            );
            let AddressLine1 = '', 
            AddressLine2 = '', 
            City = '', 
            State = '', 
            Zip = '', 
            Country = '',
            boxId = this.state.box_id;
            let locationDetails = boxDetails.filter((x) => x.id === boxId)[0];
            if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
              AddressLine1 = locationDetails.address_line_1 || "";
              AddressLine2 = locationDetails.address_line_2 || "";
              City = locationDetails.city || "";
              State = locationDetails.state || "";
              Zip = locationDetails.zip || "";
              Country = locationDetails.country || "";
            }
            this.setState({
              searchedItems: {
                PatientID: patientDetails.PatientID,
                customer_id: patientDetails.customer_id || patientDetails.customerId,
                FirstName: patientDetails.FirstName,
                LastName: patientDetails.LastName,
                MiddleName: null,
                DateOfBirth: parsedDob,
                MobileNo: this.state && this.state.phone,
                EmailID: this.state && this.state.EmailID,
                orders: [{ items: searchedRxItems }],
                AddressLine1: AddressLine1,
                AddressLine2: AddressLine2,
                City: City,
                State: State,
                Zip: Zip,
                Country: Country,
              },
            });
          }
          this.fetchTransactions(obj);
        }
      })
      .catch((error) => {
        toast.error(
          `${this.props.t('Toast.Error.RxErrorDetail')} ${searchedString}`
        );
        console.error('Error:', error.message);
        this.setState({ loader: false });
        this.setState({
          rxNumber: '',
        });
        this.handleFocus();
      });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { selectedObject } = this.state;
    this.setState(
      { searchObj: { ...this.state.searchObj, pageNo: page } },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  handleChangeRowsPerPage = (event) => {
    const { selectedObject } = this.state;
    this.setState(
      {
        searchObj: {
          ...this.state.searchObj,
          pageSize: event.target.value,
          pageNo: 0,
        },
      },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  handlePrintReceipt = async () => {
    const { box_id, selectedBinId, binid, pmid, printLoading, locationtype_id, boxTypeId } = this.state;
    
    // Race condition protection (Test 1.9) - prevent concurrent calls
    if (printLoading) {
      console.log('Print operation already in progress, ignoring duplicate request');
      return;
    }
    
    // Use binid as fallback if selectedBinId is not set
    const effectiveBinId = selectedBinId || binid;
    
    const isCounter = locationtype_id === LOCATION_TYPE.Counter;
    const isFastlaneGoliath = boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const isBinOptional = isCounter || isFastlaneGoliath;
    const binIdForApi = !effectiveBinId && isBinOptional ? null : effectiveBinId;
    
    // Check if we have the required IDs to fetch fresh data.
    // For Counter and Fastlane Goliath, bin_id can be empty and resolved by API response.
    if (!pmid || !box_id || (!binIdForApi && !isBinOptional)) {
      console.error('Missing required IDs for fetching fresh label data:', { pmid, effectiveBinId, box_id, isBinOptional });
      toast.error(this.props.t('Toast.Error.LabelData.MissingIds') || 'Cannot print: missing order information');
      return;
    }
    
    // Fetch fresh data from database
    const labelData = await this.fetchOrderDataForPrint(box_id, binIdForApi, pmid);
    
    if (!labelData) {
      toast.error(this.props.t('Toast.Error.LabelData.FetchFailed') || 'Failed to load label data from database');
      return;
    }
    
    // Validate data
    const validation = this.validateLabelData(labelData, locationtype_id, boxTypeId);
    if (!validation.isValid) {
      console.error('Label data validation failed:', validation.missingFields);
      toast.error(
        this.props.t('Toast.Error.LabelData.Incomplete') || 
        `Cannot print: missing ${validation.missingFields.join(', ')}`
      );
      return;
    }
    
    // Get branding info - use boxDetails with robust ID comparison, fallback to selectedBox
    const boxIdStr = box_id != null ? String(box_id) : '';
    const boxDetails = this.state.boxDetails;
    const getBranding = boxDetails && boxDetails.find(
      (ele) => ele && String(ele.id) === boxIdStr
    );
    const selectedBox = this.state.selectedBox;
    const gbName = getBranding && getBranding.brandName;
    const sbName = selectedBox && selectedBox.brandName;
    const brandName = (gbName != null ? gbName : sbName) || '';
    const gbPhone = getBranding && getBranding.brandPhone;
    const sbPhone = selectedBox && selectedBox.brandPhone;
    const brandPhone = (gbPhone != null ? gbPhone : sbPhone) || '';

    // Set state with fresh data from database
    this.setState({
      labelDataForPrint: labelData,
      stockCode: labelData.stockCode,
      pickupCode: labelData.pickupCode,
      PrintFirstName: labelData.firstName,
      PrintLastName: labelData.lastName,
      PrintDateOfBirth: labelData.dateOfBirth,
      PrintisCoolItem: labelData.isCoolItem,
      binid: labelData.binId,
      printDialogOpen: true,
      BrandingName: brandName,
      BrandingPhone: brandPhone,
      rxEntries: labelData.rxEntries,
    }, () => {
      if (!brandPhone) {
        console.warn('Print Label: brandPhone empty for box', box_id, '- ensure location has brand phone configured');
      }
    });
    
    setTimeout(() => {
      window.print();
      this.setState({ printDialogOpen: false });
      this.getBoxes();
      searchedRxNumbers = [];
      searchedRxItems = [];
      this.setState({
        selectedBinId: '',
        searchedItems: [],
        rxNumber: '',
        isVisibleForPause: false,
        EmailID: '',
        phone: '',
        BrandingName: '',
        BrandingPhone: '',
      });
      this.handleFocus();
    }, 500);
  };

  handleFocus = () => {
    let event = document.querySelector('#outlined-bare');
    if (![undefined, null, 'undefined', 'null'].includes(event)) event.focus();
  };

  confirmBinOkButton = () => {
    this.setState({
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedBinId: '',
    });
  };
	checkIfCodesExists = async (codes, attempt = 0) => {
    await fetch(process.env.REACT_APP_BASEURL + 'verify/codes', {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(codes),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
		.then((res) => {
        if (res && res.isExist === true) {
          const _stockCode = randomized('A0', 6, { exclude: '0oOiIlL1&zZ' });
          const _pickupCode = randomized('A0', 6, { exclude: '0oOiIlL1&zZ' });
          // Codes stored in state only - fetched fresh from database before printing
          this.setState({ stockCode: _stockCode, pickupCode: _pickupCode });
        } else {
          // Codes stored in state only - fetched fresh from database before printing
          this.setState({
            stockCode: codes.stockCode,
            pickupCode: codes.pickupCode,
          });
        }
		}).catch(() => {
			// Bounded retry with simple backoff to avoid infinite re-renders
			if (attempt < 3) {
				setTimeout(() => this.checkIfCodesExists(codes, attempt + 1), (attempt + 1) * 500);
				return;
			}
			// On persistent failure, fall back to using the generated codes without further retries
			this.setState({
				stockCode: codes.stockCode,
				pickupCode: codes.pickupCode,
				loader: false,
			});
		});
    return codes;
  };

  saveCustomerMaster = async (type) => {
    console.log('💾 saveCustomerMaster called with type:', type);
    const {
      EmailID,
      phone,
      selectedBinId,
      isVerifyingBin,
      courier_tracking,
      default_courier_selected,
      isEpicHasValidRx,
      locationtype_id,
      accountDetails,
      servePresRetryCount,
      dateOfBirth,
      boxTypeId,
      deactivatedBins,
      isRetrying,
      fastlaneBinId
    } = this.state;
    const { t } = this.props;
    
    // Prevent concurrent retry attempts
    if (isRetrying) {
      console.log('💾 Assignment already in progress, skipping duplicate call');
      return;
    }
    
    if (deactivatedBins && deactivatedBins.includes(selectedBinId)) {
      toast.error(this.props.t('Toast.Error.BinDeactivated'));
      return;
    }
    this.setState(prevState => ({ 
      servePresFetchCount: prevState.servePresFetchCount + 1,
      isRetrying: true
    }));
    if (!this.state.box_id) {
      this.setState({ hasError: true, loader: false, isRetrying: false });
      return;
    } else {
      let allowPrescriptionForcefully = false;
      this.setState({ loader: true });
      // Simplified bin validation for Kiosk
      if(locationtype_id === LOCATION_TYPE.Kiosk) {
        // For Fastlane: if selectedBinId exists, use it (could be add-on or other selection)
        // If selectedBinId is empty, use fastlaneBinId (YourPosition) for normal Fastlane flow
        // For non-Fastlane: use selectedBinId
        let effectiveBinId;
        if (boxTypeId === BOX_TYPE.FASTLANE || boxTypeId === BOX_TYPE.FASTLANEGOLIATH) {
          // If user selected a bin (from add-on or anywhere else), use it
          if (selectedBinId && ![undefined, 'undefined', null, 'null', ''].includes(selectedBinId)) {
            effectiveBinId = selectedBinId;
          } else {
            // No bin selected, use fastlaneBinId (YourPosition) for normal Fastlane flow
            // This allows normal Fastlane flow to proceed without dialog interruption
            effectiveBinId = fastlaneBinId;
          }
        } else {
          effectiveBinId = selectedBinId;
          // Only show dialog for non-Fastlane boxes if bin is not selected
          if ([undefined, 'undefined', null, 'null', ''].includes(effectiveBinId)) {
            this.setState({ openMessage: true, loader: false, isRetrying: false });
            return;
          }
        }
      }
      if (![CONNECTION_TYPE.PIONEERRX, CONNECTION_TYPE.EPIC, CONNECTION_TYPE.EPIC_WITH_MTLS, CONNECTION_TYPE.DRX_INTEGRATION, CONNECTION_TYPE.LIBERTY_SOFTWARE].includes(accountDetails.connection.id)) {
        await this.checkPrescriptionStatus();
      } else {
        allowPrescriptionForcefully = true;
      }
      if (isEpicHasValidRx || allowPrescriptionForcefully) {
        if (accountDetails.connection.id !== CONNECTION_TYPE.BASIC) {
          if (locationtype_id === LOCATION_TYPE.Counter) {
            // Counter: at least one of phone or email required
            const phoneTrimmed = (phone != null && String(phone).trim() !== '') ? String(phone).trim() : '';
            const emailTrimmed = (EmailID != null && String(EmailID).trim() !== '') ? String(EmailID).trim() : '';
            if (phoneTrimmed === '' && emailTrimmed === '') {
              toast.error(this.props.t('Assign.Counter.PhoneOrEmailRequired', { defaultValue: 'Phone or email is required for counter assignment.' }));
              this.setState({ loader: false, isRetrying: false });
              return;
            }
          } else {
            // Non-Counter: both required
            if ([undefined, 'undefined', null, 'null', ''].includes(EmailID)) {
              toast.error(this.props.t('Toast.Error.EnterEmail'));
              this.setState({ loader: false, isRetrying: false });
              return;
            }
            if ([undefined, 'undefined', null, 'null', ''].includes(phone)) {
              toast.error(this.props.t('Toast.Error.EnterMobile'));
              this.setState({ loader: false, isRetrying: false });
              return;
            }
          }
        }

        if (this.shouldShowBasicUI()) {
          let phoneError = false;
          let dobError = false;
          let rxError = false;

          if (!phone) {
            phoneError = true;
          } else {
            const cleaned = phone.replace(/\D/g, '');
            if (cleaned.length !== 10) {
              phoneError = true;
            }
          }

          if (!dateOfBirth) {
            dobError = true;
          } else if (!moment(dateOfBirth, 'MM/DD/YYYY', true).isValid()) {
            dobError = true;
          }

          const isAnyRxMissing = this.state.rxEntries.some(
            (entry) => !entry.rxNumber.trim()
          );
          if (isAnyRxMissing) {
            rxError = true;
            toast.error(this.props.t('Toast.Error.RxRequired'))
          }

          if (phoneError || dobError || rxError) {
            this.setState({ phoneError, dobError, rxError, loader: false, isRetrying: false });
            return;
          }
        }

        if (!isVerifyingBin) {
          const serverPrescriptionReqPayload =
            this.shouldShowBasicUI()
              ? await this.prepareBasicPayload()
              : await this.prepareServerPrescrptionReqPayload();
          if(locationtype_id === LOCATION_TYPE.Kiosk) {
            const isKioskGoliathAssignment =
              boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
            if (
              !isKioskGoliathAssignment &&
              [undefined, "undefined", null, "null", ""].includes(
                serverPrescriptionReqPayload.prescription.bin_id
              )
            ) {
              toast.error(this.props.t('Assign.SelectBinToContinueOrRefresh'));
              this.setState({ loader: false, isRetrying: false });
              return;
            }
            
            // Additional defense for Fastlane: Ensure bin_id is not NaN or invalid
            // Only validate if Fastlane is actually selected
            const isFastlaneSelection =
              boxTypeId === BOX_TYPE.FASTLANE &&
              (
                this.state.selectedAssignmentLocation === 'fastlane' ||
                !this.state.selectedAssignmentLocation
              );
            if (isFastlaneSelection) {
              const binIdValue = serverPrescriptionReqPayload.prescription.bin_id;
              if ([null, "null", undefined, "undefined", "", 0].includes(binIdValue)) {
                console.error("Invalid Fastlane bin ID detected:", binIdValue);
                this.setState({ 
                  loader: false,
                  isRetrying: false,
                  fastlaneBinValidationError: true,
                  pendingSaveMode: type
                });
                return;
              }
            }
          }
          console.log('📍 [ASSIGN PRESCRIPTION] Creating Order with Location Details:', {
            locationTypeId: serverPrescriptionReqPayload.prescription.locationtype_id,
            locationTypeName: (this.state.locationtype && this.state.locationtype.find(l => l.id === serverPrescriptionReqPayload.prescription.locationtype_id)) ? this.state.locationtype.find(l => l.id === serverPrescriptionReqPayload.prescription.locationtype_id).label : 'Unknown',
            boxId: serverPrescriptionReqPayload.prescription.box_id,
            boxName: (this.state.selectedBox && this.state.selectedBox.name) || 'Not Set',
            binId: serverPrescriptionReqPayload.prescription.bin_id,
            isKiosk: serverPrescriptionReqPayload.prescription.locationtype_id === LOCATION_TYPE.Kiosk,
            endpoint: 'serve/prescription'
          });
          fetch(process.env.REACT_APP_BASEURL + "serve/prescription", {
            method: "post",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(serverPrescriptionReqPayload),
          })
            .then((response) => {
              try {
                return response.json();
              } catch (error) {
                return null;
              }
            })
            .then(async (serverPrescriptionResponse) => {
              const createdOrderLocationTypeId = (serverPrescriptionResponse && serverPrescriptionResponse.patient && serverPrescriptionResponse.patient.locationtype_id) || serverPrescriptionReqPayload.prescription.locationtype_id;
              console.log('📍 [ASSIGN PRESCRIPTION] Order Created Successfully:', {
                locationTypeId: createdOrderLocationTypeId,
                locationTypeName: (this.state.locationtype && this.state.locationtype.find(l => l.id === createdOrderLocationTypeId)) ? this.state.locationtype.find(l => l.id === createdOrderLocationTypeId).label : 'Unknown',
                boxId: serverPrescriptionReqPayload.prescription.box_id,
                boxName: (this.state.selectedBox && this.state.selectedBox.name) || 'Not Set',
                isKiosk: createdOrderLocationTypeId === LOCATION_TYPE.Kiosk,
                patientId: (serverPrescriptionResponse && serverPrescriptionResponse.patient && serverPrescriptionResponse.patient.id) || null
              });
              // If Location Type is not Kiosk, call different function.
              if (
                serverPrescriptionResponse &&
                serverPrescriptionResponse.statusCode === 500
              ) {
                const failedOrderLocationTypeId = serverPrescriptionReqPayload.prescription.locationtype_id;
                console.error('📍 [ASSIGN PRESCRIPTION] Order Creation Failed:', {
                  error: serverPrescriptionResponse.statusCode,
                  locationTypeId: failedOrderLocationTypeId,
                  locationTypeName: (this.state.locationtype && this.state.locationtype.find(l => l.id === failedOrderLocationTypeId)) ? this.state.locationtype.find(l => l.id === failedOrderLocationTypeId).label : 'Unknown',
                  boxId: serverPrescriptionReqPayload.prescription.box_id,
                  boxName: (this.state.selectedBox && this.state.selectedBox.name) || 'Not Set'
                });
                this.setState({ loader: false, isRetrying: false });
                toast.error(
                  this.props.t(
                    "Toast.Error.DeliverPrescription.ServePrescription"
                  )
                );
                return;
              }
              const { patient } = serverPrescriptionResponse;
              if (patient && patient.id) {
              if (patient.locationtype_id !== LOCATION_TYPE.Kiosk) {
              console.log('📍 [ASSIGN PRESCRIPTION] Sending delivery notification for non-Kiosk:', {
                locationTypeId: patient.locationtype_id,
                locationTypeName: (this.state.locationtype && this.state.locationtype.find(l => l.id === patient.locationtype_id)) ? this.state.locationtype.find(l => l.id === patient.locationtype_id).label : 'Unknown',
                boxId: serverPrescriptionReqPayload.prescription.box_id,
                boxName: (this.state.selectedBox && this.state.selectedBox.name) || 'Not Set',
                patientId: patient.id
              });
                  await this.servePrescriptionForOtherDeliveryTypes(
                    serverPrescriptionResponse,
                    courier_tracking,
                    default_courier_selected
                  );
                }
              }
              
              // Emit updateConsole for Counter orders to trigger order list refresh
              if (createdOrderLocationTypeId === LOCATION_TYPE.Counter && this.socket) {
                this.socket.emit('updateConsole');
              }
              
              this.setState({
                loader: false,
                show_order_notes_dialog: false,
                servePresRetryCount: 3,
                servePresFetchCount: 0,
                isRetrying: false,
              });
              this.handleFocus();
              if (type === 1) {
                // Fetch fresh data from database and open print dialog
                // Preserve selectedBinId until after print dialog is opened
                const preservedBinId = this.state.selectedBinId;
                try {
                  await this.handleOpenPrintDialogWithFreshData(serverPrescriptionResponse, preservedBinId);
                } catch (error) {
                  console.error('Error opening print dialog:', error);
                  toast.error(this.props.t('Toast.Error.PrintDialog') || 'Failed to open print dialog: ' + (error.message || error));
                }
              } else {
                toast.success(
                  this.props.t("Assign.RxAssignedSuccessfully")
                );
              }
              // Clear fields after print dialog is handled (for type 1) or after success message (for type 0)
              searchedRxItems = [];
              this.setState({
                selectedBinId: "",
                searchedItems: [],
                rxNumber: "",
                EmailID: "",
                phone: "",
                makeFastlaneAPICall: true,
                show_order_notes_dialog: false,
              });
              // Only call ClearFields for type 0 to avoid duplicate clearing
              if (type !== 1) {
                this.ClearFields();
              }
            })
            .catch((error) => {
              if (servePresRetryCount > 0) {
                console.log(`Retrying assignment... Attempts remaining: ${servePresRetryCount - 1}`);
                this.setState(
                  (prevState) => ({
                    loader: false,
                    show_order_notes_dialog: false,
                    servePresRetryCount: prevState.servePresRetryCount - 1,
                    isRetrying: false,
                  }),
                  () => {
                    setTimeout(() => {
                      this.checkIfBinIsOccupedFromAnotherLocation(type);
                    }, 1000);
                  }
                );
              } else {
                // After all retries exhausted, show error and reset count
                console.error('Assignment failed after all retry attempts:', error);
                toast.error(
                  t("Toast.Error.DeliverPrescription.ServePrescription") +
                    (error && error.message ? `: ${error.message}` : '')
                );
                // Reset retry count and fetch count for next attempt
                this.setState({
                  loader: false,
                  servePresRetryCount: 3,
                  servePresFetchCount: 0,
                  isRetrying: false,
                  show_order_notes_dialog: false,
                });
              }
            });
          
        }
      }
    }
  };

  /**
   * Fetches complete order data from database for label printing
   * Uses existing /rxbybin API to get fresh data
   * @param {number} boxId - Box ID
   * @param {number} binId - Bin ID  
   * @param {string} pmId - Prescription master ID
   * @returns {object|null} Structured label data or null if error
   */
  fetchOrderDataForPrint = async (boxId, binId, pmId) => {
    this.setState({ printLoading: true });
    
    try {
      // Create abort controller for timeout handling (Test 1.7)
      // eslint-disable-next-line no-undef
      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      const timeoutId = controller ? setTimeout(() => controller.abort(), 30000) : null; // 30 second timeout
      
      // For Counter, bin_id can be null/empty - API should handle it
      const requestBody = {
        id: boxId,
        bin_id: binId || null, // Use null instead of empty string
        pm_id: pmId,
        stock_code: this.state.stockCode || null
      };
      
      const fetchOptions = {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + 
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      };
      
      // Add signal only if AbortController is available
      if (controller && controller.signal) {
        fetchOptions.signal = controller.signal;
      }
      
      const response = await fetch(
        process.env.REACT_APP_BASEURL + 'rxbybin',
        fetchOptions
      );
      
      if (timeoutId) clearTimeout(timeoutId);
      
      // Check HTTP status (Test 1.3, 1.6)
      if (!response.ok) {
        throw new Error(`API returned status ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();

      if (!data || !data.response || !data.response.box) {
        throw new Error('Invalid response structure from /rxbybin');
      }
      
      const details = data.response.box;
      const customers = details.customers;
      
      if (!customers || customers.length === 0) {
        throw new Error('No customer data found');
      }
      
      const customer = customers[0];
      const orders = customer.orders;
      
      if (!orders || orders.length === 0) {
        throw new Error('No order data found');
      }
      
      const order = orders[0];
      const items = order.items || [];
      const contacts = customer.contacts || [];
      const contact = contacts[0] || {};
      
      // For Counter, if binId was empty in request but exists in order response, use it
      let finalBinId = binId;
      if (!binId && order.bin_id) {
        finalBinId = order.bin_id;
      }
      
      // Extract and structure label data
      const labelData = {
        // Codes
        stockCode: order.stock_code,
        pickupCode: order.pucode,
        
        // Patient Info
        firstName: customer.first_name,
        lastName: customer.last_name,
        dateOfBirth: customer.dob_str,
        patientId: customer.patient_id,
        
        // Prescription Info
        binId: finalBinId || order.bin_id, // Use finalBinId if we updated it, otherwise use from order
        isCoolItem: order.is_cool_item || false,
        rxNumbers: items.map(item => item.rx_no),
        rxItems: items,
        
        // Location
        locationTypeId: order.customerLocations && order.customerLocations.length > 0 
          ? order.customerLocations[0].locationtype_id 
          : null,
        
        // Contact
        email: contact.email,
        phone: contact.phone,
        
        // Order metadata
        orderId: order.id,
        createdOn: order.created_on,
        
        // For BASIC connection type
        rxEntries: items.map(item => ({
          rxNumber: item.rx_no,
          isConsultRequired: item.is_consultrequire
        }))
      };
      
      this.setState({ printLoading: false });
      return labelData;
      
    } catch (error) {
      // Handle specific error types (Test 1.7 - timeout)
      if (error.name === 'AbortError') {
        toast.error(this.props.t('Toast.Error.LabelData.Timeout') || 'Request timed out. Please try again.');
      } else if (error.message && error.message.includes('status')) {
        toast.error(this.props.t('Toast.Error.LabelData.ApiError') || `API Error: ${error.message}`);
      } else {
        toast.error(this.props.t('Toast.Error.LabelData.FetchFailed') || `Failed to fetch label data: ${error.message || error}`);
      }
      
      this.setState({ printLoading: false });
      return null;
    }
  };

  /**
   * Validates that all required fields for label printing are present
   * @param {object} labelData - Label data object
   * @param {string} locationtype_id - Location type ID (optional, for Counter binId validation)
   * @returns {object} { isValid: boolean, missingFields: string[] }
   */
  validateLabelData = (labelData, locationtype_id = null, boxTypeId = null) => {
    const isCounter = locationtype_id === LOCATION_TYPE.Counter;
    const isFastlaneGoliath = boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const isBinOptional = isCounter || isFastlaneGoliath;
    
    if (!labelData) {
      return { isValid: false, missingFields: ['labelData is null'] };
    }
    
    const requiredFields = {
      stockCode: labelData.stockCode,
      pickupCode: labelData.pickupCode,
      firstName: labelData.firstName,
      lastName: labelData.lastName,
      dateOfBirth: labelData.dateOfBirth,
      // binId is optional for Counter and Fastlane Goliath
      ...(isBinOptional ? {} : { binId: labelData.binId }),
      rxNumbers: labelData.rxNumbers
    };
    
    // For optional-bin flows, still check binId when present but don't fail when missing
    if (isBinOptional && labelData.binId) {
      requiredFields.binId = labelData.binId;
    }
    
    const missingFields = [];
    
    Object.keys(requiredFields).forEach(field => {
      const value = requiredFields[field];
      if ([undefined, null, '', 'undefined', 'null'].includes(value)) {
        missingFields.push(field);
      } else if (field === 'rxNumbers' && (!Array.isArray(value) || value.length === 0)) {
        missingFields.push('rxNumbers (empty array)');
      }
    });
    
    // For optional-bin flows, remove binId from missingFields if present
    if (isBinOptional && missingFields.includes('binId')) {
      const binIdIndex = missingFields.indexOf('binId');
      if (binIdIndex > -1) {
        missingFields.splice(binIdIndex, 1);
      }
    }
    
    const isValid = missingFields.length === 0;
    
    return { isValid, missingFields };
  };

  /**
   * Opens print dialog with fresh data fetched from database
   * @param {object} serverPrescriptionResponse - Response from /serve/prescription
   */
  handleOpenPrintDialogWithFreshData = async (serverPrescriptionResponse, preservedBinId = null) => {
    const { box_id, selectedBinId, locationtype_id } = this.state;
    
    // Extract IDs from response - check multiple possible locations for binId
    const prescription = serverPrescriptionResponse && serverPrescriptionResponse.prescription;
    const order = serverPrescriptionResponse && serverPrescriptionResponse.order;
    const patient = serverPrescriptionResponse && serverPrescriptionResponse.patient;
    
    const pmId = prescription && prescription.id;
    const prescriptionBinId = prescription && prescription.bin_id;
    const orderBinId = order && order.bin_id;
    const patientBinId = patient && patient.bin_id;
    
    // Use preserved binId if provided, otherwise try from response (check multiple locations), then fallback to current state
    let binId = preservedBinId || prescriptionBinId || orderBinId || patientBinId || selectedBinId;
    
    // For Counter location type, binId (pouch number) might be optional or come from order response
    // Allow empty binId for Counter - it will be retrieved from the order data if needed
    const isCounter = locationtype_id === LOCATION_TYPE.Counter;
    
    // For Counter with empty binId, use null or empty string - API will handle it
    const binIdForApi = isCounter && !binId ? null : binId;
    
    // Fetch fresh data from database
    const labelData = await this.fetchOrderDataForPrint(box_id, binIdForApi, pmId);
    
    if (!labelData) {
      toast.error(this.props.t('Toast.Error.LabelData.FetchFailed') || 'Failed to load label data from database');
      return;
    }
    
    // Validate data - pass locationtype_id so Counter can have optional binId
    const validation = this.validateLabelData(labelData, locationtype_id, this.state.boxTypeId);
    
    if (!validation.isValid) {
      toast.error(
        this.props.t('Toast.Error.LabelData.Incomplete') || 
        `Cannot print: missing ${validation.missingFields.join(', ')}`
      );
      return;
    }
    
    // Get branding info - use boxDetails with robust ID comparison, fallback to selectedBox
    const boxIdStr = box_id != null ? String(box_id) : '';
    const boxDetailsForBrand = this.state.boxDetails;
    const getBranding = boxDetailsForBrand && boxDetailsForBrand.find(
      (ele) => ele && String(ele.id) === boxIdStr
    );
    const selectedBoxForBrand = this.state.selectedBox;
    const gbNameForBrand = getBranding && getBranding.brandName;
    const sbNameForBrand = selectedBoxForBrand && selectedBoxForBrand.brandName;
    const brandName = (gbNameForBrand != null ? gbNameForBrand : sbNameForBrand) || '';
    const gbPhoneForBrand = getBranding && getBranding.brandPhone;
    const sbPhoneForBrand = selectedBoxForBrand && selectedBoxForBrand.brandPhone;
    const brandPhone = (gbPhoneForBrand != null ? gbPhoneForBrand : sbPhoneForBrand) || '';

    // Set state with fresh data from database
    this.setState({
      labelDataForPrint: labelData,
      stockCode: labelData.stockCode,
      pickupCode: labelData.pickupCode,
      PrintFirstName: labelData.firstName,
      PrintLastName: labelData.lastName,
      PrintDateOfBirth: labelData.dateOfBirth,
      PrintisCoolItem: labelData.isCoolItem,
      binid: labelData.binId,
      printDialogOpen: true,
      BrandingName: brandName,
      BrandingPhone: brandPhone,
      rxEntries: labelData.rxEntries,
    });
    
    // Auto-print after dialog opens
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        this.handleClosePrintDialog();
      }, 500);
    }, 1500);
  };

  /**
   * Closes print dialog and cleans up state
   */
  handleClosePrintDialog = () => {
    const fromAddAndSave = this.state._printCloseFromAddAndSave === true;
    this.setState({
      printDialogOpen: false,
      labelDataForPrint: null,
      BrandingName: '',
      BrandingPhone: '',
      loader: false,
      makeFastlaneAPICall: true,
      show_order_notes_dialog: false,
      _printCloseFromAddAndSave: false,
    });
    searchedRxNumbers = [];
    if (!fromAddAndSave) {
      toast.success(this.props.t('Assign.RxAssignedSuccessfully'));
    }
    this.ClearFields();
  };

  openPrintDialogFromRxByBin = async (boxId, binId, pmId, options = {}) => {
    const fromAddAndSave = options.fromAddAndSave === true;
    const { locationtype_id } = this.state;
    const labelData = await this.fetchOrderDataForPrint(boxId, binId || null, pmId);
    if (!labelData) return;
    const validation = this.validateLabelData(labelData, locationtype_id);
    if (!validation.isValid) {
      toast.error(
        this.props.t('Toast.Error.LabelData.Incomplete') ||
        `Cannot print: missing ${validation.missingFields.join(', ')}`
      );
      return;
    }
    const boxIdStr = boxId != null ? String(boxId) : '';
    const boxDetailsForBrand = this.state.boxDetails;
    const getBranding = boxDetailsForBrand && boxDetailsForBrand.find(
      (ele) => ele && String(ele.id) === boxIdStr
    );
    const selectedBoxForBrand = this.state.selectedBox;
    const brandName = (getBranding && getBranding.brandName) != null ? getBranding.brandName : (selectedBoxForBrand && selectedBoxForBrand.brandName) || '';
    const brandPhone = (getBranding && getBranding.brandPhone) != null ? getBranding.brandPhone : (selectedBoxForBrand && selectedBoxForBrand.brandPhone) || '';
    this.setState({
      labelDataForPrint: labelData,
      stockCode: labelData.stockCode,
      pickupCode: labelData.pickupCode,
      PrintFirstName: labelData.firstName,
      PrintLastName: labelData.lastName,
      PrintDateOfBirth: labelData.dateOfBirth,
      PrintisCoolItem: labelData.isCoolItem,
      binid: labelData.binId,
      printDialogOpen: true,
      BrandingName: brandName,
      BrandingPhone: brandPhone,
      rxEntries: labelData.rxEntries,
      _printCloseFromAddAndSave: fromAddAndSave,
    });
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        this.handleClosePrintDialog();
      }, 500);
    }, 1500);
  };

  prepareBasicPayload = async () => {
    const {
      selectedAssignmentBoxId,
      selectedAssignmentBinId,
      phone,
      box_id,
      locationtype_id,
      box_position,
      source_location,
      storage_location,
      orderId,
      address,
      dateOfBirth,
      rxEntries,
      accountDetails,
      stockCode,
      pickupCode,
      searchedItems,
      selectedBox,
      boxTypeId
    } = this.state;
    
    // Fallback for address: use searchedItems or selectedBox if address is not set
    const boxAddress = selectedBox && selectedBox.address;
    const resolvedAddress = address || {
      address1: (searchedItems && searchedItems.AddressLine1) || (boxAddress && boxAddress.address_line_1) || (selectedBox && selectedBox.address_line_1) || '',
      address2: (searchedItems && searchedItems.AddressLine2) || (boxAddress && boxAddress.address_line_2) || (selectedBox && selectedBox.address_line_2) || '',
      city: (searchedItems && searchedItems.City) || (boxAddress && boxAddress.city) || (selectedBox && selectedBox.city) || '',
      state: (searchedItems && searchedItems.State) || (boxAddress && boxAddress.state) || (selectedBox && selectedBox.state) || '',
      zip: (searchedItems && searchedItems.Zip) || (boxAddress && boxAddress.zip) || (selectedBox && selectedBox.zip) || '',
      country: (searchedItems && searchedItems.Country) || (boxAddress && boxAddress.country) || (selectedBox && selectedBox.country) || ''
    };
    
    // Use dialog selections if available
    const assignmentBoxId = selectedAssignmentBoxId || box_id;
    const isKioskGoliathAssignment =
      locationtype_id === LOCATION_TYPE.Kiosk &&
      boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    // Keep Goliath orders unassigned until stocking.
    const assignmentBinId = isKioskGoliathAssignment
      ? null
      : (selectedAssignmentBinId || await this.getSelectedBinsByType());
    // Use codes from state - no localStorage
    let codes = {
      stockCode: stockCode || '',
      pickupCode: pickupCode || ''
    };

    let rxItems = rxEntries && rxEntries.map((item) => ({
      rx_no: item.rxNumber,
      drug_name: "",
      ndc_code: "",
      price: 0,
      expires_on: null,
      qty: 0,
      strength: "",
      route: "",
      doseage_form: "",
      non_proprietary_name: "",
      fillNumber: 0,
      is_consultrequire: item.isConsultRequired,
      is_returnable: false,
      prescriptionnumber: "",
      order_id: "",
      prescription_txn_id: "",
      pucode: codes.pickupCode,
      SeqNumber: 0,
      dateFilled: 0,
      partialfillseqnum: 0
    }));

    return {
      first_name: accountDetails.basic_first_name || 'iLocal',
      middle_name: '',
      last_name: accountDetails.basic_last_name || 'Box',
      dob: dateOfBirth,
      phone: phone,
      email: '',
      parent_box_id: assignmentBoxId,
      patient_id: phone && phone.replace(/\D/g, ''),
      locationtype_id: locationtype_id,
      address1: resolvedAddress.address1,
      address2: resolvedAddress.address2,
      city: resolvedAddress.city,
      state: resolvedAddress.state,
      zip: resolvedAddress.zip,
      country: resolvedAddress.country,
      location_notes: '',
      is_future_release: false,
      future_release_date: null,
      notes: '',
      alternateAgents: [],
      prescription: {
        bin_id: assignmentBinId,
        type_id: locationtype_id === LOCATION_TYPE.Kiosk ? assignmentstatus.ASSIGNED : DEVICE_TYPE.Ready,
        stock_code: codes.stockCode,
        pucode: codes.pickupCode,
        box_id: assignmentBoxId,
        box_position: box_position,
        locationtype_id: locationtype_id,
        source_location: source_location,
        storage_location: storage_location,
        order_notes: '',
        location_notes: '',
        order_id: orderId,
        courier_type: '',
        tracking_number: '',
        iscool_item: false,
        items: rxItems,
        is_controlled_substance: false,
        assign_order_notes: ""
      },
    };
  };
  prepareServerPrescrptionReqPayload = async () => {
    const {
      accountDetails,
      EmailID,
      phone,
      searchedItems,
      box_id,
      locationtype_id,
      boxTypeId,
      box_position,
      source_location,
      storage_location,
      locationData,
      order_notes,
      orderId,
      default_courier_selected,
      courier_tracking,
      isSelectedFlag,
      FutureRelease,
      FutureReleaseDate,
      alternateAgents,
      is_controlled_substance,
      assign_order_notes,
      stockCode,
      pickupCode
    } = this.state;
    
    const isKioskGoliathAssignment =
      locationtype_id === LOCATION_TYPE.Kiosk &&
      boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    // Keep Goliath orders unassigned until stocking.
    const assignmentBinId = isKioskGoliathAssignment
      ? null
      : await this.getSelectedBinsByType();
    const assignmentBoxId = box_id; // Always use main box_id for hardware access
    
    // Determine is_fastlane: false if bin is from add-on (letter+number pattern), true if Fastlane
    let isFastlaneAssignment = true; // Default to true for Fastlane
    const isAddOnBinId = assignmentBinId && this.isAddOnBin(assignmentBinId);
    console.log('🔍 Determining isFastlane flag:', {
      assignmentBinId,
      assignmentBinIdType: typeof assignmentBinId,
      isAddOnBinId,
      boxTypeId,
      locationtype_id
    });
    
    if (isAddOnBinId) {
      isFastlaneAssignment = false; // Add-on/locker assignment
      console.log('✅ Setting isFastlane = false (add-on bin detected)');
    } else if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
      isFastlaneAssignment = true; // Fastlane assignment
      console.log('✅ Setting isFastlane = true (Fastlane assignment)');
    } else if (boxTypeId === BOX_TYPE.FASTLANEGOLIATH && locationtype_id === LOCATION_TYPE.Kiosk) {
      isFastlaneAssignment = true; // Fastlane assignment
      console.log('✅ Setting isFastlane = true (Fastlane Goliath assignment)');
    } else {
      isFastlaneAssignment = false; // Non-Fastlane assignment
      console.log('✅ Setting isFastlane = false (non-Fastlane)');
    }
    // Use codes from state - no localStorage
    let codes = {
      stockCode: stockCode || '',
      pickupCode: pickupCode || ''
    };
    
    const payload = {
      first_name: searchedItems.FirstName,
      middle_name: searchedItems.MiddleName,
      last_name: searchedItems.LastName,
      dob: searchedItems.DateOfBirth,
      phone:
        accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS
          ? '1234567890'
          : phone,
      email:
        accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS
          ? 'na@ilocalbox.com'
          : EmailID,
      parent_box_id: box_id,
      patient_id: searchedItems.PatientID,
      locationtype_id: this.state.locationtype_id,
      address1: searchedItems.AddressLine1,
      address2: searchedItems.AddressLine2,
      city: searchedItems.City,
      state: searchedItems.State,
      zip: searchedItems.Zip,
      country: searchedItems.Country,
      location_notes: searchedItems.location_notes,
      is_future_release: FutureRelease,
      future_release_date: FutureReleaseDate,
      notes: this.state.patientNotes,
      alternateAgents: alternateAgents,
      prescription: {
        bin_id: assignmentBinId,
        type_id:
          locationtype_id === LOCATION_TYPE.Kiosk
            ? assignmentstatus.ASSIGNED
            : DEVICE_TYPE.Ready,
        stock_code: codes.stockCode,
        pucode: codes.pickupCode,
        box_id: assignmentBoxId,
        box_position: box_position,
        locationtype_id: locationtype_id,
        source_location: source_location,
        storage_location: locationtype_id === LOCATION_TYPE.Counter && locationData && locationData.location
          ? locationData.location
          : storage_location,
        order_notes: order_notes,
        location_notes: searchedItems.location_notes,
        order_id: orderId,
        courier_type: default_courier_selected,
        tracking_number: courier_tracking,
        iscool_item: isSelectedFlag,
        items: await this.prepareReqPayloadForPrescriptionItems(),
        is_controlled_substance: [
          CONNECTION_TYPE.EPIC, 
          CONNECTION_TYPE.EPIC_WITH_MTLS, 
          CONNECTION_TYPE.MCKESSONERX, 
          CONNECTION_TYPE.PIONEERRX
        ].includes(accountDetails.connection.id) ? this.fetchControlledSubstance() : is_controlled_substance,
        assign_order_notes,
        is_fastlane: isFastlaneAssignment // Flag to distinguish Fastlane assignment (true) from locker/add-on assignment (false)
      },
    };
    
    console.log('📤 Final payload is_fastlane value:', {
      is_fastlane: isFastlaneAssignment,
      assignmentBinId,
      isAddOnBin: this.isAddOnBin(assignmentBinId)
    });
    
    return payload;
  };

  prepareReqPayloadForPrescriptionItems = async () => {
    const { accountDetails, pickupCode } = this.state;
    this.getCartRxNumbers();
    let _prescriptionItemsList = [];

    if (searchedRxItems.length > 0) {
      for (let item = 0; item < searchedRxItems.length; item++) {
        let _singleItem = searchedRxItems[item];
        let rxNo = '';
        if (accountDetails.connection.id === CONNECTION_TYPE.QS1) {
          let rx = _singleItem.rxNo.substring(0, 1);
          if ((rx === 0 || rx === '0') && _singleItem.rxNo.length > 8) {
            rxNo = _singleItem.rxNo.substring(1, _singleItem.rxNo.length);
          } else {
            rxNo = _singleItem.rxNo;
          }
        } else if (accountDetails.connection.id === CONNECTION_TYPE.THIRD_PARTY) {
          rxNo = _singleItem.id
        } else {
          rxNo = _singleItem.rxNo;
        }
        _prescriptionItemsList.push({
          rx_no: rxNo,
          drug_name: _singleItem.name || _singleItem.drug_name,
          ndc_code: _singleItem.ndcCode,
          price: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.CoPayAmount || _singleItem.amount_due
          )
            ? 0
            : _singleItem.CoPayAmount || _singleItem.amount_due,
          expires_on: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.ExpirationDate
          )
            ? '01/01/2020'
            : _singleItem.ExpirationDate,
          qty: _singleItem.qty || _singleItem.dispensed_qty,
          strength: _singleItem.strength,
          route: _singleItem.route,
          doseage_form: _singleItem.doseage_form,
          non_proprietary_name: _singleItem.non_proprietary_name,
          fillNumber: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.fillNumber || _singleItem.fillnumber
          )
            ? 0
            : _singleItem.fillNumber || _singleItem.fillnumber,
          is_consultrequire: determineConsultRequire(
            [undefined, "undefined", null, "null", ""].includes(
              _singleItem.ConsultRequire
            )
              ? false
              : _singleItem.ConsultRequire,
            _singleItem.is_controlled_substance,
            this.state.locationtype_id,
            this.state.accountDetails &&
              [true, "true"].includes(this.state.accountDetails.bypass_consult)
          ),
          is_returnable: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.IsReturnable)
            ? false
            : _singleItem.IsReturnable,
          is_controlledsubstances: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.is_controlled_substance)
            ? false
            : _singleItem.is_controlled_substance,
          prescriptionnumber: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.prescriptionNumber)
            ? ''
            : _singleItem.prescriptionNumber,
          order_id: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.order_id
          )
            ? ''
            : _singleItem.order_id,
          prescription_txn_id: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.prescription_txn_id)
            ? ''
            : _singleItem.prescription_txn_id,
          pucode: pickupCode,
          SeqNumber: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.SeqNumber
          )
            ? 0
            : _singleItem.SeqNumber,
          dateFilled: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.dateFilled
          )
            ? 0
            : _singleItem.dateFilled,
          partialfillseqnum: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.partialfillseqnum)
            ? 0
            : _singleItem.partialfillseqnum,
          tax_amount: [undefined, 'undefined', null, 'null', '', '0', 0].includes(_singleItem.tax_amount)
            ? 0
            : (typeof _singleItem.tax_amount === 'string' ? parseFloat(_singleItem.tax_amount) : _singleItem.tax_amount),
          store_number: _singleItem.StoreNumber,
          // Epic Flags & Status Information - Single JSON object containing all flag data
          epic_flag_response: (() => {
            // Build epic_flag_response object only if any flag data exists
            const hasFlags = _singleItem.Flags && Array.isArray(_singleItem.Flags) && _singleItem.Flags.length > 0;
            const hasPrescriptionFlags = _singleItem.PrescriptionFlags && Array.isArray(_singleItem.PrescriptionFlags) && _singleItem.PrescriptionFlags.length > 0;
            const hasCannotDispenseReasons = _singleItem.CannotDispenseReasons && Array.isArray(_singleItem.CannotDispenseReasons) && _singleItem.CannotDispenseReasons.length > 0;
            const hasIsDispensable = _singleItem.IsDispensable !== undefined && _singleItem.IsDispensable !== null;
            const hasReasonNotFillable = _singleItem.ReasonNotFillable !== undefined && _singleItem.ReasonNotFillable !== null && _singleItem.ReasonNotFillable !== '' && _singleItem.ReasonNotFillable !== 'null';
            const hasFillStatus = _singleItem.status !== undefined && _singleItem.status !== null && _singleItem.status !== '' && _singleItem.status !== 'null';

            // Only create object if at least one field has data
            if (hasFlags || hasPrescriptionFlags || hasCannotDispenseReasons || hasIsDispensable || hasReasonNotFillable || hasFillStatus) {
              return {
                flags: hasFlags ? _singleItem.Flags : [],
                prescription_flags: hasPrescriptionFlags ? _singleItem.PrescriptionFlags : [],
                cannot_dispense_reasons: hasCannotDispenseReasons ? _singleItem.CannotDispenseReasons : [],
                is_dispensable: hasIsDispensable ? _singleItem.IsDispensable : null,
                reason_not_fillable: hasReasonNotFillable ? _singleItem.ReasonNotFillable : null,
                fill_status: hasFillStatus ? _singleItem.status : null
              };
            }
            return null;
          })(),
        });
      }
    }
    return _prescriptionItemsList;
  };

  checkPrescriptionStatus = async () => {
    const {
      accountDetails,
      isEpicHasValidRx,
      selectedBinId,
      box_id,
    } = this.state;
    if (![undefined, 'undefined', null, 'null', ''].includes(selectedBinId)) {
      if (searchedRxItems.length > 0) {
        let obj = {
          bin_id: selectedBinId,
          box_id: box_id,
          account_id: accountDetails && accountDetails.id,
        };
        let codes = {
          stockCode: this.state.stockCode,
          pickupCode: this.state.pickupCode,
        };
        await this.checkIfCodesExists(codes);
        fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          },
          body: JSON.stringify(obj),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((res) => {
            if (
              (res && res.statusCode === 200) ||
              (res && res.statusCode === 404)
            ) {
              if (
                accountDetails.connection.id === CONNECTION_TYPE.EPIC &&
                isEpicHasValidRx === false
              ) {
                toast.error(this.props.t('Toast.Error.PrescriptionStatusVerified')
                );
                this.setState({ loader: false });
                return;
              }
              if (
                accountDetails.connection.id === CONNECTION_TYPE.EPIC_WITH_MTLS &&
                isEpicHasValidRx === false
              ) {
                toast.error(this.props.t('Toast.Error.PrescriptionStatusVerified')
                );
                this.setState({ loader: false });
                return;
              }
              if (accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS) {
                let orderIds = [];
                let prescriptionNumbers = [];
                for (let i = 0; i < searchedRxItems.length; i++) {
                  orderIds.push(searchedRxItems[i].order_id);
                  prescriptionNumbers.push(
                    searchedRxItems[i].prescriptionNumber ||
                    searchedRxItems[i].prescriptionnumber ||
                    ''
                  );
                }
                this.setState({
                  orderIds: orderIds,
                  prescriptionIds: prescriptionNumbers,
                });
              }
              if (accountDetails.connection.id === CONNECTION_TYPE.LIBERTY_SOFTWARE &&
                isEpicHasValidRx === false) {
                toast.error(this.props.t('Toast.Error.LibertyStatus'));
                this.setState({ loader: false });
                return;
              }
            } else {
              this.setState({
                isVerifyingBin: true,
                loader: false,
                isVerifyingBinMessage:
                  'This bin is currently unavailable, please select another bin.',
              });
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      }
    }
  };

  handleRxCheck = async (event, pmsType) => {
    if (event.keyCode === 13) {
      const { globalAccountConnection, rxNumber } = this.state;
      let searchedString = event.target.value;
      let originalRxNumber = '';
      let RxTobeValid;
      let is_drx_lookup = false
      if (pmsType === 'PIONEERRX') {
        if (searchedString[0].toLowerCase() === 'x') {
          RxTobeValid = searchedString.split('X')[1];
        } else {
          RxTobeValid = searchedString;
        }
        searchedString = RxTobeValid;
        originalRxNumber = rxNumber;
      }
      if (pmsType === 'MCKESSONERX') {
        const rxToValidate = this.parseMcKessonRxNumber(searchedString, globalAccountConnection);
        searchedString = rxToValidate.rxNumber
        originalRxNumber = rxNumber;
      }
      if (pmsType === 'LIBERTYSOFTWARE') {
        searchedString = this.parseLibertyRxNumber(searchedString, globalAccountConnection.liberty_rx_regrx)._scriptNumber;
        originalRxNumber = rxNumber;
      }
      if(pmsType === 'EPIC' || pmsType === 'Epic With MTLS') {
        // Store the original scanned value BEFORE parsing
        originalRxNumber = event.target.value;
        
        const parsedResponse = globalAccountConnection &&
          globalAccountConnection.vial_label_scan &&
          globalAccountConnection.vial_label_scan === true
            ? await this.parseScannedQrCodeForVialLabelScan(searchedString)
            : await this.parseScannedQrCode(searchedString);
        
        searchedString = parsedResponse.prescriptionNumber;
        searchedString = globalAccountConnection &&
        globalAccountConnection.vial_label_scan &&
        globalAccountConnection.vial_label_scan === true
          ? searchedString
          : searchedString[0];
      }
      if(pmsType === 'DRX') {
        is_drx_lookup = true;
        originalRxNumber = rxNumber;
      }
      this.setState({ scannedRxScript: searchedString, originalScannedScript: originalRxNumber})
      if (![undefined, 'undefined', null, 'null', ''].includes(searchedString)) {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + 'checkrxexistornot/' + searchedString + '/' + is_drx_lookup, {
          method: 'GET',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
        }).then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        }).then((res) => {
          this.setState({ selectedPMSType: pmsType, loader: false });
          if ([true, "true"].includes(res && res.Rx_Is_Exist)) {
            this.setState({ confirmPMSDialogOpen: true });
          } else {
            this.handlePMSDialogYesEvent();
          }
          return res && res.Rx_Is_Exist;
        }).catch(() => {
          this.setState({ loader: false });
        })
      }
    }
  }

  handlePMSDialogYesEvent = () => {
    const { selectedPMSType } = this.state;
    this.setState({ confirmPMSDialogOpen: false });
    switch (selectedPMSType) {
      case 'QS1':
        this.handleQS1KeyDown();
        break;
      case 'PIONEERRX':
        this.handlePioneerKeyDown();
        break;
      case 'LIBERTYSOFTWARE':
        this.handleLibertySoftwareKeyDown()
        break;
      case 'MCKESSONERX':
        this.handleMcKessonRxKeyDown()
        break;
      case 'EPIC':
        this.handleEpicKeyDown()
        break;
      case 'Epic With MTLS': 
        this.handleEpicWithmTLSKeyDown()
        break;
      case 'DRX':
        this.handleDRXKeyDown()
        break;
      default:
        break;
    }
  }

  handlePMSDialogNoEvent = () => {
    this.setState({
      rxNumber: '',
      loader: false,
      confirmPMSDialogOpen: false
    });
    this.handleFocus();
  }

  handleLibertySoftwareKeyDown = () => {
    const { originalScannedScript } = this.state;
    let searchedString = originalScannedScript;
    this.setState({ loader: true, isEdit: false, confirmPMSDialogOpen: false });
    fetch(`${process.env.REACT_APP_BASEURL}liberty-software/GetPrescriptionByScriptNumber/${searchedString}`, {
      crossDomain: true,
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      }
    }).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then((res) => {
      console.log(res);
      this.setState({ loader: false, isEdit: false });
      if (res && res !== '') {
        let patientDetails = res.patient;
        let rxDetails = res.prescription;
        this.setState({ loader: false });
        if (
          rxDetails !== undefined &&
          rxDetails !== 'undefined' &&
          rxDetails !== null &&
          rxDetails !== 'null' &&
          rxDetails !== ''
        ) {
          if (['PickedUp', 'Shipped'].includes(rxDetails.StatusCode)) {
            this.setState({
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `The status of Rx: ${searchedString} is ${rxDetails.StatusCode}.`,
              rxNumber: '',
            });
          }
        }
        if (rxDetails === undefined || rxDetails === 'undefined') {
          toast.error(res.errorMessage);
          this.setState({
            rxNumber: '',
          });
          return;
        }
        const existingItem = this.state.searchedItems;
        if (
          existingItem &&
          searchedRxItems &&
          searchedRxItems.length > 0
        ) {
          let isexist = searchedRxItems.findIndex(
            (x) => x.rxNo === searchedString
          );
          if (existingItem.PatientID === patientDetails.patientID) {
            if (isexist < 0) {
              // Respect account-level bypass_consult flag for Liberty prescriptions
              console.log("accountDetails", this.state.accountDetails);
              if (
                this.state.accountDetails &&
                [true, "true"].includes(this.state.accountDetails.bypass_consult)
              ) {
                rxDetails.ConsultRequire = false;
              }
              searchedRxItems.push(rxDetails);
              if (
                patientDetails.email !== '' &&
                patientDetails.email !== undefined &&
                patientDetails.email !== 'undefined' &&
                patientDetails.email !== 'null' &&
                patientDetails.email !== 'null'
              ) {
                this.checkADACompatible(
                  patientDetails.patientID,
                  patientDetails.email
                );
              }
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'LIBERTYSOFTWARE'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
              });
            } else {
              toast.error(this.props.t('Toast.Error.RxAddedToCart'));
              this.setState({
                rxNumber: '',
              });
            }
          } else {
            toast.error(this.props.t('Toast.Error.WrongPatient'));
            this.setState({
              rxNumber: '',
            });
          }
        } else {
          // First Liberty script for this patient in the cart.
          // Respect account-level bypass_consult flag here as well.
          if (
            this.state.accountDetails &&
            [true, "true"].includes(this.state.accountDetails.bypass_consult)
          ) {
            rxDetails.ConsultRequire = false;
          }
          searchedRxItems.push(rxDetails);
          if (
            patientDetails.email !== null &&
            patientDetails.email !== 'null' &&
            patientDetails.email !== undefined &&
            patientDetails.email !== 'undefined' &&
            patientDetails.email !== ''
          ) {
            this.checkADACompatible(
              patientDetails.patientID,
              patientDetails.email
            );
          }
          this.getcustomerLocation(
            patientDetails,
            searchedRxItems,
            'LIBERTYSOFTWARE'
          );
          this.forceUpdate();
          this.setState({
            EmailID: patientDetails.emailAddress || patientDetails.email,
            phone: patientDetails.primaryPhone || patientDetails.phone,
            rxNumber: '',
          });
        }
      }
    }).catch((error) => {
      this.setState({
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: error && error.message + '. Looks like server is unable to featch requested data. Please try again or contact to administrator!',
        rxNumber: '',
        loader: false,
        confirmPMSDialogOpen: false
      });
    });
  }

  handleLibertySoftwareChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  }

  handleThirdPartyRxCheck = async (event, pmsType) => {
    if (event.keyCode === 13) {
      let searchedString = event.target.value;
      this.setState({ scannedRxScript: searchedString, originalScannedScript: event.target.value, loader: true })
      if (![undefined, 'undefined', null, 'null', ''].includes(searchedString)) {
        this.setState({ loader: true });
        const obj = {
          prescription_number: searchedString,
          parent_account_id: this.state.globalAccountConnection.id
        }
        fetch(process.env.REACT_APP_BASEURL + `api/v1/subscriptions/prescriptionManagement/getPrescriptionByRx`, {
          method: 'POST',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
          body: JSON.stringify(obj)
        }).then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        }).then((res) => {
          const data = res.data;
          this.setState({ selectedPMSType: pmsType, loader: false });
          if ([true, "true"].includes(res && res.Rx_Is_Exist)) {
            const existingItem = this.state.searchedItems;
            const existingPatientID = existingItem && !Array.isArray(existingItem) ? existingItem.PatientID : null;
            const newPatientID = data[0] && data[0].patient_id ? String(data[0].patient_id).trim() : null;
            
            // Check if this is the first scan (no existing patient) or same patient
            const isFirstScan = !existingPatientID || 
                                Array.isArray(existingItem) || 
                                (existingItem && Object.keys(existingItem).length === 0);
            const isSamePatient = existingPatientID && newPatientID && 
                                 String(existingPatientID).trim() === newPatientID;
            
            if (isFirstScan || isSamePatient) {
              // First scan or same patient - check if prescription already exists
              let sameRx = searchedRxItems.findIndex((x) => 
                (x.prescriptionNumber && data[0].prescriptionNumber && 
                 String(x.prescriptionNumber).trim() === String(data[0].prescriptionNumber).trim()) ||
                (x.id && data[0].id && 
                 String(x.id).trim() === String(data[0].id).trim())
              );
              
              if (sameRx < 0) {
                // Add new prescription to the array
                if (isFirstScan) {
                  searchedRxItems = data;
                } else {
                  searchedRxItems.push(data[0]);
                }
                
                this.setState({
                  EmailID: data[0].email,
                  phone: data[0].sms_phone,
                  searchedItems: {
                    FirstName: data[0].first_name,
                    LastName: data[0].last_name,
                    notes: '',
                    AddressLine1: data[0].address_line_1,
                    AddressLine2: data[0].address_line_2,
                    DateOfBirth: data[0].dob,
                    City: data[0].city,
                    State: data[0].state,
                    Zip: data[0].zip,
                    Country: '',
                    PatientID: data[0].patient_id,
                    customer_id: data[0].customer_id || data[0].customerId,
                  },
                  rxNumber: ''
                })
              } else {
                toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                this.setState({ rxNumber: '' });
              }
            } else {
              // Different patient - show error
              toast.error(this.props.t('Toast.Error.WrongPatient'));
              this.setState({ rxNumber: '' });
            }
          } else {
            toast.error(res.message);
            this.setState({ rxNumber: '' });
          }
        }).catch(() => {
          this.setState({ rxNumber: '', loader: false });
        })
      }
    }
  }

  handleThirdPartyChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      }
    );
  }

  parseLibertyRxNumber = (scriptNumber, customRegexp) => {
    console.log(customRegexp);
    let _scriptNumber = null, _refillNumber = null;
    if (!customRegexp || typeof scriptNumber !== 'string') {
        return { _scriptNumber: null, _refillNumber: null };
    }
    const cleanScriptNumber = scriptNumber.trim();
    try {
        const customPattern = new RegExp(customRegexp, 'i');
        const customMatch = cleanScriptNumber.match(customPattern);
        if (customMatch && customMatch.length >= 3) {
            _scriptNumber = customMatch[1];
            _refillNumber = customMatch[2];
        }
    } catch (error) {
        console.warn('Invalid custom regex pattern from database:', customRegexp, error && error.message);
    }
    return { _scriptNumber, _refillNumber };
  }

  fetchFastlaneBinWithRetry = async (retryCount = 0, saveMode = null) => {
    const { box_id, fastlaneBinMaxRetries } = this.state;
    const { t } = this.props;
    
    try {
      const response = await fetch(
        process.env.REACT_APP_BASEURL + `fastlane/matrix?boxId=${box_id}&status=All&tableName=&sortColumn=created_on&sortOrder=desc`,
        {
          method: 'get',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const data = await response.json();
      const binId = data && data.data && data.data.YourPosition;
      
      if (![undefined, "undefined", null, "null", "", 0].includes(binId) && !isNaN(binId)) {
        // Store in state instead of localStorage
        console.log('✅ Fastlane - Bin position from retry function:', binId);
        this.setState({ 
          fastlaneBinId: binId,
          isFastlaneRetrying: false, 
          fastlaneBinRetryCount: 0,
          fastlaneRetryMessage: '',
          fastlaneBinFetchError: false
        });
        return parseInt(binId, 10);
      } else {
        console.error('Invalid bin ID received from API:', binId);
        return null;
      }
    } catch (error) {
      console.error(`Fastlane bin fetch attempt ${retryCount + 1} failed:`, error);
      
      if (retryCount < fastlaneBinMaxRetries - 1) {
        this.setState({
          fastlaneBinRetryCount: retryCount + 1,
          fastlaneRetryMessage: t('Assign.Fastlane.RetryingAttempt', { 
            attempt: retryCount + 2, 
            total: fastlaneBinMaxRetries 
          })
        });
        
        await new Promise(resolve => setTimeout(resolve, 1000));
        return await this.fetchFastlaneBinWithRetry(retryCount + 1, saveMode);
      } else {
        this.setState({ 
          isFastlaneRetrying: false, 
          fastlaneBinRetryCount: 0,
          fastlaneRetryMessage: '',
          fastlaneBinFetchError: true,
          pendingSaveMode: saveMode,
          loader: false
        });
        return null;
      }
    }
  };

  handleFastlaneBinPositionUpdate = (position) => {
    if ([undefined, 'undefined', null, 'null', '', 0].includes(position)) {
      return;
    }

    this.setState((prevState) => {
      if (prevState.fastlaneBinId === position) {
        return null;
      }

      return { fastlaneBinId: position };
    });
  };
  getSelectedBinsByType = async (saveMode = null) => {
    const { boxTypeId, locationtype_id, selectedBinId, fastlaneBinId, storage_location } = this.state;
    let binIds = "";
    
    if (
      boxTypeId === BOX_TYPE.FASTLANE &&
      locationtype_id === LOCATION_TYPE.Kiosk
    ) {
      // For Fastlane: 
      // If user selected a bin (from add-on or anywhere), use it
      // Otherwise, use fastlaneBinId (Your position) for normal Fastlane flow
      if (selectedBinId && ![undefined, 'undefined', null, 'null', ''].includes(selectedBinId)) {
        binIds = selectedBinId;
        console.log('📦 Fastlane - Using selected bin:', binIds, this.isAddOnBin(selectedBinId) ? '(add-on)' : '(fastlane)');
      } else if (fastlaneBinId && ![undefined, "undefined", null, "null", "", 0].includes(fastlaneBinId)) {
        binIds = fastlaneBinId;
        console.log('📦 Fastlane - Using fastlaneBinId (Your position):', binIds);
      }
      
      if ([undefined, "undefined", null, "null", "", 0].includes(binIds)) {
        console.warn("Fastlane bin ID not available. Attempting to fetch with retry...");
        this.setState({ 
          isFastlaneRetrying: true,
          fastlaneRetryMessage: this.props.t('Assign.Fastlane.FetchingAttempt', { 
            attempt: 1, 
            total: this.state.fastlaneBinMaxRetries 
          })
        });
        
        binIds = await this.fetchFastlaneBinWithRetry(0, saveMode);
        
        if ([undefined, "undefined", null, "null", "", 0].includes(binIds)) {
          console.error("Fastlane bin ID is invalid or empty after retries. Cannot proceed with assignment.");
          return null;
        }
      }
    } else if (
      boxTypeId === BOX_TYPE.FASTLANEGOLIATH &&
      locationtype_id === LOCATION_TYPE.Kiosk
    ) {
      // For Goliath, do not fetch next/available bin at assignment time.
      // Keep it null (or explicit selected add-on bin when provided).
      binIds =
        selectedBinId && ![undefined, 'undefined', null, 'null', ''].includes(selectedBinId)
          ? selectedBinId
          : null;
    } else {
      // For non-Fastlane Kiosk: use selectedBinId
      // For Counter: use storage_location (manually entered location/pouch number)
      // For other location types: return null
      if (locationtype_id === LOCATION_TYPE.Kiosk) {
        binIds = selectedBinId;
      } else if (locationtype_id === LOCATION_TYPE.Counter) {
        binIds = storage_location && storage_location !== "" ? storage_location : null;
      } else {
        binIds = null;
      }
    }
    return binIds;
  };

  getAccountAndPatientIdByPhiType = (typeOfPhi, patient) => {
    let obj;
    if (typeOfPhi === 'Epic') {
      obj = {
        patientID: patient.MedicalRecordNumber,
        accountID: this.state.accountDetails.id,
      }
    } else if (typeOfPhi === 'Epic With MTLS') {
      obj = {
        patientID: patient.MedicalRecordNumber,
        accountID: this.state.accountDetails.id,
      }
    } else if (typeOfPhi === 'MScripts') {
      obj = {
        patientID: patient.PatientID || patient.patient_id || patient.patientID,
        accountID: patient.parent_account_id,
      }
    } else if (typeOfPhi === 'McKesson') {
      obj = {
        patientID: patient && patient.ExternalPatientID,
        accountID: this.state && this.state.globalAccountConnection.id,
      };
    } else {
      obj = {
        patientID: patient.PatientID || patient.patient_id || patient.patientID,
        accountID: this.state.globalAccountConnection.id,
      };
    }
    return obj;
  }

  handleFastlaneBinErrorRetry = () => {
    const { pendingSaveMode, fastlaneBinMaxRetries } = this.state;
    this.setState({ 
      fastlaneBinFetchError: false,
      isFastlaneRetrying: true,
      fastlaneRetryMessage: this.props.t('Assign.Fastlane.FetchingAttempt', { 
        attempt: 1, 
        total: fastlaneBinMaxRetries 
      }),
      fastlaneBinRetryCount: 0
    });
    
    if (pendingSaveMode !== null) {
      this.checkIfFastlaneBinIdIsExistOrNot(pendingSaveMode);
    }
  };

  fetchFastlaneBinForValidationWithRetry = async (retryCount = 0, options = {}) => {
    const { keepLoader = false, shouldTriggerAutoAssign = true } = options;
    const { box_id, fastlaneBinMaxRetries, pendingSaveMode, boxTypeId } = this.state;
    const { t } = this.props;
    
    try {
      let URL = process.env.REACT_APP_BASEURL + `fastlane/matrix?boxId=${box_id}&status=All&tableName=&sortColumn=created_on&sortOrder=desc`;
      if(boxTypeId === BOX_TYPE.FASTLANEGOLIATH) {
        URL = process.env.REACT_APP_BASEURL + `fastlane-goliath/matrix?boxId=${box_id}&status=All&tableName=&sortColumn=created_on&sortOrder=desc`;
      }
      const response = await fetch(
        URL,
        {
          method: 'get',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const data = await response.json();
      const binId = data && data.data && data.data.YourPosition;
      
      if (![undefined, "undefined", null, "null", "", 0].includes(binId) && !isNaN(binId)) {
        // Store in state instead of localStorage
        console.log('✅ Fastlane - Fetched bin position after validation:', binId);
        
        this.setState({ 
          fastlaneBinId: binId,
          isFastlaneRetrying: false,
          fastlaneBinRetryCount: 0,
          fastlaneRetryMessage: '',
          ...(keepLoader ? {} : { loader: false })
        });
        
        if (shouldTriggerAutoAssign && pendingSaveMode !== null) {
          setTimeout(() => {
            this.checkIfBinIsOccupedFromAnotherLocation(pendingSaveMode);
          }, 100);
        }
        
        return binId;
      } else {
        console.error('Invalid bin ID received from matrix API:', binId);
        return null;
      }
    } catch (error) {
      console.error(`Fastlane validation bin fetch attempt ${retryCount + 1} failed:`, error);
      
      if (retryCount < fastlaneBinMaxRetries - 1) {
        this.setState({
          fastlaneBinRetryCount: retryCount + 1,
          fastlaneRetryMessage: t('Assign.Fastlane.RetryingAttempt', { 
            attempt: retryCount + 2, 
            total: fastlaneBinMaxRetries 
          })
        });
        
        await new Promise(resolve => setTimeout(resolve, 1000));
        return await this.fetchFastlaneBinForValidationWithRetry(retryCount + 1);
      } else {
        this.setState({ 
          isFastlaneRetrying: false,
          fastlaneBinRetryCount: 0,
          fastlaneRetryMessage: '',
          ...(keepLoader ? {} : { loader: false })
        });
        
        toast.error(t('Assign.Fastlane.FinalErrorMessage'));
        this.ClearFields();
        return null;
      }
    }
  };

  handleFastlaneBinValidationErrorRetry = async () => {
    const { fastlaneBinMaxRetries } = this.state;
    
    this.setState({ 
      fastlaneBinValidationError: false,
      isFastlaneRetrying: true,
      fastlaneRetryMessage: this.props.t('Assign.Fastlane.FetchingAttempt', { 
        attempt: 1, 
        total: fastlaneBinMaxRetries 
      }),
      fastlaneBinRetryCount: 0
    });
    
    console.log('🔄 Fastlane - Fetching latest matrix after validation error with retry...');
    
    await this.fetchFastlaneBinForValidationWithRetry(0);
  };

  handleFastlaneBinCollision = (saveMode, serverResponse = null) => {
    // Extract next available bin from API response if provided
    const nextAvailableBinId =
      serverResponse &&
      serverResponse.data &&
      serverResponse.data.nextAvailableBinId
        ? serverResponse.data.nextAvailableBinId
        : null;

    this.setState({
      isFastlaneCollisionResolving: true,
      selectedBinId: '',
      fastlaneBinId: '',
      loader: true,
      pendingSaveMode: saveMode,
      fastlaneCollisionDialogOpen: true,
      fastlaneCollisionNextBinId: nextAvailableBinId || '',
    });
  };

  handleFastlaneCollisionConfirm = async () => {
    const { fastlaneCollisionNextBinId, pendingSaveMode } = this.state;
    let refreshedBinId = fastlaneCollisionNextBinId;

    // If API did not provide next available bin, fall back to matrix API
    if (
      refreshedBinId === null ||
      refreshedBinId === undefined ||
      refreshedBinId === '' ||
      refreshedBinId === 0
    ) {
      refreshedBinId = await this.fetchFastlaneBinForValidationWithRetry(0, {
        keepLoader: true,
        shouldTriggerAutoAssign: false,
      });
    }

    if (
      ![undefined, 'undefined', null, 'null', '', 0].includes(refreshedBinId)
    ) {
      this.setState(
        {
          isFastlaneCollisionResolving: false,
          fastlaneCollisionDialogOpen: false,
          fastlaneBinId: refreshedBinId,
        },
        () => {
          if (pendingSaveMode !== null) {
            this.checkIfFastlaneBinIdIsExistOrNot(pendingSaveMode);
          }
        }
      );
    } else {
      this.setState({
        isFastlaneCollisionResolving: false,
        fastlaneCollisionDialogOpen: false,
        loader: false,
      });
    }
  };

  handleFastlaneCollisionCancel = () => {
    this.setState({
      isFastlaneCollisionResolving: false,
      fastlaneCollisionDialogOpen: false,
      loader: false,
      pendingSaveMode: null,
      fastlaneCollisionNextBinId: '',
    });
  };

  checkIfFastlaneBinIdIsExistOrNot = async (saveMode) => {
    const { box_id, selectedAssignmentBoxId, boxTypeId, locationtype_id } = this.state;
    // Goliath assignments do not use next-available-bin checks at assignment time.
    if (
      boxTypeId === BOX_TYPE.FASTLANEGOLIATH &&
      locationtype_id === LOCATION_TYPE.Kiosk
    ) {
      this.checkIfBinIsOccupedFromAnotherLocation(saveMode);
      return;
    }
    // Use selectedAssignmentBoxId from dialog if available, otherwise use box_id
    const effectiveBoxId = selectedAssignmentBoxId || box_id;
    this.setState({ loader: true, pendingSaveMode: saveMode });

    try {
      const binIds = await this.getSelectedBinsByType(saveMode);

      // Validate bin ID: check if empty/null, and for numeric bins check if valid number
      // Add-on bins (letter+number format like "CC7") are strings, so skip isNaN check for them
      const isEmpty = [undefined, 'undefined', null, 'null', ''].includes(binIds);
      const isInvalidNumeric = binIds && !this.isAddOnBin(binIds) && (isNaN(binIds) || binIds === 0);
      
      if (isEmpty || isInvalidNumeric) {
        console.error("Fastlane bin validation failed. Bin ID:", binIds);
        this.setState({ 
          loader: false,
          fastlaneBinValidationError: true
        });
        return;
      }

      // Skip bin existence check for add-on bins (they use different validation)
      // Only check for fastlane numeric bins
      if (this.isAddOnBin(binIds)) {
        console.log('📦 Skipping fastlane bin check for add-on bin:', binIds);
        // For add-on bins, proceed directly to save
        this.saveCustomerMaster(saveMode);
        return;
      }

      let URL = `${process.env.REACT_APP_BASEURL}fastlane/bin/is-exist?bin_id=${binIds}&boxId=${effectiveBoxId}`;
      if(this.state.boxTypeId === BOX_TYPE.FASTLANEGOLIATH) {
        URL = `${process.env.REACT_APP_BASEURL}fastlane-goliath/bin/is-exist?bin_id=${binIds}&boxId=${effectiveBoxId}`;
      }
      const response = await fetch(
        URL,
        {
          method: 'get',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
            'Content-Type': 'application/json',
          },
        }
      );

      let checkIfFastlaneBinIdIsExistOrNotResponse = null;
      try {
        checkIfFastlaneBinIdIsExistOrNotResponse = await response.json();
      } catch (error) {
        console.error('Unable to parse Fastlane bin validation response:', error);
      }

      if (checkIfFastlaneBinIdIsExistOrNotResponse && checkIfFastlaneBinIdIsExistOrNotResponse.statusCode === 200) {
        const isBinInUse =
          checkIfFastlaneBinIdIsExistOrNotResponse &&
          checkIfFastlaneBinIdIsExistOrNotResponse.data &&
          checkIfFastlaneBinIdIsExistOrNotResponse.data.isExist === true;

        if (isBinInUse) {
          await this.handleFastlaneBinCollision(
            saveMode,
            checkIfFastlaneBinIdIsExistOrNotResponse
          );
          return;
        }

        this.setState({ loader: false, isFastlaneCollisionResolving: false });
        this.checkIfBinIsOccupedFromAnotherLocation(saveMode);
      } else {
        this.setState({ loader: false, isFastlaneCollisionResolving: false });
        toast.error(this.props.t('Assign.Fastlane.BinCheckError'));
      }
    } catch (error) {
      console.error('Error in checkIfFastlaneBinIdIsExistOrNot:', error);
      this.setState({ 
        loader: false,
        fastlaneBinValidationError: true,
        isFastlaneCollisionResolving: false
      });
    }
  }

  handleBinActivationChange = () => {
    let { selectedBinId, deactivatedBins, box_id } = this.state;
    this.setState({ loader: true })
    if (deactivatedBins.includes(selectedBinId)) {
      deactivatedBins = deactivatedBins.filter(item => item !== selectedBinId);
    } else {
      deactivatedBins.push(selectedBinId);
    }
    deactivatedBins = deactivatedBins.filter(item => item !== '');
    this.setState({ deactivatedBins })
    let varname = '';
    varname = deactivatedBins.join(',');
    const obj = {
      disabled_bins: varname,
      id: box_id
    }
    fetch(process.env.REACT_APP_BASEURL + 'boxs', {
      method: 'put',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken
      },
      body: JSON.stringify(obj)
    }).then((res) => {
      try {
        return res.json();
      } catch (error) {
        return null;
      }
    }).then((data) => {
      if (data.message) {
        console.log(data.message);
      }
      this.setState({ loader: false })
    }).catch((error) => {
      console.log(error);
      this.setState({ loader: false })
    })
    this.ClearFields();
  }

  createRowAlterAgent = () => {
    const { classes, t } = this.props;
    let alternateAgents = this.state && this.state.alternateAgents;
    let row =
      alternateAgents &&
      alternateAgents.map((val, idx) => (
        <div className={classes.styleBottom}>
          <React.Fragment>
            <div>
              <Grid container>
                <Grid item xs={2} style={{ maxWidth: '160px' }}>
                  <Button
                    style={{ marginLeft: '4%', marginTop: '5%' }}
                    className={classes.styleBottom1}
                    onClick={() => this.removeAlternetAgentRow(idx)}
                    color='primary'
                    disabled={this.state.readOnly}
                  >
                    {t('Patient.Preference.AlternateContactRemoveButton')}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={2}
                  className={classes.styleBottom1}
                  style={{ marginLeft: '-4rem', maxWidth: '120px' }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={val.isdefault}
                        onChange={this.onChangeAgentActive(idx)}
                        value='default'
                        color='primary'
                        disabled={this.state.readOnly}
                      />
                    }
                    label={
                      <span
                        style={{
                          color: '#000',
                          fontSize: '0.875rem',
                          fontWeight: '400',
                          lineHeight: '1.46429em',
                        }}
                      >
                        {t('Patient.Preference.AlternateContactActiveCheckbox')}
                      </span>
                    }
                    style={{ marginTop: '5px' }}
                  />
                </Grid>
                <Grid item xs={2} style={{ marginRight: '2px' }}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='dense'
                    value={val.agent_firstname}
                    id='agent_firstname'
                    label={t('Patient.Preference.AlternateContactFirstName')}
                    placeholder=''
                    onChange={this.onChangeAgentFirstName(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: this.state.readOnly,
                      maxLength: 50,
                      autoComplete: 'new-password',
                      form: {
                        autoComplete: 'off',
                      },
                    }}
                    sx={{
                      '&.MuiFormControl-marginDense': { marginTop: '0px' },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={2} style={{ marginRight: '2px' }}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='dense'
                    value={val.agent_lastname}
                    id='Last_Name'
                    label={t('Patient.Preference.AlternateContactLastName')}
                    placeholder=''
                    onChange={this.onChangeAgentLastName(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: this.state.readOnly,
                      maxLength: 50,
                      autoComplete: 'new-password',
                      form: {
                        autoComplete: 'off',
                      },
                    }}
                    sx={{
                      '&.MuiFormControl-marginDense': { marginTop: '0px' },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={2} style={{ maxWidth: '190px' }}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='dense'
                    value={val.agent_email}
                    id='Email'
                    label={t('Patient.Preference.AlternateContactEmail')}
                    placeholder=''
                    onChange={this.onChangeAgentEmail(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: this.state.readOnly,
                      maxLength: 50,
                      autoComplete: 'new-password',
                      form: {
                        autoComplete: 'off',
                      },
                    }}
                    sx={{
                      '&.MuiFormControl-marginDense': { marginTop: '0px' }, width: '250px'
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={2} style={{ marginLeft: '4rem' }}>
                  <PhoneInput
                    labelStyle={{ left: '-13px', top: '-17px' }}
                    className={classes.halfTextFieldAgents}
                    id='smsphone'
                    name='phone'
                    onBlur={this.onChangeAgentsmsphone(idx)}
                    defaultValue={val.agent_sms}
                    readOnly={this.state.readOnly}
                    style={{ width: '133px' }}
                  />
                </Grid>
              </Grid>
            </div>
          </React.Fragment>
        </div>
      ));
    return row;
  };

  addAlterAgentRow = () => {
    this.setState({
      alternateAgents:
        this.state &&
        this.state.alternateAgents &&
        this.state.alternateAgents.concat([
          {
            agent_firstname: '',
            agent_lastname: '',
            agent_email: '',
            agent_sms: '',
            isdefault: false,
          },
        ]),
    });
  };

  onChangeAgentFirstName = (idx) => (evt) => {
    const agent_firstname =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: evt.target.value,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agent_firstname });
  };

  onChangeAgentLastName = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: evt.target.value,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  onChangeAgentEmail = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: evt.target.value,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  onChangeAgentsmsphone = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: evt.target.value,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  onChangeAgentActive = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: evt.target.checked,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  removeAlternetAgentRow = (i) => {
    this.setState({
      alternateAgents: this.state.alternateAgents.filter((s, sidx) => i !== sidx),
    });
  };

  servePrescriptionForOtherDeliveryTypes = async (serverPrescriptionResponse, courier_tracking, default_courier_selected) => {
    const { t } = this.props;
    const { patient, prescription } = serverPrescriptionResponse;
    if (prescription && prescription.id) {
      let data = {
        order_id: prescription.id,
        account_id: patient.parent_account_id,
        location_type_id: patient.locationtype_id,
        courier_tracking: courier_tracking,
        default_courier_selected: default_courier_selected,
      };
      const requestUrl = `${[LOCATION_TYPE.Bedside].includes(data.location_type_id)
        ? 'delivery/bedsidenotification'
        : 'delivery/notifications'
        }`;
      fetch(process.env.REACT_APP_BASEURL + requestUrl, {
        method: 'POST',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user'))
              .signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }).then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      }).then((servePrescriptionForOtherDeliveryTypesResponse) => {
        console.log('📍 [ASSIGN PRESCRIPTION] Delivery notification sent successfully:', {
          response: servePrescriptionForOtherDeliveryTypesResponse,
          locationTypeId: data.location_type_id
        });
        this.setState({ loader: false });
      }).catch((error) => {
        console.error('📍 [ASSIGN PRESCRIPTION] Delivery notification failed:', {
          error: error && error.message,
          locationTypeId: data.location_type_id
        });
        toast.error(t("Toast.Error.DeliverPrescription.ServePrescription") + " " + error && error.message);
        this.setState({ loader: false });
      });
    }
  }

  removePhantomBin = (e) => {
    const { t } = this.props;
    e && e.preventDefault();
    const { pmid, stockCode, isPhantomStockCodePrompt } = this.state;
    const normalizedStockCode = (stockCode || '').trim();
    if (isPhantomStockCodePrompt && !normalizedStockCode) {
      toast.error('Please enter stock code');
      return;
    }
    if (!pmid) {
      toast.error('Unable to remove phantom bin. Prescription id is missing.');
      return;
    }
    console.log(`Order to be removed ${pmid}`);
    this.setState({ loader: true });
    fetch(`${process.env.REACT_APP_BASEURL}release/phantom`, {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user'))
            .signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prescriptionId: pmid, stockCode: normalizedStockCode }),
    }).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then((pbrr) => {
      console.log(JSON.stringify(pbrr, null, 2));
      if(pbrr && pbrr.data) {
        toast.success(t("Assign.PhantomBin.SuccessMessage"));
        this.ClearFields();
      }
      this.setState({
        loader: false,
        confirmPhantomRemoval: false,
        doesBinClicked: false,
        isPhantomStockCodePrompt: false,
      });
    }).catch((error) => {
      toast.error(t("Toast.Error.DeliverPrescription.ServePrescription") + " " + error && error.message);
      this.setState({
        loader: false,
        confirmPhantomRemoval: false,
        doesBinClicked: false,
        isPhantomStockCodePrompt: false,
      });
    });
  }

  setPermission = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    if(_checkUserRole === userroles.SUPERADMIN) {
      this.setState({ 
        isManualOverridePermissionEnabled: true, 
        prescriptionUnAssign: true, 
        prescriptionAssign: true, 
        prescriptionView: true,
        prescriptionDirectPickup: true,
        prescriptionRemind: true,
        prescriptionConsult: true,
        prescriptionHoldResume: true,
        prescriptionAcDc: true,
        printTicketPermissionAllowed: true 
      });
    } else {
      if (permissions && permissions.length > 0) {
        const manualOverride = permissions.filter((item) => {
          return item.permission_entity_type === "Manual Override"
        });
        const assignPrescriptions = permissions.filter((item) => {
          return item.permission_entity_type === "Assign Prescription"
        });

        if (manualOverride.length > 0) {
          this.setState({ isManualOverridePermissionEnabled: manualOverride.some((x) => x.name.trim() === 'Open Bin' && x.is_allowed === 1) })
        } else {
          this.setState({ isManualOverridePermissionEnabled: false });
        }

        if (assignPrescriptions.length > 0) {
          this.setState({
            prescriptionUnAssign: assignPrescriptions.some((x) => x.name.trim() === 'UnAssign' && x.is_allowed === 1),  // UnAssign
            prescriptionAssign: assignPrescriptions.some((x) => x.name.trim() === 'Assign' && x.is_allowed === 1),  // Assign
            prescriptionView: assignPrescriptions.some((x) => x.name.trim() === 'View' && x.is_allowed === 1), //View
            prescriptionRemind: assignPrescriptions.some((x) => x.name.trim() === 'Remind' && x.is_allowed === 1), //Remind
            prescriptionDirectPickup: assignPrescriptions.some((x) => x.name.trim() === 'Direct Pickup' && x.is_allowed === 1),  // Direct Pickup
            prescriptionConsult: assignPrescriptions.some((x) => x.name.trim() === 'Consult' && x.is_allowed === 1), //Consult
            prescriptionAcDc: assignPrescriptions.some((x) => x.name.trim() === 'Activate/DeActivate' && x.is_allowed === 1), // Activate/DeActivate
            prescriptionHoldResume: assignPrescriptions.some((x) => x.name.trim() === 'Hold/Resume' && x.is_allowed === 1), // Activate/DeActivate
            printTicketPermissionAllowed: assignPrescriptions.some((x) => x.name.trim() === 'Print Ticket' && x.is_allowed === 1), // Print Ticket
          })
        } else {
          this.setState({
            prescriptionUnAssign: false,
            prescriptionAssign: false,
            prescriptionView: false,
            prescriptionDirectPickup: false,
            prescriptionRemind: false,
            prescriptionConsult: false,
            prescriptionHoldResume: false,
            prescriptionAcDc: false,
            printTicketPermissionAllowed: false
          });
        }
      } else {
        this.setState({
          isManualOverridePermissionEnabled: false,
          prescriptionUnAssign: false,
          prescriptionAssign: false,
          prescriptionView: false,
          prescriptionDirectPickup: false,
          prescriptionRemind: false,
          prescriptionConsult: false,
          prescriptionHoldResume: false,
          prescriptionAcDc: false,
          printTicketPermissionAllowed: false
        });
      } 
    }
  }
  handleHL7KeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        lookupValue: searchedString,
        account_id: globalAccountConnection.id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'hl/orders/lookup', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedJson = JSON.parse(res);
          if (
            parsedJson &&
            parsedJson.status &&
            parsedJson.status.toLowerCase() === 'failed'
          ) {
            toast.error(parsedJson.error_message);
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.order_details;
          if (!prescriptionDetails) {
            toast.error(this.props.t('Toast.Error.RxFound'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          } else {
            let item = {
              ndcCode: prescriptionDetails.ndc,
              itemId: '',
              binId: '',
              rxNo: prescriptionDetails.rx_num,
              name: prescriptionDetails.name,
              description: '',
              image: '',
              potency: '',
              qty: prescriptionDetails.dispensed_qty,
              schedule: '',
              Amount: prescriptionDetails.amount_due,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: prescriptionDetails.amount_due,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: prescriptionDetails.expiry_date,
              isLoadingTrans: false,
              fillNumber: null,
              prescriptionNumber: null,
              ConsultRequire: false,
              IsReturnable: false,
              status: '',
              order_id: null,
              prescription_txn_id: null,
              is_controlled_substance: false
            };
            const existingItem = this.state.searchedItems;
            this.setState({ EmailID: patientDetails.EmailAddress, phone: patientDetails.phone });
            if (
              existingItem &&
              searchedRxItems &&
              searchedRxItems.length > 0
            ) {
              let isexist = searchedRxItems.findIndex(
                (x) => x.rxNo === searchedString
              );
              if (existingItem.PatientID === patientDetails.patient_id) {
                if (isexist < 0) {
                  searchedRxItems.push(item);
                  if (
                    patientDetails &&
                    patientDetails.patient_id &&
                    patientDetails.EmailAddress
                  ) {
                    this.checkADACompatible(
                      patientDetails.patient_id,
                      patientDetails.EmailAddress
                    );
                  }
                  this.getcustomerLocation(
                    patientDetails,
                    searchedRxItems,
                    'HL7'
                  );
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                  this.forceUpdate();
                } else {
                  toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                }
              } else {
                toast.error(this.props.t('Toast.Error.WrongPatient'));
                this.setState({
                  rxNumber: '',
                  loader: false,
                });
              }
            } else {
              searchedRxItems.push(item);
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'HL7'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
                loader: false,
              });
            }
          }
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  }

  handleHL7OnChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  }

  validateRxFillsForDRX = (items) => {
    let _validRxItemArray = [];
    let _inValidRxItemArray = [];
    let validatedRxFills = {};
    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        if (['Waiting Bin', 'Verify', 'Scan', 'Pre-Check'].includes(items[i].status)) {
          _validRxItemArray.push(items[i]);
        } else {
          _inValidRxItemArray.push(items[i]);
        }
      }
    }
    validatedRxFills.validRxItems = _validRxItemArray;
    validatedRxFills.inValidRxItems = _inValidRxItemArray;
    return validatedRxFills;
  };

  isRxExistInCartForDRX = async (searchedString, patientDetails, items) => {
    let _existingPrescriptionNumbers = [];
    let existingRxNo = searchedString;
    for (let si = 0; si < searchedRxItems.length; si++) {
      if (
        existingRxNo === searchedRxItems[si].rxNo.toString()
      ) {
        _existingPrescriptionNumbers.push(searchedRxItems[si].rxNo.toString());
      }
    }
    if (_existingPrescriptionNumbers.length > 0) {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The prescription ${_existingPrescriptionNumbers.join(
          ','
        )} is already exist in the cart!`,
      });
      return true;
    } else {
      let itemsdetail;
      let validRxScripts = this.validateRxFillsForDRX(items);
      if (
        validRxScripts &&
        validRxScripts.validRxItems &&
        validRxScripts.validRxItems.length > 0
      ) {
        itemsdetail = validRxScripts.validRxItems;
      } else {
        itemsdetail = validRxScripts.inValidRxItems;
      }
      for (let i = 0; i < itemsdetail.length; i++) {
        searchedRxItems.push(itemsdetail[i]);
      }
      this.checkADACompatible(
        patientDetails.patient_id,
        patientDetails.email
      );
      this.getcustomerLocation(patientDetails, itemsdetail, 'DRX');
      this.forceUpdate();
      this.setState({
        rxNumber: '',
        loader: false,
      });
    }
  };

  isSamePatientForDRX = (patientDetails) => {
    const { searchedItems } = this.state;
    if (searchedItems.PatientID === patientDetails.patient_id) {
      this.setState({
        EmailID: patientDetails.email,
        phone: patientDetails.phone,
      });
      return true;
    } else {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The scanned or entered prescription has different patient details. Please assign this prescription to any bin first then scan or enter another prescription!`,
      });
      return false;
    }
  };

  checkIfRxExistOrNotForDRX = async (rxTransactionNumber) => {
    let response = {};
    return fetch(
      process.env.REACT_APP_BASEURL +
      'drx/prescription/check/rxno-fillid/' +
      rxTransactionNumber,
      {
        method: 'get',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((checkResponse) => {
        if (checkResponse) {
          let parsedJsonResponse = JSON.parse(checkResponse);
          if (
            parsedJsonResponse &&
            parsedJsonResponse.res &&
            parsedJsonResponse.res.status === 200
          ) {
            response.error = parsedJsonResponse.res.message;
            response.result = true;
            return response;
          } else {
            response.error = '';
            response.result = false;
            return response;
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleDRXChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleDRXKeyDown = (event) => {
    this.setState({
      loader: true,
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: "",
      isEdit: false,
    });
    const { originalScannedScript } = this.state;
    let searchedString = originalScannedScript;
    let validItems = [];
    let items = [];
    let obj = {
      lookupValue: searchedString,
      accountId: this.state.accountDetails.id,
    };
    fetch(process.env.REACT_APP_BASEURL + "drx/prescription/lookup", {
      crossDomain: true,
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(async (res) => {
        let parsedJsonResponse = res;
        let parsedJson;
        if (parsedJsonResponse && parsedJsonResponse.status !== 200) {
          this.setState({
            loader: false,
            rxNumber: "",
            isEpicHasValidRx: false,
            isEpicHasValidRxMessage: `${parsedJsonResponse.message}`,
          });
          return;
        }
        parsedJson = parsedJsonResponse.data;
        let patientDetails = parsedJson.prescription.patient;
        let prescriptionDetails = parsedJson.prescription;
        if (prescriptionDetails.length <= 0) {
          toast.error(this.props.t("Toast.Error.Prescription"));
          this.setState({
            rxNumber: "",
            loader: false,
          });
          return;
        }
        if (searchedRxItems && searchedRxItems.length > 0) {
          const _isSamePatient = this.isSamePatientForDRX(patientDetails);
          if (_isSamePatient === true) {
            let _existingPrescriptionNumbers = [];
            let preacriptionNumber =
              prescriptionDetails.prescription_id;
            for (let si = 0; si < searchedRxItems.length; si++) {
              if (
                preacriptionNumber === searchedRxItems[si].prescription_id
              ) {
                _existingPrescriptionNumbers.push(preacriptionNumber);
              }
            }
            if (
              _existingPrescriptionNumbers &&
              _existingPrescriptionNumbers.length &&
              _existingPrescriptionNumbers.length > 0
            ) {
              this.setState({
                loader: false,
                rxNumber: "",
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers} are already exist in the cart!`,
              });
              return true;
            }
          }
        }
        let isconsultrequired = false;
        let isreturnable = false;
        let isControlledSubstance = false;
        if (
          prescriptionDetails.prescribed_item &&
          ![undefined, "undefined", null, "null", ""].includes(
            prescriptionDetails &&
            prescriptionDetails.prescribed_item &&
            prescriptionDetails.prescribed_item.dea_schedule
          )
        ) {
          const deaClass = prescriptionDetails.prescribed_item.dea_schedule;
          if (["2", "3", "4", "5", 2, 3, 4, 5].includes(deaClass)) {
            isControlledSubstance = true;
          }
        }
        this.setState({ is_controlled_substance: isControlledSubstance });
        for (let i = 0; i < prescriptionDetails.fills.length; i++) {
          let item = {
            ndcCode: prescriptionDetails.ndc,
            itemId: "",
            binId: "",
            rxNo: prescriptionDetails.prescription_id,
            name: prescriptionDetails.drug_name,
            description: prescriptionDetails.sig,
            image: "",
            potency: "",
            qty: prescriptionDetails.fills[i].dispensed_quantity,
            schedule: "",
            Amount: prescriptionDetails.fills[i].copay,
            taxPercentage: "",
            insuranceAmount: "",
            CoPayAmount: prescriptionDetails.fills[i].copay,
            PaidAmount: "",
            DueAmount: "",
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            strength: "",
            route: "",
            doseage_form: "",
            non_proprietary_name: "",
            ExpirationDate: prescriptionDetails.expiration_date,
            isLoadingTrans: false,
            fillNumber: prescriptionDetails.fills[i].id,
            prescriptionNumber: "",
            ConsultRequire: isconsultrequired,
            IsReturnable: isreturnable,
            status: prescriptionDetails.fills[i].status,
            is_controlled_substance: isControlledSubstance,
          };
          let rxTransactionNumber = `${prescriptionDetails.prescription_id}-${prescriptionDetails.fills[i].id}`;
          if (['Waiting Bin', 'Verify', 'Scan', 'Pre-Check'].includes(prescriptionDetails.fills[i].status)
          ) {
            let isRxTrasactionNumberExist = false
            isRxTrasactionNumberExist = await this.checkIfRxExistOrNotForDRX(
              rxTransactionNumber
            );
            if (
              isRxTrasactionNumberExist &&
              isRxTrasactionNumberExist.result === true
            ) {
              items.push(item);
              this.setState({
                loader: false,
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: "The Rx transaction has already been processed!",
              });
            } else {
              items.push(item);
              if (['Waiting Bin', 'Verify', 'Scan', 'Pre-Check'].includes(prescriptionDetails.fills[i].status)) {
                validItems.push(prescriptionDetails.fills[i]);
              }
              if (validItems.length > 0) {
                prescriptionDetails.fills[i] = validItems;
              }
            }
          } else {
            items.push(item);
          }
        }
        if (items && items.length === 0) {
          return;
        }
        if (searchedRxItems && searchedRxItems.length > 0) {
          const _isSamePatient = this.isSamePatientForDRX(patientDetails);
          if (_isSamePatient === true) {
            this.isRxExistInCartForDRX(searchedString, patientDetails, items);
          }
        } else {
          this.setState({
            EmailID: patientDetails.email,
            phone: patientDetails.phone,
          });
          let RxItems = this.validateRxFillsForDRX(items);
          if (
            RxItems &&
            RxItems.validRxItems &&
            RxItems.validRxItems.length > 0
          ) {
            searchedRxItems = RxItems.validRxItems;
          } else {
            searchedRxItems = RxItems.inValidRxItems;
            let errorArray = [];
            if (searchedRxItems && searchedRxItems.length > 0) {
              for (let invalid = 0; invalid < searchedRxItems.length; invalid++) {
                errorArray.push({ Status: searchedRxItems[invalid].status });
              }
              this.setState({
                loader: false,
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: `The status of the prescription
                  should be Waiting Bin, Verify, Scan, Pre-Check but the ${
                    errorArray && errorArray.length > 1
                      ? "statuses are"
                      : "status is"
                  } ${errorArray && errorArray.map((x) => x.Status).join(", ")}`,
              });
            }
          }
          this.checkADACompatible(
            patientDetails.patient_id,
            patientDetails.email
          );
          this.getcustomerLocation(patientDetails, searchedRxItems, "DRX");
          this.forceUpdate();
          this.setState({
            rxNumber: "",
            loader: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loader: false,
          rxNumber: "",
          isEpicHasValidRx: false,
          isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
        });
        return;
      });
  };

  fetchControlledSubstance = () => {
    if (searchedRxItems.length > 0) { 
      const _controlledSubstance = searchedRxItems.filter((item) => item.is_controlled_substance === (true || 'true'));
      if(_controlledSubstance.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  parseScannedQrCodeForVialLabelScan = async (scannedQR) => {
    const { t } = this.props;
    let _parsedResponse = {};
    if (scannedQR.startsWith('\\')) {
      const splittedRx = scannedQR.split('^');
      if(splittedRx.length > 0) {
        const actualRxNumber = splittedRx[0].substring(4, splittedRx[0].length);
        _parsedResponse.prescriptionNumber = actualRxNumber;
        _parsedResponse.pharmacyNCPDPId = null;
        _parsedResponse.fillId = splittedRx[1];
        _parsedResponse.is_coreFlex = false;  
      } else {
        toast.error(t('Toast.Error.RxNotValid'))
      }
    } else {
      const splittedRx = scannedQR.split('^');
      if(splittedRx.length > 0) {
        const actualRxNumber = splittedRx[0].substring(3, splittedRx[0].length);
        _parsedResponse.prescriptionNumber = actualRxNumber;
        _parsedResponse.pharmacyNCPDPId = null;
        _parsedResponse.fillId = splittedRx[1];
        _parsedResponse.is_coreFlex = false;  
      } else {
        toast.error(t('Toast.Error.RxNotValid'))
      }
    }
    console.log(
      `Parsed Response for EPIC script : ${JSON.stringify(
        _parsedResponse,
        null,
        2
      )}`
    );
    return _parsedResponse;
  };

  checkIfBinIsOccupedFromAnotherLocation = async (type) => {
    const { 
      box_id, 
      boxTypeId,
      locationtype_id
    } = this.state;
    
    // Get effective bin ID - if selectedBinId is add-on pattern, use it; otherwise use fastlaneBinId for Fastlane
    let effectiveBinId = await this.getSelectedBinsByType(type);
    const effectiveBoxId = box_id;
    
    // Skip collision check if bin is from add-on (letter+number pattern)
    if (effectiveBinId && this.isAddOnBin(effectiveBinId)) {
      console.log("🔶 Skipping collision check for add-on bin:", effectiveBinId);
      this.saveCustomerMaster(type);
      return;
    }
    
    // For Fastlane and FastlaneGoliath, skip collision check for non-Kiosk locations
    if(boxTypeId === BOX_TYPE.FASTLANE || boxTypeId === BOX_TYPE.FASTLANEGOLIATH) {
      if(locationtype_id !== LOCATION_TYPE.Kiosk) {
        console.log("No action required for other types of locations.");
        this.saveCustomerMaster(type);
        return;
      }
    }
    
    if(locationtype_id !== LOCATION_TYPE.Kiosk) {
      if([undefined, 'undefined', null, 'null', ""].includes(effectiveBinId)) {
        this.saveCustomerMaster(type);
        return;
      }
    }
    
    // For Fastlane and FastlaneGoliath, skip collision check (original Fastlane behavior)
    if((boxTypeId === BOX_TYPE.FASTLANE || boxTypeId === BOX_TYPE.FASTLANEGOLIATH) && locationtype_id === LOCATION_TYPE.Kiosk) {
      this.saveCustomerMaster(type);
      return;
    }
    
    console.log("🔶 Checking bin collision status for box_id:", effectiveBoxId, "bin_id:", effectiveBinId);
    fetch(process.env.REACT_APP_BASEURL + "api/v2/orders/bin/status", {
      crossDomain: true,
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({
        box_id: effectiveBoxId,
        bin_id: effectiveBinId,
      }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          console.log(
            `Preflight error while processing request ${error && error.message}`
          );
          return null;
        }
      })
      .then(async (res) => {
        console.log("🔶 Bin collision check response:", res);
        if (res && res.isOccupied === true) {
          console.log("🔶 Bin is occupied - showing error");
          toast.error(res.message);
          this.setState({ loader: false, isRetrying: false });
        } else {
          console.log("🔶 Bin is not occupied - proceeding to saveCustomerMaster");
          this.saveCustomerMaster(type);
        }
      })
      .catch((error) => {
        // Don't show error toast here - let saveCustomerMaster retry mechanism handle it
        // This prevents duplicate error dialogs when retrying
        console.error(`🔶 Bin status check failed: ${error && error.message}`);
        // Still proceed with save to let the retry mechanism work
        console.log("🔶 Proceeding to saveCustomerMaster despite error");
        this.saveCustomerMaster(type);
      });
  };

  handleChangeOrderNotes = (e) => {
    e.preventDefault();
    this.setState({
      assign_order_notes: e.target.value,
    })
  }


  // Helper function to check if a bin ID is from an add-on (letter+number format like "CC5", "DD12")
  isAddOnBin = (binId) => {
    if (!binId) return false;
    // Convert to string to handle both string and number inputs
    const binIdStr = String(binId).trim();
    // Add-on bins have letter+number format (e.g., "CC5", "DD12", "AA1", "BB4")
    // Fastlane bins are numeric (e.g., "76", "77", "1")
    const isAddOn = /^[A-Z]+\d+$/i.test(binIdStr); // Added 'i' flag for case-insensitive matching
    console.log('🔍 isAddOnBin check:', { binId, binIdStr, isAddOn });
    return isAddOn;
  }

  // Check if box has add-on expansions
  hasAddOnExpansions = () => {
    const { expansionUnits } = this.state;
    if (!expansionUnits || expansionUnits.length === 0) return false;
    // Check if there are any actual add-on units (not just Fastlane main unit)
    return expansionUnits.some(unit => unit.id && unit.id !== -1 && unit.pos !== 'FASTLANE');
  }


  handlePhoneChange = (e) => {
    this.setState({ phoneError: false })
    const { name, value } = e.target;

    let cleaned = value.replace(/\D/g, '');
    if (cleaned.length > 10) {
      cleaned = cleaned.slice(0, 10);
    }

    let formatted = cleaned;
    if (cleaned.length > 6) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length > 3) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else if (cleaned.length > 0) {
      formatted = `(${cleaned}`;
    }

    this.setState({ [name]: formatted });
  }

  handlePhoneBlur = () => {
    if (!this.state.isRxView) {
      this.generateCodes()
    }
  }
  
  handleDOBChange = (e) => {
    this.setState({ dobError: false });
    const { value } = e.target;
    let cleaned = value.replace(/\D/g, '');
    if (cleaned.length > 8) {
      cleaned = cleaned.slice(0, 8);
    }

    let formatted = cleaned;
    if (cleaned.length > 4) {
      formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4)}`;
    } else if (cleaned.length > 2) {
      formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
    }

    this.setState({ dateOfBirth: formatted });
  };

  handleRxChange = (index, event) => {
    const newEntries = [...this.state.rxEntries];
    newEntries[index].rxNumber = event.target.value;
    this.setState({ rxEntries: newEntries });
  };

  handleConsultChange = (index, event) => {
    const newEntries = [...this.state.rxEntries];
    newEntries[index].isConsultRequired = event.target.checked;
    this.setState({ rxEntries: newEntries });
  };

  handleAddRx = () => {
    this.setState((prevState) => ({
      rxEntries: [...prevState.rxEntries, { rxNumber: '', isConsultRequired: false }]
    }));
  };

  handleRemoveRx = (index) => {
    const newEntries = [...this.state.rxEntries];
    newEntries.splice(index, 1);
    this.setState({ rxEntries: newEntries });
  };

  handlePrintTicket = async () => {
    const puCode = this.state.reminderData &&
      this.state.reminderData.data &&
      this.state.reminderData.data.response &&
      this.state.reminderData.data.response.box &&
      this.state.reminderData.data.response.box.customers &&
      this.state.reminderData.data.response.box.customers[0] &&
      this.state.reminderData.data.response.box.customers[0].orders &&
      this.state.reminderData.data.response.box.customers[0].orders[0] &&
      this.state.reminderData.data.response.box.customers[0].orders[0].pucode;
    await this.getHtmlForPrint(puCode);
  }

  openPrintDialog = () => {
    this.setState({ openPrintDialog: true });
  }

  closePrintDialog = () => {
    this.setState({ openPrintDialog: false });
  }

  getHtmlForPrint = async (pucode) => {
    this.setState({ loader: true });
    fetch(
      process.env.REACT_APP_BASEURL + "printStockedItemEmailTemplate/" + pucode,
      {
        method: "GET",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => response.text())
      .then(async (res) => {
        this.setState({ htmlBodyToPrint: res, loader: false });
        await this.handlePrint();
      })
      .catch((err) => {
        this.setState({ loader: false });
        console.error(err)
      });
  }
    
  
  handlePrint = async () => {
    this.openPrintDialog();
    setTimeout(() => {
      window.print();
      this.closePrintDialog();
    }, 1500);
  };  
  handlePrimerxOnChange = (e) => {
    const scannedValue = e.target.value;
    const cleanedValue = String(scannedValue).replace(/^0+/, ""); 
    
    this.setState(
      {
        rxNumber: cleanedValue,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handlePrimerxKeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        lookupValue: searchedString,
        account_id: globalAccountConnection.account_id,
      };
      fetch(process.env.REACT_APP_BASEURL + "api/primerx/order/lookup", {
        crossDomain: true,
        method: "post",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedJson = JSON.parse(res);
          if (
            parsedJson &&
            parsedJson.status &&
            parsedJson.status.toLowerCase() === "failed"
          ) {
            toast.error(parsedJson.error_message);
            this.setState({
              rxNumber: "",
              loader: false,
            });
            return;
          }
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.order_details;
          if (
            [false, "false"].includes(
              patientDetails && patientDetails._isOrderFound
            )
          ) {
            toast.error("This order may not be deliverable.", {
              autoClose: 5000,
              progress: undefined,
              hideProgressBar: false,
            });
          }
          if (!prescriptionDetails) {
            toast.error(this.props.t("Toast.Error.RxFound"));
            this.setState({
              rxNumber: "",
              loader: false,
            });
            return;
          }
          let _localIsControlledSubstance = false;
          if(![undefined, 'undefined', null, 'null', ''].includes(prescriptionDetails.drug_class)) {
            if(["2", "3", "4", "5", 2, 3, 4, 5].includes(prescriptionDetails.drug_class)) {
              this.setState({ is_controlled_substance: true });
              _localIsControlledSubstance = true;
            } else {
              this.setState({ is_controlled_substance: false });
              _localIsControlledSubstance = false;
            }
          } else {
            this.setState({ is_controlled_substance: false });
            _localIsControlledSubstance = false;
          }
          let item = {
            ndcCode: prescriptionDetails.ndc,
            itemId: "",
            binId: "",
            rxNo: prescriptionDetails.rx_num,
            name: prescriptionDetails.name,
            description: "",
            image: "",
            potency: "",
            qty: prescriptionDetails.dispensed_qty,
            schedule: "",
            Amount: prescriptionDetails.amount_due,
            taxPercentage: "",
            insuranceAmount: "",
            CoPayAmount: prescriptionDetails.amount_due,
            PaidAmount: "",
            DueAmount: "",
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            strength: "",
            route: "",
            doseage_form: "",
            non_proprietary_name: "",
            ExpirationDate: prescriptionDetails.expiry_date,
            isLoadingTrans: false,
            fillNumber: prescriptionDetails.fill_number,
            prescriptionNumber: "",
            ConsultRequire:
              [true, "true"].includes(this.state.accountDetails.bypass_consult)
                ? false
                : ((prescriptionDetails && prescriptionDetails.fill_number === 0) ||
                   (prescriptionDetails && prescriptionDetails.fill_number === "0")),
            IsReturnable: false,
            status: "",
            order_id: parsedJson.order_id,
            prescription_txn_id: "",
            is_controlled_substance: _localIsControlledSubstance ? true : false,
          };
          const existingItem = this.state.searchedItems;
          this.setState({
            EmailID: patientDetails.EmailAddress,
            phone: patientDetails.phone,
          });
          if (existingItem && searchedRxItems && searchedRxItems.length > 0) {
            let isexist = searchedRxItems.findIndex(
              (x) => x.rxNo === searchedString
            );
            if (existingItem.PatientID === patientDetails.patient_id) {
              if (isexist < 0) {
                searchedRxItems.push(item);
                if (
                  patientDetails &&
                  patientDetails.patient_id &&
                  patientDetails.EmailAddress
                ) {
                  this.checkADACompatible(
                    patientDetails.patient_id,
                    patientDetails.EmailAddress
                  );
                }
                this.getcustomerLocation(
                  patientDetails,
                  searchedRxItems,
                  "PrimeRx"
                );
                this.setState({
                  rxNumber: "",
                  loader: false,
                });
                this.forceUpdate();
              } else {
                toast.error(this.props.t("Toast.Error.RxAddedToCart"));
                this.setState({
                  rxNumber: "",
                  loader: false,
                });
              }
            } else {
              toast.error(this.props.t("Toast.Error.WrongPatient"));
              this.setState({
                rxNumber: "",
                loader: false,
              });
            }
          } else {
            searchedRxItems.push(item);
            this.getcustomerLocation(patientDetails, searchedRxItems, "PrimeRx");
            this.forceUpdate();
            this.setState({
              rxNumber: "",
              loader: false,
            });
          }
        })
        .catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  handleLockToggle = async () => {
    const nextLockState = !this.state.isBinLocked;
  
    this.setState({ isBinLocked: nextLockState });
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BASEURL}bin-lock`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        },
        body: JSON.stringify({
          id: this.state.orderId,
          lockState: nextLockState,
        }),
      });
  
      const result = await response.json();
  
      if (!response.ok || !result.success) {
        throw new Error(result.message || "Failed to update lock state");
      }

      // Audit log: bin lock/unlock at root cause (after successful API response)
      // Description shows only P/U code and bin for professional display; order id is in metadata (User Details modal)
      const actionLabel = nextLockState ? "locked" : "unlocked";
      const pucode = this.state.pickupCode ? this.state.pickupCode : "—";
      const binId = this.state.selectedBinId ? this.state.selectedBinId : "—";
      const description = `Bin ${actionLabel} for P/U: ${pucode}, bin ${binId}.`;
      await writeAuditLog(
        description,
        "Bin Lock",
        {
          boxId: this.state.box_id,
          ...(this.state.orderId && { prescriptionMasterId: this.state.orderId })
        },
        {
          eventType: "BIN_LOCK",
          source: "PORTAL",
          severity: "INFO",
          metadata: {
            orderId: this.state.orderId,
            lockState: nextLockState,
            binId: this.state.selectedBinId || null,
            pucode: this.state.pickupCode || null
          }
        },
        { wait: false }
      );

      this.getAssignedBins(this.state.box_id);
      console.log("Lock state updated:", nextLockState);
    } catch (error) {
      console.error("Failed to update lock state", error);
  
      // Rollback UI on failure
      this.setState(prev => ({
        isBinLocked: !prev.isBinLocked,
      }));
    }
  };
  
  render() {
    const itemCount = this.shouldShowBasicUI() ? this.state.rxEntries && this.state.rxEntries[0].rxNumber.length : searchedRxItems && searchedRxItems.length;
    const Dateoptions = { year: 'numeric', month: 'numeric', day: 'numeric' }; // Define options for formatting the date
    const {
      searchedItems,
      selectedBinId,
      stockCode,
      pickupCode,
      selected,
      hasError,
      isAlreadyOnHold,
      isAlreadyAssigned,
      locationtype,
      is_stocked,
      order,
      orderBy,
      isManualOverrideOpen,
      locationtype_id,
      selectedBox,
      boxTypeId,
      accountDetails,
      isBinDeactivated,
      doesBinClicked,
      confirmPhantomRemoval,
      isPhantomStockCodePrompt,
      isManualOverridePermissionEnabled,
      prescriptionUnAssign,
      prescriptionAssign,
      prescriptionView,
      prescriptionDirectPickup,
      prescriptionRemind,
      prescriptionConsult,
      prescriptionHoldResume,
      prescriptionAcDc,
      assign_order_notes,
      consultCheckBoxFlagForRxByBin,
      printTicketPermissionAllowed,
      htmlBodyToPrint
    } = this.state;
    const canShowLockButton = isAlreadyOnHold || is_stocked;
    const { classes, t } = this.props;
    const localizer = momentLocalizer(moment);
    const disabledDatesStyle = (date, currentDate) => {
      if (date < currentDate) {
        return {
          className: 'disabled-date',
          style: {
            backgroundColor: '#e6e6e6',
            color: '#99999',
            pointerEvents: 'none',
          },
        };
      }
    };
    const isIlocalUser = localStorage.getItem('isIlocalUser');
    
    // Early return for Counter location type - completely different UI
    if (locationtype_id === LOCATION_TYPE.Counter) {
      const fallbackPatientEmail =
        (searchedItems &&
          (searchedItems.email ||
            searchedItems.EmailAddress ||
            searchedItems.EmailID ||
            searchedItems.emailAddress)) ||
        "";
      const fallbackPatientPhone =
        (searchedItems &&
          (searchedItems.phone ||
            searchedItems.sms_phone ||
            searchedItems.MobilePhone ||
            searchedItems.mobilePhone ||
            searchedItems.CellPhone ||
            searchedItems.cell_phone)) ||
        "";

      const patientEmailValue =
        this.state.EmailID !== undefined && this.state.EmailID !== null
          ? this.state.EmailID
          : fallbackPatientEmail;

      const rawPhoneValue =
        this.state.phone !== undefined && this.state.phone !== null
          ? this.state.phone
          : fallbackPatientPhone;
      const patientPhoneValue = this.formatUSPhoneNumber(rawPhoneValue);

      const patientEmailError = this.getEmailError(patientEmailValue);
      const patientPhoneError = this.getPhoneError(patientPhoneValue);

      return (
        <Box component='div'>
          <Paper className={classes.paperRoot}>
            {this.state.loader ? (
              <div className={classes.spinner}>
                <img
                  className={classes.spinnerImage}
                  src={spinner}
                  alt='loading'
                />
              </div>
            ) : null}
            
            {/* Shared dialogs that Counter UI might need */}
            <div id='react-no-print'>
              {/* Delete Confirmation Dialog */}
              <Dialog
                open={this.state.deleteDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogTitle id='alert-dialog-title'>
                  {'Are you sure you want to delete?'}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {t('Assign.AreYouSureToDelete')}
                    <ul>
                      {this.state.forDeletion &&
                        this.state.forDeletion.map(function (a) {
                          return <li>{a.name}</li>;
                        })}
                    </ul>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.deleteConfirmClose}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.CancelButton')}
                  </Button>
                  <Button
                    onClick={this.deleteConfirmed}
                    color='primary'
                    autoFocus
                    className={classes.primaryButton}
                  >
                    {t('Assign.DeleteButton')}
                  </Button>
                </DialogActions>
              </Dialog>
              
              {/* Manual Override Dialog */}
              {isManualOverrideOpen && (
                <PatientManulOverride
                  detailDialogOpen={isManualOverrideOpen}
                  selectedObject={{
                    binid: selectedBinId,
                    kiosk_box_id: selectedBox && selectedBox.kiosk_box_id,
                    pmid: this.state.pmid,
                    boxid: this.state.box_id,
                    pucode: this.state.pickupCode,
                  }}
                  onPopupClose={() =>
                    this.setState({ isManualOverrideOpen: false })
                  }
                  isPatientDetailsVisible={false}
                  isBoxDetailsVisible={false}
                  isManualOverrideVisible={true}
                  isManualConsultVisible={true}
                />
              )}
              
              {/* Verifying Bin Dialog */}
              <Dialog
                open={this.state.isVerifyingBin || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogTitle id='alert-dialog-title'>
                  {t('Assign.BinStatus')}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {this.state && this.state.isVerifyingBinMessage}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.confirmBinOkButton}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.OkayButton')}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Consult cancel reason dialog - when user unchecks required consultation */}
              <Dialog
                open={this.state.consultWaiveDialogOpen}
                onClose={this.handleConsultWaiveCancel}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                  sx: {
                    borderRadius: 3,
                    boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
                    overflow: "hidden",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    m: 0,
                    px: 3,
                    py: 2.5,
                    background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "1.15rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <InfoIcon sx={{ color: "#ffffff", fontSize: "1.5rem" }} />
                    <span>{t('Assign.ConsultWaive.Title')}</span>
                  </Box>
                  <IconButton
                    aria-label={t('Global.Close') || 'Close'}
                    onClick={this.handleConsultWaiveCancel}
                    sx={{
                      color: "#ffffff",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.18)",
                      },
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  sx={{
                    px: 3,
                    pt: 3,
                    pb: 2,
                    backgroundColor: "#f8fafc",
                  }}
                >
                  <DialogContentText
                    sx={{
                      color: "#475569",
                      fontSize: "0.95rem",
                      lineHeight: 1.6,
                      mb: 2,
                    }}
                  >
                    {t('Assign.ConsultWaive.ReasonPlaceholder')}
                  </DialogContentText>
                  <TextField
                    autoFocus
                    fullWidth
                    placeholder={t('Assign.ConsultWaive.ReasonPlaceholder')}
                    value={this.state.consultWaiveReason}
                    onChange={(e) => this.setState({ consultWaiveReason: e.target.value })}
                    multiline
                    minRows={2}
                    variant="outlined"
                    margin="dense"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#ffffff",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#7c3aed",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#7c3aed",
                          borderWidth: 2,
                        },
                      },
                    }}
                  />
                </DialogContent>
                <DialogActions
                  sx={{
                    px: 3,
                    py: 2,
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #e2e8f0",
                  }}
                >
                  <Button
                    onClick={this.handleConsultWaiveCancel}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      color: "#64748b",
                      px: 3,
                      "&:hover": {
                        backgroundColor: "#e2e8f0",
                      },
                    }}
                  >
                    {t('Assign.ConsultWaive.Cancel')}
                  </Button>
                  <Button
                    onClick={this.handleConsultWaiveConfirm}
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
                      boxShadow: "0 4px 14px 0 rgba(124, 58, 237, 0.3)",
                      px: 3,
                      py: 1,
                      borderRadius: 2,
                      "&:hover": {
                        background: "linear-gradient(135deg, #6d28d9 0%, #5b21b6 100%)",
                        boxShadow: "0 6px 20px 0 rgba(124, 58, 237, 0.4)",
                      },
                    }}
                  >
                    {t('Assign.ConsultWaive.Confirm')}
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            
            {/* Counter-specific UI */}
            <CounterAssignUI
              searchedRxItems={searchedRxItems}
              searchedItems={searchedItems}
              stockCode={stockCode}
              pickupCode={pickupCode}
              prescriptionAssign={prescriptionAssign}
              customerId={searchedItems && (searchedItems.customer_id || searchedItems.customerId || searchedItems.patient_id || searchedItems.PatientID)}
              prescriptionView={prescriptionView}
              prescriptionHoldResume={prescriptionHoldResume}
              printTicketPermissionAllowed={printTicketPermissionAllowed}
              isEpicHasValidRx={this.state.isEpicHasValidRx}
              isEpicHasValidRxMessage={this.state.isEpicHasValidRxMessage}
              rxNumber={this.state.rxNumber}
              patientFirstName={(searchedItems && searchedItems.first_name) || (searchedItems && searchedItems.FirstName) || ''}
              patientLastName={(searchedItems && searchedItems.last_name) || (searchedItems && searchedItems.LastName) || ''}
              patientEmail={patientEmailValue}
              patientEmailError={patientEmailError}
              patientPhone={patientPhoneValue}
              patientPhoneError={patientPhoneError}
              patientDOB={this.state.dateOfBirth || (searchedItems && (searchedItems.dateOfBirth || searchedItems.DateOfBirth || searchedItems.dob_str || searchedItems.DOB)) || ''}
              patientRecord={this.state.patientRecord || (searchedItems && (searchedItems.PatientRecordNumber || searchedItems.patientRecordNumber || searchedItems.patient_record_number || searchedItems.PatientID || searchedItems.patientID)) || ''}
              locationName={(selectedBox && selectedBox.name) || ''}
              locationTypeDisplay={getLocationTypeName(locationtype_id) || ''}
              addressLine1={(this.state.searchedItems && this.state.searchedItems.AddressLine1) || (selectedBox && selectedBox.address && selectedBox.address.address_line_1) || ''}
              addressLine2={(this.state.searchedItems && this.state.searchedItems.AddressLine2) || (selectedBox && selectedBox.address && selectedBox.address.address_line_2) || ''}
              city={(this.state.searchedItems && this.state.searchedItems.City) || (selectedBox && selectedBox.address && selectedBox.address.city) || ''}
              state={(this.state.searchedItems && this.state.searchedItems.State) || (selectedBox && selectedBox.address && selectedBox.address.state) || ''}
              zip={(this.state.searchedItems && this.state.searchedItems.Zip) || (selectedBox && selectedBox.address && selectedBox.address.zip) || ''}
              binAssignments={this.getBinAssignments()}
              orderTotal={this.getDueAmount()}
              binId={locationtype_id === LOCATION_TYPE.Counter ? (this.state.storage_location || '') : (this.state.selectedBinId || '')}
              onRxScan={(value) => this.onChange({ target: { value } })}
              onBinScan={(value) => this.getSelectedBin(value)}
              onBinIdChange={(value) => {
                // For Counter location type, update storage_location instead of selectedBinId
                if (locationtype_id === LOCATION_TYPE.Counter) {
                  this.setState({ storage_location: value });
                } else {
                  this.setState({ selectedBinId: value });
                }
              }}
              onLocationChange={(locationData) => {
                this.setState({ locationData: locationData });
                if (locationData && locationData.location) {
                  this.setState({ storage_location: locationData.location });
                } else if (!locationData) {
                  this.setState({ storage_location: '' });
                }
              }}
              onRxChange={(index, field, value) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  searchedRxItems[index][field] = value;
                  this.forceUpdate();
                }
              }}
              onQtyChange={(index, value) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  searchedRxItems[index].qty = value;
                  this.forceUpdate();
                }
              }}
              onPatientEmailChange={this.handlePatientEmailChange}
              onPatientPhoneChange={this.handlePatientPhoneChange}
              onAmountDueChange={(index, value) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  searchedRxItems[index].CoPayAmount = value;
                  this.forceUpdate();
                }
              }}
              onControlledSubstanceChange={(index, checked) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  searchedRxItems[index].is_controlled_substance = checked;
                  this.forceUpdate();
                }
              }}
              onConsultChange={(index, checked) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  const item = searchedRxItems[index];
                  const isCurrentlyRequired = item.ConsultRequire || item.is_consultrequire;
                  if (checked === false && isCurrentlyRequired) {
                    this.setState({
                      consultWaiveDialogOpen: true,
                      consultWaiveIndex: index,
                      consultWaiveReason: '',
                    });
                    return;
                  }
                  searchedRxItems[index].ConsultRequire = checked;
                  this.forceUpdate();
                }
              }}
              onRemoveItem={(index) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  searchedRxItems.splice(index, 1);
                  if (searchedRxItems.length === 0) {
                    this.ClearFields();
                  } else {
                    this.forceUpdate();
                  }
                }
              }}
              onAssign={() => {
                const type = 0;
                const { boxTypeId, locationtype_id } = this.state;
                // Simplified: proceed directly with assignment flow
                if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
                  this.checkIfFastlaneBinIdIsExistOrNot(type);
                } else {
                  this.checkIfBinIsOccupedFromAnotherLocation(type);
                }
              }}
              onAssignAndPrint={() => {
                const type = 1;
                const { boxTypeId, locationtype_id } = this.state;
                // Simplified: proceed directly with assignment flow
                if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
                  this.checkIfFastlaneBinIdIsExistOrNot(type);
                } else {
                  this.checkIfBinIsOccupedFromAnotherLocation(type);
                }
              }}
              onClear={() => this.ClearFields()}
              onToggleLoader={(loading) => this.setState({ loader: loading })}
              onOpenPrintDialogWithRxByBin={this.openPrintDialogFromRxByBin}
              currentBoxData={this.state.currentBoxData}
              accountDetails={this.state.accountDetails}
              courier_tracking={this.state.courier_tracking}
              default_courier_selected={this.state.default_courier_selected}
              locationtype_id={locationtype_id}
              locationtype={this.state.locationtype}
              onLocationTypeChange={this.handleLocationTypeChange}
              boxes={this.state.allBoxes}
              onCounterLocationChange={this.handleCounterLocationChange}
              onGetAccountConnection={this.GetAcccountConnectionId}
              boxDetails={this.state.boxDetails}
            />
          </Paper>

          
          {/* Print Label Functionality for Counter */}
          <Box component='div' id='Print_AssingPrescription_Label'>
            <PrintTemplate>
              <Dialog
                open={this.state.printDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                PaperProps={{
                  sx: { borderRadius: '0px', width: '255px', height: '500px' },
                }}
              >
                <DialogContent sx={{ p: '10px' }}>
                  <LabelTemplate
                    style={{ display: 'none' }}
                    stockCode={stockCode || ''}
                    pickupCode={pickupCode || ''}
                    rxNumbers={searchedRxNumbers || ''}
                    boxId={this.state.box_id || ''}
                    ref={(el) => (this.componentRef = el)}
                    accountDetails={this.state.accountDetails || ''}
                    pharmacyDetails={this.state.pharmacyDetails || ''}
                    firstName={this.state.PrintFirstName || ''}
                    lastName={this.state.PrintLastName || ''}
                    dateOfBirth={this.state.PrintDateOfBirth || ''}
                    isCoolItem={this.state.PrintisCoolItem || ''}
                    locationTypeID={this.state.locationtype_id || ''}
                    brandingName={this.state.BrandingName || ''}
                    brandingPhone={this.state.BrandingPhone || ''}
                    boxDetails={this.state.boxDetails}
                    connectionType={0}
                    t={t}
                    bin_id={this.state.binid}
                    rxEntries={this.state.rxEntries}
                    accountConnectionsId={this.state.accountConnectionsLoginId}
                    compactStockLabelLayout={true}
                  />
                </DialogContent>
              </Dialog>
            </PrintTemplate>
          </Box>
        </Box>
      );
    }
    // Default UI for all other location types
    return (
      <Box component='div'>
        <Paper className={classes.paperRoot}>
          {/* Tabs and Search Bar Row - At top of Paper, tabs left, search right */}
          {locationtype && locationtype.length > 1 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 0,
                gap: 2,
                width: '100%',
                px: 2,
                pt: 0,
              }}
            >
              <Box sx={{ flexShrink: 0 }}>
                <DeliveryTypeTabs
                  selectedLocationTypeId={locationtype_id}
                  onLocationTypeChange={this.handleLocationTypeChange}
                  locationtype={locationtype}
                  position="inline"
                />
              </Box>
              
              <Box sx={{ flexShrink: 0 }}>
                <TextField
                  id='idsearchtxt'
                  type='text'
                  margin='normal'
                  variant='standard'
                  value={this.state.searchObj.searchTxt}
                  label={t('Assign.Search')}
                  InputProps={{
                    inputProps: { autoComplete: 'off' },
                    form: {
                      autoComplete: 'off',
                    },
                    startAdornment: (
                      <InputAdornment position='start'>
                        <MagnifyIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={this.onSearchChange}
                  sx={{ width: '8cm' }}
                />
              </Box>
            </Box>
          )}
          
          {(!locationtype || locationtype.length === 0 || locationtype.length === 1) && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                mb: 0,
                width: '100%',
                px: 2,
                pt: 0,
              }}
            >
              <TextField
                id='idsearchtxt'
                type='text'
                margin='normal'
                variant='standard'
                value={this.state.searchObj.searchTxt}
                label={t('Assign.Search')}
                InputProps={{
                  inputProps: { autoComplete: 'off' },
                  form: {
                    autoComplete: 'off',
                  },
                  startAdornment: (
                    <InputAdornment position='start'>
                      <MagnifyIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={this.onSearchChange}
                sx={{ width: '8cm' }}
              />
            </Box>
          )}
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <div id='react-no-print'>
            <div id='react-no-print' className={classes.root}>
              <Dialog
                open={this.state.deleteDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogTitle id='alert-dialog-title'>
                  {'Are you sure you want to delete?'}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {t('Assign.AreYouSureToDelete')}
                    <ul>
                      {this.state.forDeletion &&
                        this.state.forDeletion.map(function (a) {
                          return <li>{a.name}</li>;
                        })}
                    </ul>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.deleteConfirmClose}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.CancelButton')}
                  </Button>
                  <Button
                    onClick={this.deleteConfirmed}
                    color='primary'
                    autoFocus
                    className={classes.primaryButton}
                  >
                    {t('Assign.DeleteButton')}
                  </Button>
                </DialogActions>
              </Dialog>
              {/* Consult cancel reason dialog (non-counter theme) - when user unchecks required consultation */}
              <Dialog
                open={this.state.consultWaiveDialogOpen || false}
                onClose={this.handleConsultWaiveCancel}
                aria-labelledby='consult-waive-dialog-title'
                aria-describedby='consult-waive-dialog-description'
                maxWidth='sm'
                fullWidth
              >
                <DialogTitle id='consult-waive-dialog-title' className={classes.dialogTitleColor}>
                  {t('Assign.ConsultWaive.Title')}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='consult-waive-dialog-description'>
                    {t('Assign.ConsultWaive.ReasonPlaceholder')}
                  </DialogContentText>
                  <TextField
                    autoFocus
                    fullWidth
                    margin='normal'
                    placeholder={t('Assign.ConsultWaive.ReasonPlaceholder')}
                    value={this.state.consultWaiveReason}
                    onChange={(e) => this.setState({ consultWaiveReason: e.target.value })}
                    multiline
                    minRows={2}
                    variant='outlined'
                    className={classes.textField}
                    inputProps={{
                      'aria-label': t('Assign.ConsultWaive.ReasonLabel') || 'Reason for waiving consultation',
                    }}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.handleConsultWaiveCancel}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.ConsultWaive.Cancel')}
                  </Button>
                  <Button
                    onClick={this.handleConsultWaiveConfirm}
                    color='primary'
                    className={classes.primaryButton}
                    autoFocus
                  >
                    {t('Assign.ConsultWaive.Confirm')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.SearchResultDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                fullWidth={true}
                PaperProps={{
                  style: { maxWidth: '1315px' },
                }}
              >
                <DialogContent>
                  {this.state.innerSearchLoader && (
                    <Box component='div' className={classes.spinner}>
                      <Box
                        component='img'
                        className={classes.spinnerImage}
                        src={spinner}
                        alt='loading'
                      />
                    </Box>
                  )}
                  <Table aria-labelledby='tableTitle'>
                    <TableHead>
                      <TableRow sx={{ height: '56px' }}>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.FirstName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.LastName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Email')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Phone')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Bin')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Status')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.StockCode')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.PUCode')}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(this.state.selectedObject) &&
                        this.state.selectedObject.length > 0 ? (
                        this.state &&
                        this.state.selectedObject.map((n) => {
                          return (
                            <TableRow>
                              <TableCell className={classes.tablebody}>
                                {n.first_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.last_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.email}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.phone}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.bin_id}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.status}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id,
                                      n.stock_code
                                    )
                                  }
                                >
                                  {n.stock_code}
                                </a>
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id,
                                      n.stock_code
                                    )
                                  }
                                >
                                  {n.pucode}
                                </a>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5}>
                            {t('Assign.NoDataFound')}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <ThemeProvider theme={localeTheme}>
                    <TablePagination
                      component='div'
                      count={this.state.totalSearchRecords || 0}
                      rowsPerPage={this.state.searchObj.pageSize}
                      page={this.state.searchObj.pageNo}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </ThemeProvider>
                </DialogContent>
                <DialogActions style={{ marginTop: '-20px' }}>
                  <Button
                    onClick={(e) => {
                      this.handleSearchClose(e);
                    }}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.Search.Close')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.showDatePopup || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                PaperProps={{
                  style: { maxWidth: '1315px' },
                }}
              >
                <DialogTitle id='alert-dialog-title'>
                  {'Set Future Release Date'}
                  <IconButton
                    onClick={() => { this.setState({ showDatePopup: false, FutureRelease: false }) }}
                    aria-label="Close"
                    style={{ position: 'absolute', padding: '0px', right: '20px', top: '20px' }}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Calendar
                    dayPropGetter={(date) => disabledDatesStyle(date, new Date())}
                    localizer={localizer}
                    selectable={true}
                    toolbar={true}
                    events={[]}
                    views={['month']}
                    startAccessor="start"
                    endAccessor="end"
                    onSelectSlot={this.handleFutureDateChange}
                    style={{ height: 500, width: 600 }}
                  />
                </DialogContent>
              </Dialog>
              <div id='react-no-print' className={classes.assignForm}>
                <div className={classes.main}>
                  <Table>
                    <TableBody>
                      {this.state && this.state.isEpicHasValidRx === false ? (
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            style={{ borderBottom: 'none', padding: 0 }}
                          >
                            <p
                              style={{
                                fontSize: '14px',
                                color: 'red',
                                paddingRight: '0px !important',
                              }}
                            >
                              {this.state && this.state.isEpicHasValidRxMessage}
                            </p>
                          </TableCell>
                        </TableRow>
                      ) : null}
                      <TableRow>
                        {!this.shouldShowBasicUI() && (
                          <React.Fragment>
                            <TableCell className={classes.layoutBorder}>
                              {this.renderScanRxBasedOnConnectionType(classes)}
                            </TableCell>
                            <TableCell
                              className={classes.layoutBorder}
                              style={{ width: '60%' }}
                            >
                              <TextField
                                id='PatientNotes'
                                type='text'
                                className={classes.textField}
                                margin='normal'
                                variant='standard'
                                label={t('Assign.PatientNotes')}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                  autoComplete: 'off',
                                  form: {
                                    autoComplete: 'off',
                                  },
                                }}
                                value={this.state.patientNotes || ''}
                                onChange={(e) =>
                                  !this.state.readOnly && this.setState({ patientNotes: e.target.value })
                                }
                                readOnly={this.state.readOnly}
                              />
                            </TableCell>
                          </React.Fragment>
                        )}
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
                {this.shouldShowBasicUI() ?
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={6} style={{ height: "100px" }}>
                          <TextField
                            id='phoneNo'
                            type='text'
                            className={classes.textField}
                            fullWidth
                            inputRef={this.phoneInputRef}
                            name='phone'
                            margin='normal'
                            variant='standard'
                            label={t('Assign.SMSPhone')}
                            onChange={this.handlePhoneChange}
                            onBlur={this.handlePhoneBlur}
                            InputLabelProps={{ shrink: true }}
                            value={this.state.phone}
                            inputProps={{
                              autoComplete: 'off',
                              maxLength: 14
                            }}
                            disabled={!prescriptionAssign}
                            readOnly={this.state.isRxView}
                            error={this.state.phoneError}
                            helperText={this.state.phoneError ? t('Validation.Phone') : ''}
                          />
                        </Grid>
                        <Grid item xs={6} style={{ height: "100px" }}>
                          <TextField
                            id="dateOfBirth"
                            type="text"
                            className={classes.textField}
                            margin="normal"
                            variant="standard"
                            label={t('Assign.DOB')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              maxLength: 10,
                            }}
                            disabled={!prescriptionAssign}
                            readOnly={this.state.isRxView}
                            value={this.state.dateOfBirth}
                            onChange={this.handleDOBChange}
                            error={this.state.dobError}
                            helperText={this.state.dobError ? t('Validation.DOB') : ''}
                          />

                        </Grid>
                        <Grid item xs={12} style={{ height: "432px" }}>
                          <div
                            style={{
                              maxHeight: '285px',
                              overflowY: this.state.rxEntries.length > 2 ? 'auto' : 'visible',
                              padding: '8px',
                              borderRadius: '4px',
                              border: "3px solid rgb(74, 107, 167)",
                              position: 'relative',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: '16px',
                                marginBottom: '12px',
                                fontWeight: 'bold',
                                color: '#555',
                                fontSize: '0.875rem',
                                borderBottom: '1px solid #ccc',
                                paddingBottom: '4px',
                                paddingLeft: '2px',
                                background: 'white',
                                position: 'sticky',
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              <div style={{ width: '40%' }}>{t('Home.StartConsultPopup.RxHash')}</div>
                              <div style={{ width: 'auto' }}>{t('Navbar.Consult')}</div>
                              <IconButton
                                disabled={this.state.isRxView}
                                onClick={this.handleAddRx}
                                color="primary"
                                style={{ marginLeft: 'auto' }}
                              >
                                <AddCircleOutlineRounded />
                              </IconButton>
                            </div>
                            {this.state.rxEntries.map((entry, index) => (
                              <div
                                key={index}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  gap: '16px',
                                  marginBottom: '12px',
                                }}
                              >
                                <TextField
                                  id={`rx-${index}`}
                                  type='text'
                                  className={classes.scantextField}
                                  value={entry.rxNumber}
                                  margin='normal'
                                  variant='standard'
                                  placeholder="Enter Rx"
                                  onChange={(e) => this.handleRxChange(index, e)}
                                  inputProps={{
                                    autoComplete: 'off',
                                    form: { autoComplete: 'off' },
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !this.state.isRxView) {
                                      this.handleAddRx();
                                    }
                                  }}
                                  style={{ width: '40%' }}
                                  disabled={!prescriptionAssign}
                                  readOnly={this.state.isRxView}
                                />
                                <Checkbox
                                  checked={entry.isConsultRequired}
                                  onChange={(e) => this.handleConsultChange(index, e)}
                                  color="primary"
                                  disabled={!prescriptionAssign}
                                  readOnly={this.state.isRxView}
                                />

                                {this.state.rxEntries && this.state.rxEntries.length > 1 && (
                                  <IconButton
                                    onClick={() => this.handleRemoveRx(index)}
                                    color="primary"
                                    style={{ marginLeft: 'auto' }}
                                    disabled={this.state.isRxView}
                                  >
                                    <RemoveCircleOutlineRounded />
                                  </IconButton>
                                )}
                              </div>
                            ))}
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor='location_type_id'
                            style={{ fontSize: '13px', marginTop: "8px" }}
                          >
                            {t('Assign.DeliveryType')}
                          </InputLabel>
                          <Select
                            style={{ marginTop: '5px' }}
                            fullWidth={true}
                            value={locationtype && locationtype.length > 0 && locationtype.some(t => t.id === this.state.locationtype_id) ? this.state.locationtype_id : ''}
                            onChange={this.handletypeChange}
                            inputProps={{
                              name: 'location_type_id',
                              id: 'location_type_ids',
                            }}
                            variant='standard'
                          >
                            {locationtype &&
                              locationtype.map((type, index) => (
                                <MenuItem
                                  key={index}
                                  value={type.id}
                                  selected
                                  className={classes.locationType}
                                >
                                  {type.label}
                                </MenuItem>
                              ))}
                          </Select>
                          {hasError && (
                            <FormHelperText className={classes.selectLable}>
                              Please select any type
                            </FormHelperText>
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <SearchableSelect
                            label={t('Assign.Location')}
                            items={this.state.boxItems || []}
                            value={this.state.box_id || ''}
                            onChange={this.handleChange}
                            placeholder="Search locations..."
                            id="select-location"
                            fullWidth={true}
                            sx={{ marginTop: '16px' }}
                            variant="standard"
                          />
                          {hasError && (
                            <FormHelperText className={classes.selectLable}>
                              Please select any box
                            </FormHelperText>
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            id='address1'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Address1')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={this.state.address && this.state.address.address1}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            id='address2'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Address2')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={this.state.address && this.state.address.address2}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            id='city'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.City')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={this.state.address && this.state.address.city}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            id='state'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.State')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={this.state.address && this.state.address.state}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            id='zip'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Zip')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={this.state.address && this.state.address.zip}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            id='bin'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.BIN')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={selectedBinId}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid> 
                  :
                  <div>
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='firstName'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.FirstName')}
                              fullWidth
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              InputLabelProps={{ shrink: true }}
                              value={
                                searchedItems &&
                                  searchedItems.FirstName &&
                                  searchedItems.FirstName !== null &&
                                  searchedItems.FirstName !== 'null'
                                  ? searchedItems.FirstName
                                  : ''
                              }
                            />
                          </TableCell>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='lastName'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.LastName')}
                              fullWidth
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              InputLabelProps={{ shrink: true }}
                              value={
                                searchedItems &&
                                  searchedItems.LastName &&
                                  searchedItems.LastName !== null &&
                                  searchedItems.LastName !== 'null'
                                  ? searchedItems.LastName
                                  : ''
                              }
                            />
                          </TableCell>
                          <TableCell className={classes.layoutBorder}>
                            <InputLabel
                              htmlFor='location_type_id'
                              style={{ fontSize: '13px' }}
                            >
                              {t('Assign.DeliveryType')}
                            </InputLabel>
                            <Select
                              style={{ marginTop: '5px' }}
                              fullWidth={true}
                              value={locationtype && locationtype.length > 0 && locationtype.some(t => t.id === this.state.locationtype_id) ? this.state.locationtype_id : ''}
                              onChange={this.handletypeChange}
                              inputProps={{
                                name: 'location_type_id',
                                id: 'location_type_ids',
                              }}
                              variant='standard'
                            >
                              {locationtype &&
                                locationtype.map((type, index) => (
                                  <MenuItem
                                    key={index}
                                    value={type.id}
                                    selected
                                    className={classes.locationType}
                                  >
                                    {type.label}
                                  </MenuItem>
                                ))}
                            </Select>
                            {hasError && (
                              <FormHelperText className={classes.selectLable}>
                                Please select any type
                              </FormHelperText>
                            )}
                          </TableCell>
                          <TableCell className={classes.layoutBorder}>
                            <SearchableSelect
                              label={t('Assign.Location')}
                              items={this.state.boxItems || []}
                              value={this.state.box_id || ''}
                              onChange={this.handleChange}
                              placeholder="Search locations..."
                              id="select-location-table"
                              fullWidth={true}
                              sx={{ marginTop: '5px' }}
                              variant="standard"
                            />
                            {hasError && (
                              <FormHelperText className={classes.selectLable}>
                                Please select any box
                              </FormHelperText>
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='email'
                              type='text'
                              className={classes.textField}
                              fullWidth
                              margin='normal'
                              variant='standard'
                              label={t('Assign.Email')}
                              name='EmailID'
                              onChange={this.onInputChange}
                              InputLabelProps={{ shrink: true }}
                              value={this.state.EmailID}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              disabled={!prescriptionAssign}
                            />
                          </TableCell>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='phoneNo'
                              type='text'
                              className={classes.textField}
                              fullWidth
                              margin='normal'
                              variant='standard'
                              label={t('Assign.SMSPhone')}
                              name='phone'
                              onChange={this.onInputChange}
                              InputLabelProps={{ shrink: true, maxLength: 10 }}
                              value={this.state.phone}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              disabled={!prescriptionAssign}
                            />
                          </TableCell>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='address1'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.Address1')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              value={
                                searchedItems &&
                                  searchedItems.AddressLine1 &&
                                  searchedItems.AddressLine1 !== null &&
                                  searchedItems.AddressLine1 !== 'null'
                                  ? searchedItems.AddressLine1
                                  : ''
                              }
                            />
                          </TableCell>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='address2'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.Address2')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              value={
                                searchedItems &&
                                  searchedItems.AddressLine2 &&
                                  searchedItems.AddressLine2 !== null &&
                                  searchedItems.AddressLine2 !== 'null'
                                  ? searchedItems.AddressLine2
                                  : ''
                              }
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='dateOfBirth'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.DOB')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              value={
                                searchedItems &&
                                  searchedItems.DateOfBirth &&
                                  searchedItems.DateOfBirth !== null &&
                                  searchedItems.DateOfBirth !== 'null'
                                  ? searchedItems.DateOfBirth
                                  : ''
                              }
                            />
                          </TableCell>
                          <TableCell style={{ border: 'none' }}>
                            <TextField
                              id='bin'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.BIN')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              value={this.state.showAddOnSelectionMode && this.state.selectedAddOnBinId ? this.state.selectedAddOnBinId : selectedBinId}
                              style={{ marginTop: '8.5%', marginLeft: '1%' }}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                            />
                          </TableCell>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='city'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.City')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              value={
                                searchedItems &&
                                  searchedItems.City &&
                                  searchedItems.City !== null &&
                                  searchedItems.City !== 'null'
                                  ? searchedItems.City
                                  : ''
                              }
                            />
                          </TableCell>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='state'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.State')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              value={
                                searchedItems &&
                                  searchedItems.State &&
                                  searchedItems.State !== null &&
                                  searchedItems.State !== 'null'
                                  ? searchedItems.State
                                  : ''
                              }
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='patient record number'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.PatientRecordNumber')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              value={this.BindPatientId()}
                            />
                          </TableCell>
                          {this.state.accountDetails.is_future_release ? <TableCell className={classes.layoutBorder}>
                            <InputLabel
                              htmlFor='FutureRelease'
                              style={{ fontSize: '13px' }}
                            >
                              {t('Assign.FutureRelease')}
                              {
                                this.state.FutureReleaseDate &&
                                this.state.FutureRelease &&
                                <span style={{
                                  marginLeft: "3px",
                                  color: "white",
                                  padding: "3px",
                                  fontSize: "10px",
                                  borderRadius: "5px",
                                  backgroundColor: "#00a7e1"
                                }}>
                                  {
                                    this.state.FutureReleaseDate.toLocaleDateString('en-US', Dateoptions)
                                  }
                                </span>
                              }
                            </InputLabel>
                            <Select
                              disabled={this.state.disableFeild}
                              style={{ marginTop: '5px' }}
                              fullWidth={true}
                              value={this.state.FutureRelease}
                              onChange={this.handleFutureChange}
                              inputProps={{
                                name: 'FutureRelease',
                                id: 'FutureRelease',
                                disabled: !prescriptionAssign
                              }}
                              variant='standard'
                            >
                              {
                                [{ label: "Yes", value: true }, { label: "No", value: false }].map((type, index) => (
                                  <MenuItem
                                    key={index}
                                    value={type.value}
                                    selected
                                    className={classes.locationType}
                                  >
                                    {type.label}
                                  </MenuItem>
                                ))}
                            </Select>
                            {hasError && (
                              <FormHelperText className={classes.selectLable}>
                                Please select any option
                              </FormHelperText>
                            )}
                          </TableCell> : null}

                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='zip'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.Zip')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              value={
                                searchedItems &&
                                  searchedItems.Zip &&
                                  searchedItems &&
                                  searchedItems.Zip !== null &&
                                  searchedItems &&
                                  searchedItems.Zip !== 'null'
                                  ? searchedItems.Zip
                                  : ''
                              }
                            />
                          </TableCell>
                          <TableCell className={classes.layoutBorder}>
                            <TextField
                              id='country'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Assign.Country')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                              value={
                                searchedItems &&
                                  searchedItems.Country &&
                                  searchedItems.Country !== null &&
                                  searchedItems.Country !== 'null'
                                  ? searchedItems.Country
                                  : ''
                              }
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={2} className={classes.layoutBorder}>
                            <TextField
                              id='orderNotes'
                              type='text'
                              className={classes.textField}
                              fullWidth
                              margin='normal'
                              variant='standard'
                              label={t('Unplugged.Courier.OrderNotes')}
                              name='orderNotes'
                              onChange={this.handleChangeOrderNotes}
                              InputLabelProps={{ shrink: true }}
                              value={assign_order_notes}
                              inputProps={{
                                autoComplete: 'off',
                                form: {
                                  autoComplete: 'off',
                                },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </div>}
                {!this.shouldShowBasicUI() && (
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>{t('Assign.AlternateContacts')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid item xs={12}>
                        <Button
                          style={{ marginLeft: '-1%', marginTop: '1%' }}
                          onClick={this.addAlterAgentRow}
                          color='primary'
                          disabled={this.state.readOnly}
                        >
                          {t(
                            'Patient.Preference.AddAlternateContactButton'
                          )}
                        </Button>
                        {this.createRowAlterAgent()}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {!this.shouldShowBasicUI() && (
                  <div className={classes.adjustDrugGrid}>
                    <EnhancedTableToolbar
                      numSelected={selected.length}
                      deleteItems={this.deleteItems}
                      confirmDelete={this.confirmDelete}
                    />
                    <div className={classes.handleOverflow}>
                      <Table
                        className={classes.table}
                        aria-labelledby='tableTitle'
                      >
                        <EnhancedTableHead
                          numSelected={selected.length}
                          onSelectAllClick={this.handleSelectAllClick}
                          rowCount={searchedRxItems ? searchedRxItems.length : 0}
                          isVisibleForPause={this.state.isVisibleForPause}
                          order={order}
                          orderBy={orderBy}
                          onRequestSort={this.handleRequestSort}
                          className={classes.tableCellLabel}
                        />
                        <TableBody>
                          {searchedRxItems.length === 0 ? (
                            <TableRow>
                              <TableCell
                                className={classes.emptyRowCell}
                                style={{ padding: '10px 0px' }}
                                colSpan='11'
                              >
                                {t('Assign.NoDataFound')}
                              </TableCell>
                            </TableRow>
                          ) : (
                            stableSort(
                              searchedRxItems,
                              getSorting(order, orderBy)
                            ).map((n, index) => {
                              let amount;
                              if (
                                n.price !== undefined &&
                                n.price !== null &&
                                n.price !== 'undefined' &&
                                n.price !== 'null' &&
                                n.price !== ''
                              ) {
                                amount = n.price;
                              } else if (
                                n.CoPayAmount !== undefined &&
                                n.CoPayAmount !== null &&
                                n.CoPayAmount !== 'undefined' &&
                                n.CoPayAmount !== 'null' &&
                                n.CoPayAmount !== ''
                              ) {
                                amount = n.CoPayAmount;
                              } else if (
                                n.amount_due !== undefined &&
                                n.amount_due !== null &&
                                n.amount_due !== 'undefined' &&
                                n.amount_due !== 'null' &&
                                n.amount_due !== ''
                              ) {
                                amount = n.amount_due;
                              } else {
                                amount = 0;
                              }
                              const isSelected = this.isSelected(
                                n.rxNo || n.rx_no
                              );
                              const _seqNumber = n.SeqNumber || n.seqnumber;
                              return (
                                <TableRow
                                  hover
                                  role='checkbox'
                                  aria-checked={isSelected}
                                  tabIndex={-1}
                                  key={`${n.rxNo || n.rx_no || n.id || index}-${index}`}
                                  selected={isSelected}
                                >
                                  {!this.state.isVisibleForPause && (
                                    <TableCell
                                      padding={'none'}
                                      onClick={(event) =>
                                        this.handleClick(event, n.rxNo || n.rx_no)
                                      }
                                    >
                                      <Checkbox checked={isSelected} />
                                    </TableCell>
                                  )}
                                  <TableCell
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, n.rxNo || n.rx_no)
                                    }
                                    style={{ fontSize: '0.70rem' }}
                                  >
                                    {accountDetails && accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS ? (n.rxNo || n.rx_no) : (n.rxNo || n.rx_no || n.id)}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, n.rxNo || n.rx_no)
                                    }
                                    sx={{ fontSize: '0.70rem' }}
                                  >
                                    {n.fillNumber || n.fillnumber}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: '140px' }}
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, n.rxNo || n.rx_no)
                                    }
                                    sx={{ fontSize: '0.70rem' }}
                                  >
                                    {n.prescriptionNumber ||
                                      n.prescriptionnumber ||
                                      ''}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: '140px' }}
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, n.rxNo || n.rx_no)
                                    }
                                    sx={{ fontSize: '0.70rem' }}
                                  >
                                    {n.order_id || ''}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: '140px' }}
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, n.rxNo || n.rx_no)
                                    }
                                  >
                                    {accountDetails && accountDetails.connection.id === CONNECTION_TYPE.QS1 ?
                                      n.isLoadingTrans === true ? (
                                        <img src={cl} alt='loader' width='36' />
                                      ) :
                                        <TextField
                                          sx={{
                                            width: '60px',
                                            mt: '7px',
                                            '.MuiInput-root': {
                                              fontSize: '0.80rem',
                                            },
                                          }}
                                          value={_seqNumber}
                                          variant='standard'
                                          onChange={(e) =>
                                            this.onHandleChangeInputValue(
                                              ![undefined, 'undefined', null, 'null', ''].includes(n.id) ? n.id : n.itemId,
                                              'seqNumber',
                                              e.target.value,
                                              n.rxNo || n.rx_no
                                            )
                                          }
                                          id='seqNumber'
                                        />
                                      : (n.prescription_txn_id || '')}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: '160px' }}
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, n.rxNo || n.rx_no)
                                    }
                                    sx={{ fontSize: '0.70rem' }}
                                  >
                                    {n.name || n.drug_name}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, n.rxNo || n.rx_no)
                                    }
                                    sx={{ fontSize: '0.70rem' }}
                                  >
                                    {n.isLoadingTrans === true ? (
                                      <img src={cl} alt='loader' width='36' />
                                    ) : (
                                      n.ndcCode || n.ndc_code
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, n.rxNo || n.rx_no)
                                    }
                                    sx={{ fontSize: '0.70rem' }}
                                  >
                                    {n.isLoadingTrans === true ? (
                                      <img src={cl} alt='loader' width='36' />
                                    ) : (
                                      n.qty
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    sx={{ fontSize: '0.70rem' }}
                                  >
                                    {n.isLoadingTrans === true ? (
                                      <img src={cl} alt='loader' width='36' />
                                    ) : (
                                      <div>
                                        <TextField
                                          sx={{
                                            width: '60px',
                                            mt: '7px',
                                            '.MuiInput-root': {
                                              fontSize: '0.80rem',
                                            },
                                          }}
                                          value={parseFloat(amount)}
                                          variant='standard'
                                          onChange={(e) =>
                                            this.onHandleChangeInputValue(
                                              ![undefined, 'undefined', null, 'null', ''].includes(n.id) ? n.id : n.itemId,
                                              'price',
                                              e.target.value,
                                              n.rxNo || n.rx_no
                                            )
                                          }
                                          id='price'
                                          InputProps={{
                                            inputComponent: NumberFormatCustom,
                                            autoComplete: 'new-password',
                                            form: {
                                              autoComplete: 'off',
                                            },
                                          }}
                                        />
                                        {this.state.isEdit === true &&
                                          this.state.isAmountPaid === false ? (
                                          this.state.indexNo === index ? (
                                            <React.Fragment>
                                              <Tooltip
                                                title={t('Assign.SaveTooltip')}
                                              >
                                                <IconButton
                                                  onClick={() =>
                                                    this.handleCloseDueAmountEditInput(
                                                      index,
                                                      n.id
                                                    )
                                                  }
                                                  className={
                                                    classes.onAmoutDueEditPrimaryButton
                                                  }
                                                >
                                                  <SaveIcon />
                                                </IconButton>
                                              </Tooltip>
                                            </React.Fragment>
                                          ) : (
                                            <Tooltip
                                              title={t('Assign.EditTooltip')}
                                            >
                                              <IconButton
                                                className={
                                                  classes.onAmoutDueEditPrimaryButton
                                                }
                                                onClick={() =>
                                                  this.handleOpenDueAmountEditInput(
                                                    index
                                                  )
                                                }
                                                sx={{ ml: '6%' }}
                                              >
                                                <EditIcon />
                                              </IconButton>
                                            </Tooltip>
                                          )
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    )}
                                  </TableCell>
                                  {this.state.accountDetails.bypass_consult ? (
                                    <TableCell className={classes.TableCell}>
                                      <Checkbox
                                        key={`consult-${n.rx_no || n.rxNo}-${this.state.consultWaiveDialogOpen}`}
                                        checked={!(n.ConsultRequire !== true && n.is_consultrequire !== true)}
                                        disabled={consultCheckBoxFlagForRxByBin}
                                        onChange={() =>
                                          this.handleConsultrequire(searchedRxItems.indexOf(n))
                                        }
                                        value={
                                          n.ConsultRequire || n.is_consultrequire
                                        }
                                        color="primary"
                                      />
                                    </TableCell>
                                  ) : (
                                    <TableCell
                                      className={classes.tableCell}
                                      sx={{ fontSize: '0.70rem' }}
                                    >
                                      {' '}
                                      {n &&
                                        n.is_order_released &&
                                        n.is_order_released === true ? (
                                        <div>
                                          <img
                                            src={checked}
                                            alt={n.rx_no}
                                            height={24}
                                            width={24}
                                          />
                                        </div>
                                      ) : (
                                        <div>
                                          {n.isLoadingTrans === true ? (
                                            <img
                                              src={cl}
                                              alt='loader'
                                              width='36'
                                            />
                                          ) : (
                                            <Checkbox
                                              key={`consult-${n.rx_no || n.rxNo}-${this.state.consultWaiveDialogOpen}`}
                                              checked={!(n.ConsultRequire !== true && n.is_consultrequire !== true)}
                                              onChange={() =>
                                                this.handleConsultrequire(searchedRxItems.indexOf(n))
                                              }
                                              value={
                                                n.ConsultRequire ||
                                                n.is_consultrequire
                                              }
                                              color='primary'
                                            />
                                          )}
                                        </div>
                                      )}
                                    </TableCell>
                                  )}
                                  <TableCell className={classes.tableCell} sx={{ fontSize: "0.70rem" }}>
                                    {" "}
                                    {n && n.is_order_released && n.is_order_released === true ? (
                                      <div>
                                        <img src={checked} alt={n.rx_no} height={24} width={24} />
                                      </div>
                                    ) : (
                                      <div>
                                        {n.isLoadingTrans === true ? (
                                          <img src={cl} alt="loader" width="36" />
                                        ) : (
                                          <Checkbox
                                            onChange={() => this.handleIsReturnable(index)}
                                            value={n.is_returnable || n.IsReturnable}
                                            checked={
                                              n.IsReturnable ||
                                              n.is_returnable
                                            }
                                            color="primary"
                                          />
                                        )}
                                      </div>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          )}
                        </TableBody>
                      </Table>
                    </div>
                    {this.state.isVisibleForPause ? (
                      <Table
                        aria-labelledby='tableTitle'
                      >
                        <TableBody>
                        <TableRow style={{ height: 40 }}>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            {t('Assign.Paid')}
                          </TableCell>
                          <TableCell style={{ textAlign: 'left' }}>
                            {this.state && this.state.isAmountPaid === true
                              ? this.getDueAmount()
                              : `$${(0).toFixed(2)}`}
                          </TableCell>
                        </TableRow>
                        <TableRow style={{ height: 40 }}>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            &nbsp;
                          </TableCell>
                          <TableCell className={classes.padiGridCell}>
                            {t('Assign.AmountDue')}
                          </TableCell>
                          <TableCell style={{ textAlign: 'left' }}>
                            {this.state && this.state.isAmountPaid === false
                              ? this.getDueAmount()
                              : `$${(0).toFixed(2)}`}
                          </TableCell>
                        </TableRow>
                        </TableBody>
                      </Table>
                    ) : (
                      <div></div>
                    )}
                  </div>
                )}
                <div className={classes.buttonContainer}>
                  {
                    printTicketPermissionAllowed ? (
                      <Button
                        type="button"
                        color="primary"
                        variant="contained"
                        className={classes.primaryButton}
                        onClick={this.handlePrintTicket}
                        disabled={
                          !Boolean(selectedBinId) ||
                          !(
                            // Check if reminderData, orders, and type_id exist and is_stocked is true
                            this.state.reminderData &&
                            this.state.reminderData.data &&
                            this.state.reminderData.data.response &&
                            this.state.reminderData.data.response.box &&
                            this.state.reminderData.data.response.box.customers &&
                            this.state.reminderData.data.response.box.customers[0] &&
                            this.state.reminderData.data.response.box.customers[0].orders &&
                            this.state.reminderData.data.response.box.customers[0].orders[0] &&
                            this.state.reminderData.data.response.box.customers[0].orders[0].type_id === assignmentstatus.STOCKED
                          )
                        }
                      >
                        {t("API.Roles.Permission.Assign.PrintTicket")}
                      </Button>
                    ) : null
                  }
                  &nbsp;
                  {prescriptionAcDc ? (
                    <Button
                      type='button'
                      color='primary'
                      variant='contained'
                      className={classes.primaryButton}
                      onClick={this.handleBinActivationChange}
                      disabled={!Boolean(selectedBinId)}
                    >
                      {isBinDeactivated ? t('Assign.Activate') : t('Assign.Deactivate')}
                    </Button>
                  ) : null}
                  {(is_stocked || isAlreadyAssigned || isAlreadyOnHold) && itemCount !== 0 ? (
                    <div>
                      &nbsp;
                      {prescriptionRemind ? (
                        <Button
                          type='button'
                          color='primary'
                          variant='contained'
                          className={classes.primaryButton}
                          onClick={() => this.reminderHandler()}
                        >
                          {t('Assign.RemindButton')}
                        </Button>
                      ) : null}
                      &nbsp;
                      {prescriptionConsult ? (
                        <Button
                          type='button'
                          color='primary'
                          variant='contained'
                          className={classes.primaryButton}
                          onClick={() => this.handleConsultClick()}
                        >
                          {t('Assign.ConsultButton')}
                        </Button>
                      ) : null}
                    </div>
                  ) : (
                    ''
                  )}
                  &nbsp;
                  {false && locationtype_id === LOCATION_TYPE.Kiosk &&
                    isManualOverridePermissionEnabled && (
                      <React.Fragment>
                        <Button
                          type='button'
                          color='primary'
                          variant='contained'
                          className={classes.primaryButton}
                          onClick={() =>
                            this.setState({ isManualOverrideOpen: true })
                          }
                        >
                          {t('Assign.OpenBinButton')}
                        </Button>
                        &nbsp;
                      </React.Fragment>
                    )}
                  <Button
                    type='button'
                    color='primary'
                    variant='contained'
                    className={classes.primaryButton}
                    disabled={
                      (itemCount === 0 ? true : false) ||
                      (this.state && this.state.isLoadingTrans === true)
                    }
                    onClick={() => this.ClearFields()}
                  >
                    {t('Assign.ClearButton')}
                  </Button>
                  &nbsp;
                  {[true, "true"].includes(isIlocalUser) ? (
                    <Button
                      type='button'
                      color='primary'
                      variant='contained'
                      className={classes.primaryButton}
                      disabled={!doesBinClicked}
                      onClick={() => this.setState({ confirmPhantomRemoval: true })}
                    >
                      {t('Assign.PhantomBin.Button')}
                    </Button>
                  ) : null}
                  &nbsp;
                  {!this.state.isVisibleForPause ? (
                    <div>
                      {prescriptionDirectPickup ? (
                        <Button
                          type='button'
                          color='primary'
                          variant='contained'
                          className={classes.primaryButton}
                          disabled={
                            (itemCount === 0 ? true : false) ||
                            (this.state && this.state.isLoadingTrans === true)
                          }
                          onClick={() => this.ManualPickupNotification(0)}
                        >
                          {t('Assign.DirectPickupButton')}
                        </Button>
                      ) : null}
                      &nbsp;
                      {prescriptionAssign === true ? (
                        <React.Fragment>
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            disabled={
                              (itemCount === 0 ? true : false) ||
                              (this.state && this.state.isLoadingTrans === true)
                            }
                            onClick={() => {
                              const type = 0;
                              const { boxTypeId, locationtype_id } = this.state;
                              // Simplified: proceed directly with assignment flow
                              if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
                                this.checkIfFastlaneBinIdIsExistOrNot(type);
                              } else {
                                this.checkIfBinIsOccupedFromAnotherLocation(type);
                              }
                            }}
                          >
                            {t('Assign.SaveButton')}
                          </Button>
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            disabled={
                              (itemCount === 0 ? true : false) ||
                              (this.state && this.state.isLoadingTrans === true)
                            }
                            onClick={() => {
                              const type = 1;
                              const { boxTypeId, locationtype_id } = this.state;
                              // Simplified: proceed directly with assignment flow
                              if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
                                this.checkIfFastlaneBinIdIsExistOrNot(type);
                              } else {
                                this.checkIfBinIsOccupedFromAnotherLocation(type);
                              }
                            }}
                          >
                            {t('Assign.SavePrintButton')}
                          </Button>
                        </React.Fragment>
                      ) : null}
                      
                    </div>
                  ) : (
                    <div>
                      {!isAlreadyOnHold ? (
                        <div>
                          {isAlreadyAssigned && (
                            <React.Fragment>
                              {prescriptionDirectPickup ? (
                                <Button
                                  type='button'
                                  color='primary'
                                  variant='contained'
                                  className={classes.primaryButton}
                                  disabled={
                                    (itemCount === 0 ? true : false) ||
                                    (this.state &&
                                      this.state.isLoadingTrans === true)
                                  }
                                  onClick={() => this.ManualPickupNotification(1)}
                                >
                                  {t('Assign.DirectPickupButton')}
                                </Button>
                              ) : null}
                              &nbsp;
                              {prescriptionUnAssign === true ? (
                                <Button
                                  type='button'
                                  color='primary'
                                  variant='contained'
                                  className={classes.primaryButton}
                                  onClick={() => this.changeOrderStatus('remove')}
                                  disabled={isAlreadyOnHold ? true : false}
                                >
                                  <i
                                    className={classes.pauseButton}
                                    style={{ margin: '2px' }}
                                  >
                                    remove
                                  </i>
                                </Button>
                              ) : null}
                            </React.Fragment>
                          )}
                          {prescriptionDirectPickup ? (
                            <React.Fragment>
                              {!isAlreadyAssigned && (
                                <Button
                                  type='button'
                                  color='primary'
                                  variant='contained'
                                  className={classes.primaryButton}
                                  disabled={
                                    (itemCount === 0 ? true : false) ||
                                    (this.state &&
                                      this.state.isLoadingTrans === true)
                                  }
                                  onClick={() => this.ManualPickupNotification(2)}
                                >
                                  {t('Assign.DirectPickupButton')}
                                </Button>
                              )}
                            </React.Fragment>
                          ) : null }
                          &nbsp;
                          {prescriptionHoldResume ? (
                            <Button
                              type='button'
                              color='primary'
                              variant='contained'
                              className={classes.primaryButton}
                              onClick={() => this.changeOrderStatus('pause')}
                              disabled={
                                isAlreadyOnHold || isAlreadyAssigned
                                  ? true
                                  : false
                              }
                            >
                              <i
                                className={classes.pauseButton}
                                style={{ margin: '2px' }}
                              >
                                pause
                              </i>
                            </Button>
                          ) : null}
                          
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.handlePrintReceipt()}
                            disabled={this.state.printLoading}
                          >
                            {t('Assign.PrintLabel')}
                          </Button>
                          &nbsp;
                        </div>
                      ) : (
                        <div>
                          {prescriptionDirectPickup ? (
                            <Button
                              type='button'
                              color='primary'
                              variant='contained'
                              className={classes.primaryButton}
                              disabled={
                                (itemCount === 0 ? true : false) ||
                                (this.state && this.state.isLoadingTrans === true)
                              }
                              onClick={() => this.ManualPickupNotification(3)}
                            >
                              {t('Assign.DirectPickupButton')}
                            </Button>
                          ) : null}
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.changeOrderStatus('play')}
                            disabled={!isAlreadyOnHold ? true : false}
                          >
                            <PlayArrow
                              className={classes.pauseButton}
                              style={{ margin: '2px' }}
                            />
                          </Button>
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.handlePrintReceipt()}
                            disabled={this.state.printLoading}
                          >
                            {t('Assign.PrintLabel')}
                          </Button>
                          &nbsp;
                        </div>
                      )}
                    </div>
                  )}
                  {canShowLockButton && (
                  <Tooltip
                    title={this.state.isBinLocked ? t("Assign.Unlock") : t("Assign.Lock")}
                    arrow
                    placement="top"
                  >
                    <span>
                      <Button
                        type="button"
                        color={this.state.isBinLocked ? "secondary" : "primary"}
                        variant="contained"
                        className={classes.primaryButton}
                        onClick={this.handleLockToggle}
                        sx={{ mx: 1 }}
                      >
                        {this.state.isBinLocked ? <LockIcon /> : <LockOpenIcon />}
                      </Button>
                    </span>
                  </Tooltip>
                  )}
                </div>
              </div>
              <div id='react-no-print' key='BoxLayout'>
                {this.state.locationtype_id === LOCATION_TYPE.Kiosk ? (
                  <React.Fragment>
                    <Grid container sx={{ m: '0px', mt: '2%' }}>
                      {/* Informational message when add-ons are connected */}
                      {this.hasAddOnExpansions() && boxTypeId === BOX_TYPE.FASTLANE && (
                        <Grid item xs={12} sx={{ mb: '16px' }}>
                          <Box
                            sx={{
                              backgroundColor: '#e3f2fd',
                              border: '2px solid #1976d2',
                              borderRadius: '8px',
                              padding: '12px 16px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px',
                              width: '98%'
                            }}
                          >
                            <InfoIcon sx={{ color: '#1976d2', fontSize: '24px', flexShrink: 0 }} />
                            <Typography sx={{ color: '#1976d2', fontWeight: 500, fontSize: '0.95rem', lineHeight: 1.5 }}>
                              {t('Assign.AddOnInfoMessage') || 'You can also assign this prescription to an add-on locker. Use pagination to switch between units and select a bin.'}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <Boxlayout
                          BinStatus={this.state.BinStatus}
                          deactivatedBins={this.state.deactivatedBins}
                          selectedBinId={this.state.selectedBinId}
                          expansionUnits={this.state.expansionUnits}
                          getPrescriptionDetails={this.getPrescriptionDetails}
                          getSelectedBin={this.getSelectedBin}
                          getSelectedUnitName={this.getSelectedUnitName}
                          currentTabIndex={this.state.expansionUnits.findIndex(
                            (x) => x.pos === 'M' || x.pos === 'M22' || x.pos === 'FASTLANE' || x.pos === 'M24' || x.pos === 'FASTLANEGOLIATH'
                          )}
                          isADACompatible={this.state.isADACompatible}
                          ADAData={this.state.ADAData}
                          PatientID={
                            this.state &&
                            this.state.searchedItems &&
                            this.state.searchedItems.PatientID
                          }
                          boxTypeId={this.state.boxTypeId}
                          t={t}
                          allowMultiBinsPickup={this.state.allow_multi_bins_pickup}
                          BoxID={this.state && this.state.box_id}
                          makeFastlaneAPICall={this.state.makeFastlaneAPICall}
                          selectedBox={selectedBox}
                          isViewPermissionAllowed={prescriptionView}
                          onBinPositionUpdate={this.handleFastlaneBinPositionUpdate}
                          columnMappings={this.state.currentBoxData && this.state.currentBoxData.column_mappings ? this.state.currentBoxData.column_mappings : []}
                          userGroupType={(() => {
                            const groupType = sessionStorage.getItem('groupType');
                            const result = groupType && groupType !== 'null' && groupType !== 'undefined' && groupType !== '' ? groupType : null;
                            return result;
                          })()}
                        />
                      </Grid>
                    </Grid>
                    {!(boxTypeId === BOX_TYPE.FASTLANE || boxTypeId === BOX_TYPE.FASTLANEGOLIATH) && <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <List sx={{ display: 'flex', flexDirection: 'row' }}>
                        {legend.map((value, index) => {
                          return (
                            <ListItem key={value.label || index} disablePadding sx={{ cursor: 'pointer', margin: '0 10px' }}>
                              <ListItemIcon>
                                <span style={{ background: value.color, height: '20px', width: '20px', border: '1px solid #888', borderRadius: '50%' }}>&nbsp;</span>
                              </ListItemIcon>
                              <ListItemText primary={value.label} />
                            </ListItem>
                          );
                        })}
                      </List>
                    </div>}
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12}>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell className={classes.TableHeadTop}>
                                <span style={{ color: '#a4a6a5' }}>
                                  {t("Unplugged.StockCode")}:
                                </span>
                                &nbsp;&nbsp; <span>{stockCode}</span>
                              </TableCell>
                              <TableCell className={classes.TableHeadTop}>
                                <span style={{ color: '#a4a6a5' }}>
                                  {t("Unplugged.PUCode")}:
                                </span>
                                &nbsp;&nbsp; <span>{pickupCode}</span>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                ) : this.state.locationtype_id === LOCATION_TYPE.Home ? (
                  <Box
                    component='div'
                    sx={{ height: '100%', width: '100%', textAlign: 'center' }}
                  >
                    <HomeIcon
                      style={{ height: '100%', width: '50%', color: '#0a5d66' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Work ? (
                  <Box
                    component='div'
                    sx={{ height: '100%', width: '100%', textAlign: 'center' }}
                  >
                    <WorkIcon
                      style={{ height: '100%', width: '50%', color: '#0a5d66' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Courier ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}
                  >
                    <img
                      src={courierIcon}
                      style={{ height: '30%', width: '50%', color: '#0a5d66' }}
                      alt='no-icon'
                    />
                    <Grid
                      container
                      spacing={2}
                      sx={{ pl: '0.5rem', pr: '0.5rem' }}
                    >
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}
                    >
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}
                    >
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.Courier')}
                        </label>
                        {this.state.courier_type &&
                          this.state.courier_type.length > 0
                          ? this.state.courier_type.map((val) => {
                            return (
                              <div>
                                <FormControlLabel
                                  label={
                                    <span style={{ color: '#000' }}>
                                      {val}
                                    </span>
                                  }
                                  control={
                                    <Checkbox
                                      value={val}
                                      color='primary'
                                      checked={
                                        this.state
                                          .default_courier_selected === val
                                      }
                                      onClick={() =>
                                        this.checkBoxHandler(val)
                                      }
                                    />
                                  }
                                />
                              </div>
                            );
                          })
                          : ''}
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.TrackingNumber')}
                        </label>
                        <br />
                        <input
                          type='text'
                          style={{
                            width: '100%',
                            borderRadius: '5px',
                            padding: '5px',
                            height: '45px',
                            fontSize: '15px',
                          }}
                          value={this.state.courier_tracking}
                          onChange={(evt) => this.courierTrackingHandler(evt)}
                          placeholder='Scan or Enter Tracking Number'
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ mt: '5%', mb: '2%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Other ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}
                  >
                    <OtherIcon
                      style={{ height: '100%', width: '50%', color: '#0a5d66' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Curbside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}
                  >
                    <img
                      src={curbsideIcon}
                      style={{
                        height: '35%',
                        width: '50%',
                        color: '#0a5d66',
                        marginBottom: '-10%',
                      }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ mt: '5%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Bedside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}
                  >
                    <img
                      src={inpatientIcon}
                      style={{ height: '30%', width: '50%', color: '#0a5d66' }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : (
                  ''
                )}
              </div>
              <div>
                <Dialog
                  maxWidth={'sm'}
                  open={this.state.openMessage}
                  keepMounted
                  onClose={this.handleClose}
                  aria-labelledby='alert-dialog-slide-title'
                  aria-describedby='alert-dialog-slide-description'
                >
                  <div className={classes.dialogBackground}>
                    <DialogTitle id='alert-dialog-title'>
                      <span className={classes.dialogTitleColor}>
                        {t('Assign.MessageText')}
                      </span>
                    </DialogTitle>
                    <DialogContent className={classes.dialogContentColor}>
                      {t('Assign.SelectBinToContinue')}
                    </DialogContent>
                    <DialogActions className={classes.alignButton}>
                      <Button
                        onClick={this.handleClose}
                        className={classes.buttonColor}
                      >
                        {t('Assign.OkButton')}
                      </Button>
                    </DialogActions>
                  </div>
                </Dialog>
              </div>
              {this.state.detailDialogOpen ? (
                <Manualconsultation
                  detailDialogOpen={this.state.detailDialogOpen}
                  selectedObject={this.state.searchedItems}
                  stockCode={stockCode}
                  pickupCode={pickupCode}
                  boxId={this.state.box_id}
                  accountDetails={this.state.accountDetails}
                  pharmacyDetails={this.state.pharmacyDetails}
                  onPopupClose={this.handleConsultClose}
                  searchedRxItems={searchedRxItems}
                />
              ) : null}
              {isManualOverrideOpen && (
                <PatientManulOverride
                  detailDialogOpen={isManualOverrideOpen}
                  selectedObject={{
                    binid: selectedBinId,
                    kiosk_box_id: selectedBox.kiosk_box_id,
                    pmid: this.state.pmid,
                    boxid: this.state.box_id,
                    pucode: this.state.pickupCode,
                  }}
                  onPopupClose={() =>
                    this.setState({ isManualOverrideOpen: false })
                  }
                  isPatientDetailsVisible={false}
                  isBoxDetailsVisible={false}
                  isManualOverrideVisible={true}
                  isManualConsultVisible={true}
                />
              )}
            </div>
          </div>
        </Paper>

        {/* Print Label Functionality  */}
        <Box component='div' id='Print_AssingPrescription_Label'>
          <PrintTemplate>
            <Dialog
              open={this.state.printDialogOpen || false}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
              PaperProps={{
                sx: { borderRadius: '0px', width: '255px', height: '500px' },
              }}
            >
              <DialogContent sx={{ p: '10px' }}>
                <LabelTemplate
                  style={{ display: 'none' }}
                  stockCode={stockCode || ''}
                  pickupCode={pickupCode || ''}
                  rxNumbers={searchedRxNumbers || ''}
                  boxId={this.state.box_id || ''}
                  ref={(el) => (this.componentRef = el)}
                  accountDetails={this.state.accountDetails || ''}
                  pharmacyDetails={this.state.pharmacyDetails || ''}
                  firstName={this.state.PrintFirstName || ''}
                  lastName={this.state.PrintLastName || ''}
                  dateOfBirth={this.state.PrintDateOfBirth || ''}
                  isCoolItem={this.state.PrintisCoolItem || ''}
                  locationTypeID={this.state.locationtype_id || ''}
                  brandingName={this.state.BrandingName || ''}
                  brandingPhone={this.state.BrandingPhone || ''}
                  boxDetails={this.state.boxDetails}
                  connectionType={0}
                  t={t}
                  bin_id={this.state.binid}
                  rxEntries={this.state.rxEntries}
                  accountConnectionsId={this.state.accountConnectionsLoginId}
                  compactStockLabelLayout={true}
                />
              </DialogContent>
            </Dialog>
          </PrintTemplate>
        </Box>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={this.state.isVerifyingBin || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Assign.BinStatus')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {this.state && this.state.isVerifyingBinMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.confirmBinOkButton}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.OkayButton')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={this.state.confirmPMSDialogOpen || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Assign.DoYouWantToContinue')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {t('Assign.DoYouWantToContinueText')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => this.handlePMSDialogYesEvent(e)}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.ManualConsult.Yes')}
              </Button>
              <Button
                onClick={this.handlePMSDialogNoEvent}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.ManualConsult.No')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={(boxTypeId === BOX_TYPE.FASTLANE) && (this.state.isFastlaneRetrying || false)}
            aria-labelledby='fastlane-retry-dialog-title'
            aria-describedby='fastlane-retry-dialog-description'
            disableEscapeKeyDown
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return false;
              }
            }}
            PaperProps={{
              style: { 
                minWidth: '400px'
              }
            }}
            BackdropProps={{
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)'
              }
            }}
          >
            <DialogTitle id='fastlane-retry-dialog-title' sx={{ textAlign: 'center', color: '#1976d2' }}>
              {t('Assign.Fastlane.RetryDialogTitle')}
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', pb: 3, pt: 2 }}>
              <Box component='div' sx={{ mb: 2 }}>
                <img
                  className={classes.spinnerImage}
                  src={spinner}
                  alt='loading'
                  style={{ width: '50px', height: '50px' }}
                />
              </Box>
              <DialogContentText id='fastlane-retry-dialog-description' sx={{ fontSize: '1rem', fontWeight: 600, color: '#000' }}>
                {this.state.fastlaneRetryMessage}
              </DialogContentText>
              <DialogContentText sx={{ mt: 1, fontSize: '0.875rem', color: '#666' }}>
                {t('Assign.Fastlane.RetryMessage')}
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={(boxTypeId === BOX_TYPE.FASTLANE) && (this.state.fastlaneBinFetchError || false)}
            aria-labelledby='fastlane-error-dialog-title'
            aria-describedby='fastlane-error-dialog-description'
            disableEscapeKeyDown
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return false;
              }
            }}
          >
            <DialogTitle id='fastlane-error-dialog-title' sx={{ color: '#d32f2f' }}>
              {t('Assign.Fastlane.ErrorDialogTitle')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='fastlane-error-dialog-description'>
                {t('Assign.Fastlane.ErrorMessage')}
              </DialogContentText>
              <DialogContentText sx={{ mt: 2, fontWeight: 500 }}>
                {t('Assign.Fastlane.ErrorQuestion')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleFastlaneBinErrorRetry}
                color='primary'
                className={classes.primaryButton}
                autoFocus
              >
                {t('Assign.Fastlane.TryAgainButton')}
              </Button>
              <Button
                onClick={() => this.setState({ fastlaneBinFetchError: false, pendingSaveMode: null })}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.CancelButton')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={(boxTypeId === BOX_TYPE.FASTLANE) && (this.state.fastlaneBinValidationError || false)}
            aria-labelledby='fastlane-validation-error-dialog-title'
            aria-describedby='fastlane-validation-error-dialog-description'
            disableEscapeKeyDown
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return false;
              }
            }}
          >
            <DialogTitle id='fastlane-validation-error-dialog-title' sx={{ color: '#d32f2f' }}>
              {t('Assign.Fastlane.ErrorDialogTitle')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='fastlane-validation-error-dialog-description'>
                {t('Assign.Fastlane.InvalidBinError')}
              </DialogContentText>
              <DialogContentText sx={{ mt: 2, fontWeight: 500 }}>
                {t('Assign.Fastlane.ValidationErrorMessage')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleFastlaneBinValidationErrorRetry}
                color='primary'
                className={classes.primaryButton}
                autoFocus
              >
                {t('Assign.OkayButton')}
              </Button>
              <Button
                onClick={() => this.setState({ fastlaneBinValidationError: false, pendingSaveMode: null })}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.CancelButton')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={(boxTypeId === BOX_TYPE.FASTLANE) && (this.state.fastlaneCollisionDialogOpen || false)}
            aria-labelledby='fastlane-collision-dialog-title'
            aria-describedby='fastlane-collision-dialog-description'
            disableEscapeKeyDown
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return false;
              }
            }}
          >
            <DialogTitle id='fastlane-collision-dialog-title' sx={{ color: '#d32f2f' }}>
              {t('Assign.Fastlane.CollisionTitle')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='fastlane-collision-dialog-description'>
                {t('Assign.Fastlane.CollisionMessage')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleFastlaneCollisionConfirm}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.YesButton') || 'Yes'}
              </Button>
              <Button
                onClick={this.handleFastlaneCollisionCancel}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.NoButton') || 'No'}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={confirmPhantomRemoval || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Assign.DoYouWantToContinue')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {t('Assign.PhantomBin.Confirmation')}
              </DialogContentText>
              {isPhantomStockCodePrompt ? (
                <TextField
                  fullWidth
                  margin='dense'
                  label={t('Assign.StockCode')}
                  value={stockCode || ''}
                  onChange={(event) =>
                    this.setState({ stockCode: event.target.value })
                  }
                />
              ) : null}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => this.removePhantomBin(e)}
                color='primary'
                className={classes.primaryButton}
                disabled={this.state.loader}
              >
                {t('Assign.ManualConsult.Yes')}
              </Button>
              <Button
                onClick={(e) =>
                  this.setState({
                    confirmPhantomRemoval: false,
                    isPhantomStockCodePrompt: false,
                  })
                }
                color='primary'
                className={classes.primaryButton}
                disabled={this.state.loader}
              >
                {t('Assign.ManualConsult.No')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='print-mount'>
           <PrintTemplate>
             <Dialog
               open={this.state.openPrintDialog}
               PaperProps={{
                 sx: { borderRadius: '0px', minWidth: '700px', minHeight: '500px' },
               }}
             >
               <DialogContent sx={{ p: '10px' }}>
                 <div
                   dangerouslySetInnerHTML={{ __html: htmlBodyToPrint }}
                 ></div>
               </DialogContent>
             </Dialog>
           </PrintTemplate>
        </div>
      </Box>
    );
  }
}

export default withStyles(styles)(withTranslation()(AssignPrescriptions));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/index.js